
const localeData = {
  "bg": {
    "timeRecorded": "Времето ви е записано!",
    "dailyNonogramFor": "Ежедневна нонограма за",
    "privacyPolicy": "Политика за поверителност",
    "termsOfService": "Общи условия",
    "account": "Сметка",
    "username": "Потребител",
    "password": "парола",
    "oldPassword": "Стара парола",
    "loading": "Зареждане",
    "login": "Влизам",
    "noAccount": "Нямате профил?",
    "createAccount": "Регистрирайте се тук",
    "required": "длъжен",
    "loggedIn": "Влезли сте в системата!",
    "logout": "Излез от профила си",
    "loggedOut": "Вече сте излезли",
    "returnToPuzzles": "Върни се към пъзелите",
    "changePassword": "Промяна на паролата",
    "settings": "Настройки",
    "settingsUpdated": "Настройките обновени",
    "register": "Регистрирам",
    "forgotYourPassword": "Забравена парола?",
    "resetPassword": "Променете паролата си",
    "email": "електронна поща",
    "confirmPassword": "Потвърди парола",
    "passwordUpdated": "Актуализирана парола",
    "passwordsMustMatch": "паролите трябва да съвпадат",
    "haveAnAccount": "Вече имате профил?",
    "ajaxError": "Имаше проблем. Опитайте отново по-късно",
    "language": "език",
    "size": "размер",
    "save": "Запази",
    "invalidEmail": "Въведете валиден имейл",
    "sendingEmail": "Изпращане на имейл",
    "resetEmailSent": "Проверете електронната си поща за връзката, за да зададете нова парола.",
    "ad": "реклама",
    "nonogramPuzzle": "Nonogram Puzzle",
    "goodLuck": "Късмет!",
    "errorFound": "Намерени грешки",
    "correct": "Правилно !!",
    "startOver": "Започни отначало",
    "showCorrect": "Показване на правилните редове/колони",
    "checkIt": "Провери го",
    "newNonogram": "Нов Nonogram",
    "topTimesFor": "Големи времена за {size} x {size}",
    "noTimes": "Няма време за показване",
    "user": "потребител",
    "time": "път",
    "puzzle": "пъзели",
    "nonogramSizes": "Неразмерни размери",
    "contactMe": "Свържи се с мен",
    "howToSolve": "Как да решим",
    "topTimes": "Top Times",
    "languages": "Езици",
    "yourName": "Твоето име",
    "yourEmail": "Твоят имейл",
    "message": "съобщение",
    "sendingMessage": "Изпращане на съобщение",
    "sendMessage": "Изпрати съобщение",
    "sentMessage": "Съобщението е изпратено",
    "bulgarian": "български",
    "czech": "чешки",
    "danish": "датски",
    "german": "Немски",
    "greek": "Гръцки",
    "english": "Английски",
    "spanish": "испански",
    "estonian": "естонски",
    "finnish": "фински",
    "french": "Френски",
    "hebrew": "иврит",
    "croatian": "хърватски",
    "hungarian": "унгарски",
    "italian": "Италиански",
    "japanese": "японски",
    "korean": "корейски",
    "norwegian": "норвежки",
    "dutch": "холандски",
    "polish": "полски",
    "portuguese": "португалски",
    "romanian": "румънски",
    "russian": "Руски",
    "slovak": "словашки",
    "slovenian": "словенски",
    "serbian": "сръбски",
    "swedish": "шведски",
    "turkish": "Турски",
    "vietnamese": "виетнамски",
    "chinese": "Китайски",
    "howToSolveNonogram": "Как да решим Nonogram",
    "objective": "Обективен",
    "nonoObjective": "Целта на играта е да запълни мрежата с черни квадрати, така че броят на запълнените последователни квадрати да съответства на номерата в горната част и вляво.",
    "controls": "Контроли",
    "nonoControlsLeft": "Кликнете с левия бутон, за да маркирате квадрат като (черен) или неизвестен (бял).",
    "nonoControlsRight": "Кликнете с десния бутон, за да маркирате квадрат като изключен (червен X) или неизвестен (бял).",
    "nonoControlsTouch": "Докоснете, за да превъртите квадратично (черно), изключено (червено X) или неизвестно (бяло).",
    "nonoControlsDrag": "Плъзгането работи за всичките три по-горе.",
    "freecell": "Freecell",
    "metaDescription": "Нонограми онлайн. Над 500 000 пъзела на 29 езика.",
    "metaKeywords": "nonogram, nonograms, картина, пъзел, griddlers, griddler, picross",
    "mobileApps": "Мобилни приложения",
    "dailyArchive": "Архив",
    "day": "Ден",
    "fastestTime": "Най-бързо време",
    "name": "Име",
    "created": "Създадено",
    "markAsRead": "Маркирай като прочетено",
    "dontMissTodaysPuzzle": "Не пропускайте днешния пъзел!",
    "playToday": "Играй днес",
    "dismiss": "Отхвърляне",
    "neverShowAgain": "Никога повече не се показвай",
    "tipsAndTricks": "Съвети и трикове за решаване на нонограми",
    "startWithTheObvious": "Започнете с очевидното",
    "focusOnRowsOrColumns": "Фокусирайте се върху редове или колони, където уликите почти запълват целия ред.",
    "useBothDirections": "Използвайте и двете посоки",
    "progressInOneDirection": "Напредъкът в едната посока често помага за отключване на логиката в другата.",
    "markYourEmptySpaces": "Маркирайте празните си места",
    "useARedX": "Използвайте червен „X“ върху потвърдените празни квадратчета, за да останете организирани.",
    "countCarefully": "Бройте внимателно",
    "separateNumbersMeanDifferentGroups": "Отделните числа означават различни групи с поне едно разстояние между тях.",
    "largeNumberClues": "Обработете краищата",
    "largeNumberCluesDescription": "Големият брой улики може да е подходящ само по ограничен начин – използвайте това във ваша полза.",
    "stayOrganized": "Останете организирани",
    "stayOrganizedDescription": "Сканирайте често мрежата; напредъкът в една област може да разкрие улики в други.",
    "dontGuess": "Не гадай",
    "dontGuessDescription": "Придържайте се към логиката – избягвайте метода проба-грешка, когато е възможно.",
    "howToSolveNonogramDescription": "Нонограмите са пъзели, базирани на логика, при които попълвате квадратчета в мрежа, използвайки улики, предоставени за всеки ред и колона. Тези улики са числа, които ви казват колко запълнени блокчета има в този ред и в какъв ред. Например, улика „4 1“ означава, че има четири запълнени квадратчета, последвани от едно запълнено квадратче, с поне едно празно място между групите. Вашата цел е да разберете къде отиват тези запълнени блокчета, като приложите логическо разсъждение и вземете предвид както хоризонталните, така и вертикалните улики заедно.",
    "howToSolveNonogramInstructions": "За да започнете да решавате, потърсете редове или колони, където уликите заемат голяма част от реда, тъй като те обикновено са най-лесни за попълване първо. С напредването си използвайте наученото, за да актуализирате други редове и колони. Пространствата, които определено са празни, трябва да бъдат маркирани с червен „X“, за да се избегнат грешки и да се изяснят останалите ви опции. Постепенно, като попълвате потвърдени квадратчета и маркирате празни, ще се придвижите към завършена и последователна мрежа.",
    "darkMode": "Тъмен режим",
    "lightMode": "Светлинен режим",
    "todaysPuzzle": "Днешният пъзел",
    "playNow": "Играй сега",
    "contactMessages": "Съобщения",
    "dailyPuzzleArchive": "Дневен архив на пъзелите",
    "previous": "Предишен",
    "next": "Следващо",
    "noPuzzlesFound": "Няма намерени ежедневни пъзели за този месец.",
    "nonogram": "Нонограма",
    "sudoku": "Судоку",
    "playSudokuDailyToday": "Играйте Судоку Дейли още днес!",
    "playNonogramDailyToday": "Играйте Nonogram Daily още днес!"
  },
  "cs": {
    "timeRecorded": "Váš čas byl zaznamenán!",
    "dailyNonogramFor": "Denní nonogram pro",
    "privacyPolicy": "Zásady ochrany osobních údajů",
    "termsOfService": "Podmínky služby",
    "account": "Účet",
    "username": "Uživatelské jméno",
    "password": "Heslo",
    "oldPassword": "Staré heslo",
    "loading": "načítání",
    "login": "Přihlásit se",
    "noAccount": "Nemáte účet?",
    "createAccount": "Registrujte se zde",
    "required": "Povinný",
    "loggedIn": "Jste přihlášeni!",
    "logout": "Odhlásit se",
    "loggedOut": "Nyní jste odhlášeni",
    "returnToPuzzles": "Vraťte se k hádankám",
    "changePassword": "Změnit heslo",
    "settings": "Nastavení",
    "settingsUpdated": "Nastavení aktualizováno",
    "register": "Registrovat",
    "forgotYourPassword": "Zapomněli jste heslo?",
    "resetPassword": "Obnovit heslo",
    "email": "E-mailem",
    "confirmPassword": "Potvrďte heslo",
    "passwordUpdated": "Aktualizováno heslo",
    "passwordsMustMatch": "Heslo se musí shodovat",
    "haveAnAccount": "Máte již účet?",
    "ajaxError": "Nastal problém. Zkuste to později znovu",
    "language": "Jazyk",
    "size": "Velikost",
    "save": "Uložit",
    "invalidEmail": "Zadejte platný e-mail",
    "sendingEmail": "Odesílání e-mailů",
    "resetEmailSent": "Ověřte svůj e-mail pro odkaz a obnovte heslo.",
    "ad": "reklama",
    "nonogramPuzzle": "Nonogram Puzzle",
    "goodLuck": "Hodně štěstí!",
    "errorFound": "Byly nalezeny chyby",
    "correct": "Opravit!!",
    "startOver": "Začít znovu",
    "showCorrect": "Zobrazit správné řádky/sloupce",
    "checkIt": "Zkontroluj to",
    "newNonogram": "Nový nonogram",
    "topTimesFor": "Nejvyšší časy pro {size} x {size}",
    "noTimes": "Žádné časy, které by se ukázaly",
    "user": "Uživatel",
    "time": "Čas",
    "puzzle": "Hádanka",
    "nonogramSizes": "Nonogram velikosti",
    "contactMe": "Kontaktujte mě",
    "howToSolve": "Jak vyřešit",
    "topTimes": "Nejvyšší časy",
    "languages": "Jazyky",
    "yourName": "Tvé jméno",
    "yourEmail": "Tvůj e-mail",
    "message": "Zpráva",
    "sendingMessage": "Odeslání zprávy",
    "sendMessage": "Poslat zprávu",
    "sentMessage": "Zpráva odeslána",
    "bulgarian": "bulharština",
    "czech": "čeština",
    "danish": "dánský",
    "german": "Němec",
    "greek": "řecký",
    "english": "Angličtina",
    "spanish": "španělština",
    "estonian": "estonština",
    "finnish": "Finština",
    "french": "francouzština",
    "hebrew": "hebrejština",
    "croatian": "chorvatský",
    "hungarian": "maďarský",
    "italian": "italština",
    "japanese": "japonský",
    "korean": "korejština",
    "norwegian": "Norština",
    "dutch": "holandský",
    "polish": "polština",
    "portuguese": "portugalština",
    "romanian": "rumunština",
    "russian": "ruština",
    "slovak": "Slovák",
    "slovenian": "slovinský",
    "serbian": "srbština",
    "swedish": "švédský",
    "turkish": "turečtina",
    "vietnamese": "vietnamština",
    "chinese": "čínština",
    "howToSolveNonogram": "Jak vyřešit Nonogram",
    "objective": "Objektivní",
    "nonoObjective": "Cílem hry je vyplnit mřížku s černými čtverci tak, aby čísla vyplněných sekvenčních čtverců odpovídala číslům v horní a vlevo.",
    "controls": "Řízení",
    "nonoControlsLeft": "Klepnutím levým tlačítkem označte čtverec jako (černý) nebo neznámý (bílý).",
    "nonoControlsRight": "Klepnutím pravým tlačítkem označte čtverec jako vypnutý (červený X) nebo neznámý (bílý).",
    "nonoControlsTouch": "Dotkněte se, chcete-li vykreslit čtvereček jako na (černé), vypnout (červená X) nebo neznámé (bílé).",
    "nonoControlsDrag": "Tažení funguje pro všechny tři výše uvedené.",
    "freecell": "Freecell",
    "metaDescription": "Nonogramy online. Více než 500 000 hádanek v 29 jazycích.",
    "metaKeywords": "nonogram, nonograms, picture, puzzle, griddlers, griddler, picross",
    "mobileApps": "Mobilní aplikace",
    "dailyArchive": "Archiv",
    "day": "Den",
    "fastestTime": "Nejrychlejší čas",
    "name": "Jméno",
    "created": "Vytvořeno",
    "markAsRead": "Označit jako přečtené",
    "dontMissTodaysPuzzle": "Nenechte si ujít dnešní hádanku!",
    "playToday": "Hrajte ještě dnes",
    "dismiss": "Propustit",
    "neverShowAgain": "Už nikdy nezobrazovat",
    "tipsAndTricks": "Tipy a triky pro řešení nonogramů",
    "startWithTheObvious": "Začněte s tím zřejmým",
    "focusOnRowsOrColumns": "Zaměřte se na řádky nebo sloupce, kde nápovědy téměř vyplňují celý řádek.",
    "useBothDirections": "Použijte oba směry",
    "progressInOneDirection": "Pokrok v jednom směru často pomáhá odemknout logiku v tom druhém.",
    "markYourEmptySpaces": "Označte si prázdná místa",
    "useARedX": "Pro udržení pořádku použijte červený křížek na potvrzených prázdných políčkách.",
    "countCarefully": "Počítejte pečlivě",
    "separateNumbersMeanDifferentGroups": "Samostatná čísla znamenají různé skupiny s alespoň jednou mezerou mezi nimi.",
    "largeNumberClues": "Opracujte okraje",
    "largeNumberCluesDescription": "Velké množství indicií se může hodit jen omezeným způsobem – využijte toho ve svůj prospěch.",
    "stayOrganized": "Zůstaňte organizovaní",
    "stayOrganizedDescription": "Často prohledávejte mřížku; pokrok v jedné oblasti může odhalit stopy v jiných.",
    "dontGuess": "Nehádej",
    "dontGuessDescription": "Držte se logiky – pokud možno se vyhněte metodě pokus-omyl.",
    "howToSolveNonogramDescription": "Nonogramy jsou logické hádanky, ve kterých vyplňujete čtverce v mřížce pomocí nápověd pro každý řádek a sloupec. Tyto nápovědy jsou čísla, která vám říkají, kolik vyplněných čtverců je v daném řádku a v jakém pořadí. Například nápověda „4 1“ znamená, že existují čtyři vyplněné čtverce, za nimiž následuje jeden vyplněný čtverec, s alespoň jedním prázdným místem mezi skupinami. Vaším cílem je zjistit, kam tyto vyplněné čtverce patří, a to logickým uvažováním a souhrnným zvážením horizontálních i vertikálních nápověd.",
    "howToSolveNonogramInstructions": "Chcete-li začít s řešením, hledejte řádky nebo sloupce, kde nápovědy zabírají velkou část řádku, protože ty se obvykle nejsnadněji vyplňují jako první. Postupně využívejte to, co jste se naučili, k aktualizaci dalších řádků a sloupců. Mezery, které jsou rozhodně prázdné, by měly být označeny červeným „X“, abyste se vyhnuli chybám a ujasnili si zbývající možnosti. Postupně se vyplňováním potvrzených čtverců a odškrtáváním prázdných políček propracujete k úplné a konzistentní mřížce.",
    "darkMode": "Tmavý režim",
    "lightMode": "Světelný režim",
    "todaysPuzzle": "Dnešní hádanka",
    "playNow": "Hrát nyní",
    "contactMessages": "Zprávy",
    "dailyPuzzleArchive": "Denní archiv hádanek",
    "previous": "Předchozí",
    "next": "Další",
    "noPuzzlesFound": "Pro tento měsíc nebyly nalezeny žádné denní hádanky.",
    "nonogram": "Nonogram",
    "sudoku": "Sudoku",
    "playNonogramDailyToday": "Zahrajte si Nonogram Daily ještě dnes!",
    "playSudokuDailyToday": "Zahrajte si Sudoku Daily ještě dnes!"
  },
  "da": {
    "timeRecorded": "Din tid er blevet registreret!",
    "dailyNonogramFor": "Dagligt nonogram for",
    "privacyPolicy": "Privatlivspolitik",
    "termsOfService": "Servicevilkår",
    "account": "Konto",
    "username": "Brugernavn",
    "password": "Adgangskode",
    "oldPassword": "Gammel adgangskode",
    "loading": "Indlæser",
    "login": "Log på",
    "noAccount": "Har du ikke en konto?",
    "createAccount": "Tilmeld dig her",
    "required": "Nødvendig",
    "loggedIn": "Du er logget ind!",
    "logout": "Log ud",
    "loggedOut": "Du er nu logget ud",
    "returnToPuzzles": "Gå tilbage til gåderne",
    "changePassword": "Skift kodeord",
    "settings": "Indstillinger",
    "settingsUpdated": "Indstillinger opdateret",
    "register": "Tilmeld",
    "forgotYourPassword": "Glemt din adgangskode?",
    "resetPassword": "Nulstil din adgangskode",
    "email": "E-mail",
    "confirmPassword": "Bekræft kodeord",
    "passwordUpdated": "Adgangskode opdateret",
    "passwordsMustMatch": "kodeordene skal være ens",
    "haveAnAccount": "har du allerede en bruger?",
    "ajaxError": "Der var et problem. Prøv igen senere",
    "language": "Sprog",
    "size": "Størrelse",
    "save": "Gemme",
    "invalidEmail": "Giv en gyldig email",
    "sendingEmail": "Afsendelse af e-mail",
    "resetEmailSent": "Tjek din email for linket for at nulstille din adgangskode.",
    "ad": "Reklame",
    "nonogramPuzzle": "Nonogram puslespil",
    "goodLuck": "Held og lykke!",
    "errorFound": "Fejl fundet",
    "correct": "Korrekt!!",
    "startOver": "Start forfra",
    "showCorrect": "Vis korrekte rækker/kolonner",
    "checkIt": "Tjekke det",
    "newNonogram": "Nyt nonogram",
    "topTimesFor": "Toptider for {size} x {size}",
    "noTimes": "Ingen gange at vise",
    "user": "Bruger",
    "time": "Tid",
    "puzzle": "Gåde",
    "nonogramSizes": "Nonogram størrelser",
    "contactMe": "Kontakt mig",
    "howToSolve": "Hvordan man løser",
    "topTimes": "Top Times",
    "languages": "Sprog",
    "yourName": "Dit navn",
    "yourEmail": "Din email",
    "message": "Besked",
    "sendingMessage": "Afsendelse af besked",
    "sendMessage": "Send besked",
    "sentMessage": "Besked sendt",
    "bulgarian": "bulgarsk",
    "czech": "tjekkisk",
    "danish": "dansk",
    "german": "tysk",
    "greek": "græsk",
    "english": "engelsk",
    "spanish": "spansk",
    "estonian": "estisk",
    "finnish": "Finsk",
    "french": "fransk",
    "hebrew": "Hebrew",
    "croatian": "Kroatisk",
    "hungarian": "ungarsk",
    "italian": "italiensk",
    "japanese": "japansk",
    "korean": "Korean",
    "norwegian": "Norsk",
    "dutch": "hollandske",
    "polish": "Polere",
    "portuguese": "portugisisk",
    "romanian": "rumænsk",
    "russian": "Russisk",
    "slovak": "slovakisk",
    "slovenian": "slovensk",
    "serbian": "serbisk",
    "swedish": "Svensk",
    "turkish": "tyrkisk",
    "vietnamese": "Vietnamesisk",
    "chinese": "kinesisk",
    "howToSolveNonogram": "Sådan løses et nonogram",
    "objective": "Objektiv",
    "nonoObjective": "Formålet med spillet er at udfylde gitteret med sorte firkanter, så antallet af fyldte sekventielle firkanter matcher tallene øverst og venstre.",
    "controls": "Controls",
    "nonoControlsLeft": "Venstre klik for at markere en firkant som på (sort) eller ukendt (hvid).",
    "nonoControlsRight": "Højreklik for at markere en firkant som slukket (rødt X) eller ukendt (hvidt).",
    "nonoControlsTouch": "Tryk for at cykle en firkant som på (sort), slukket (rød X) eller ukendt (hvid).",
    "nonoControlsDrag": "Trækværk for alle tre af ovenstående.",
    "freecell": "Freecell",
    "metaDescription": "Nonograms online. Over 500.000 gåder på 29 sprog.",
    "metaKeywords": "nonogram, nonograms, billede, puslespil, griddlers, griddler, picross",
    "mobileApps": "Mobile Apps",
    "dailyArchive": "Arkiv",
    "day": "Dag",
    "fastestTime": "Hurtigste tid",
    "name": "Navn",
    "created": "Oprettet",
    "markAsRead": "Markér som læst",
    "dontMissTodaysPuzzle": "Gå ikke glip af dagens puslespil!",
    "playToday": "Spil i dag",
    "dismiss": "Afskedige",
    "neverShowAgain": "Vis aldrig igen",
    "tipsAndTricks": "Tips og tricks til at løse nonogrammer",
    "startWithTheObvious": "Start med det åbenlyse",
    "focusOnRowsOrColumns": "Fokuser på rækker eller kolonner, hvor ledetrådene næsten fylder hele linjen.",
    "useBothDirections": "Brug begge retninger",
    "progressInOneDirection": "Fremskridt i én retning hjælper ofte med at åbne op for logik i den anden.",
    "markYourEmptySpaces": "Marker dine tomme pladser",
    "useARedX": "Brug et rødt \"X\" på bekræftede tomme felter for at holde dig organiseret.",
    "countCarefully": "Tæl omhyggeligt",
    "separateNumbersMeanDifferentGroups": "Separate tal betyder forskellige grupper med mindst ét mellemrum imellem dem.",
    "largeNumberClues": "Arbejd kanterne",
    "largeNumberCluesDescription": "Store ledetråde passer måske kun på begrænsede måder – brug dette til din fordel.",
    "stayOrganized": "Hold dig organiseret",
    "stayOrganizedDescription": "Scan ofte gitteret; fremskridt på ét område kan afsløre spor på andre.",
    "dontGuess": "Gæt ikke",
    "dontGuessDescription": "Hold dig til logikken – undgå trial and error, når det er muligt.",
    "howToSolveNonogramDescription": "Nonogrammer er logikbaserede gåder, hvor du udfylder firkanter på et gitter ved hjælp af ledetråde for hver række og kolonne. Disse ledetråde er tal, der fortæller dig, hvor mange udfyldte blokke der er i den pågældende linje, og i hvilken rækkefølge. For eksempel betyder et ledetråd på \"4 1\", at der er fire udfyldte firkanter efterfulgt af et udfyldt felt med mindst ét tomt mellemrum mellem grupperne. Dit mål er at finde ud af, hvor disse udfyldte blokke skal være, ved at anvende logisk ræsonnement og overveje både de vandrette og lodrette ledetråde sammen.",
    "howToSolveNonogramInstructions": "For at begynde at løse opgaven skal du kigge efter rækker eller kolonner, hvor ledetrådene fylder en stor del af linjen, da de normalt er nemmest at udfylde først. Brug det, du har lært, til at opdatere andre rækker og kolonner, efterhånden som du gør fremskridt. Felter, der helt sikkert er tomme, bør markeres med et rødt \"X\" for at undgå fejl og tydeliggøre dine resterende muligheder. Ved gradvist at udfylde bekræftede felter og markere tomme felter, vil du arbejde dig hen imod et færdigt og ensartet gitter.",
    "darkMode": "Mørk tilstand",
    "lightMode": "Lystilstand",
    "todaysPuzzle": "Dagens puslespil",
    "playNow": "Spil nu",
    "contactMessages": "Beskeder",
    "dailyPuzzleArchive": "Dagligt puslespilarkiv",
    "previous": "Tidligere",
    "next": "Næste",
    "noPuzzlesFound": "Ingen daglige gåder fundet for denne måned.",
    "nonogram": "Nonogram",
    "sudoku": "Sudoku",
    "playSudokuDailyToday": "Spil Sudoku Daily i dag!",
    "playNonogramDailyToday": "Spil Nonogram Daily i dag!"
  },
  "de": {
    "timeRecorded": "Ihre Zeit wurde erfasst!",
    "dailyNonogramFor": "Tägliches Nonogramm für",
    "privacyPolicy": "Datenschutzrichtlinie",
    "termsOfService": "Servicebedingungen",
    "account": "Konto",
    "username": "Nutzername",
    "password": "Passwort",
    "oldPassword": "Altes Passwort",
    "loading": "Wird geladen",
    "login": "Anmeldung",
    "noAccount": "Ich habe noch kein Konto",
    "createAccount": "Hier registrieren",
    "required": "Erforderlich",
    "loggedIn": "Du bist eingeloggt!",
    "logout": "Ausloggen",
    "loggedOut": "Sie sind jetzt ausgeloggt",
    "returnToPuzzles": "Kehre zu den Rätseln zurück",
    "changePassword": "Ändere das Passwort",
    "settings": "die Einstellungen",
    "settingsUpdated": "Einstellungen aktualisiert",
    "register": "Registrieren",
    "forgotYourPassword": "Haben Sie Ihr Passwort vergessen?",
    "resetPassword": "Setze dein Passwort zurück",
    "email": "Email",
    "confirmPassword": "Passwort bestätigen",
    "passwordUpdated": "Passwort aktualisiert",
    "passwordsMustMatch": "Die Passwörter müssen übereinstimmen",
    "haveAnAccount": "Hast du schon ein Konto?",
    "ajaxError": "Es gab ein Problem. Versuchen Sie es später noch einmal",
    "language": "Sprache",
    "size": "Größe",
    "save": "sparen",
    "invalidEmail": "Geben Sie eine gültige E-Mail-Adresse an",
    "sendingEmail": "Email schicken",
    "resetEmailSent": "Überprüfen Sie Ihre E-Mail nach dem Link, um Ihr Passwort zurückzusetzen.",
    "ad": "Werbung",
    "nonogramPuzzle": "Nonogram Puzzle",
    "goodLuck": "Viel Glück!",
    "errorFound": "Fehler gefunden",
    "correct": "Richtig!!",
    "startOver": "Von vorn anfangen",
    "showCorrect": "Richtige Zeilen/Spalten anzeigen",
    "checkIt": "Prüfen Sie",
    "newNonogram": "Neues Nonogramm",
    "topTimesFor": "Top-Zeiten für {Größe} x {Größe}",
    "noTimes": "Keine Zeiten zu zeigen",
    "user": "Nutzer",
    "time": "Zeit",
    "puzzle": "Puzzle",
    "nonogramSizes": "Nonogram-Größen",
    "contactMe": "Kontaktiere mich",
    "howToSolve": "Wie löst man",
    "topTimes": "Top-Zeiten",
    "languages": "Sprachen",
    "yourName": "Dein Name",
    "yourEmail": "Deine E-Mail",
    "message": "Botschaft",
    "sendingMessage": "Schicke Nachricht",
    "sendMessage": "Nachricht senden",
    "sentMessage": "Nachricht gesendet",
    "bulgarian": "bulgarisch",
    "czech": "Tschechisch",
    "danish": "dänisch",
    "german": "Deutsche",
    "greek": "griechisch",
    "english": "Englisch",
    "spanish": "Spanisch",
    "estonian": "estnisch",
    "finnish": "finnisch",
    "french": "Französisch",
    "hebrew": "Hebräisch",
    "croatian": "kroatisch",
    "hungarian": "ungarisch",
    "italian": "Italienisch",
    "japanese": "japanisch",
    "korean": "Koreanisch",
    "norwegian": "norwegisch",
    "dutch": "Niederländisch",
    "polish": "Polieren",
    "portuguese": "Portugiesisch",
    "romanian": "rumänisch",
    "russian": "Russisch",
    "slovak": "slowakisch",
    "slovenian": "Slowenisch",
    "serbian": "serbisch",
    "swedish": "Schwedisch",
    "turkish": "Türkisch",
    "vietnamese": "Vietnamesisch",
    "chinese": "Chinesisch",
    "howToSolveNonogram": "So lösen Sie ein Nonogramm",
    "objective": "Zielsetzung",
    "nonoObjective": "Das Ziel des Spiels ist es, das Gitter mit schwarzen Quadraten zu füllen, so dass die Anzahl der gefüllten sequentiellen Quadrate mit den Zahlen oben und links übereinstimmt.",
    "controls": "Steuerelemente",
    "nonoControlsLeft": "Klicken Sie mit der linken Maustaste, um ein Quadrat als (schwarz) oder als unbekannt (weiß) zu markieren.",
    "nonoControlsRight": "Klicken Sie mit der rechten Maustaste, um ein Quadrat als deaktiviert (rotes X) oder unbekannt (weiß) zu markieren.",
    "nonoControlsTouch": "Berühren Sie, um ein Quadrat als Ein (Schwarz), Aus (Rotes X) oder Unbekanntes (Weiß) zu durchlaufen.",
    "nonoControlsDrag": "Ziehen funktioniert für alle drei der oben genannten.",
    "freecell": "Freie Zelle",
    "metaDescription": "Nonogramme Online. Über 500.000 Rätsel in 29 Sprachen.",
    "metaKeywords": "nonogramm, nonogramme, bild, puzzle, griddlers, griddler, picross",
    "mobileApps": "Mobile Apps",
    "dailyArchive": "Archiv",
    "day": "Tag",
    "fastestTime": "Schnellste Zeit",
    "name": "Name",
    "created": "Erstellt",
    "markAsRead": "Als gelesen markieren",
    "dontMissTodaysPuzzle": "Verpassen Sie nicht das heutige Rätsel!",
    "playToday": "Spielen Sie noch heute",
    "dismiss": "Zurückweisen",
    "neverShowAgain": "Nie wieder anzeigen",
    "tipsAndTricks": "Tipps und Tricks zum Lösen von Nonogrammen",
    "startWithTheObvious": "Beginnen Sie mit dem Offensichtlichen",
    "focusOnRowsOrColumns": "Konzentrieren Sie sich auf Zeilen oder Spalten, in denen die Hinweise fast die gesamte Zeile ausfüllen.",
    "useBothDirections": "Verwenden Sie beide Richtungen",
    "progressInOneDirection": "Fortschritte in die eine Richtung helfen oft dabei, die Logik in der anderen Richtung zu entschlüsseln.",
    "markYourEmptySpaces": "Markieren Sie Ihre leeren Stellen",
    "useARedX": "Verwenden Sie ein rotes „X“ auf bestätigten leeren Feldern, um die Übersicht zu behalten.",
    "countCarefully": "Zählen Sie sorgfältig",
    "separateNumbersMeanDifferentGroups": "Getrennte Zahlen bedeuten unterschiedliche Gruppen mit mindestens einem Leerzeichen dazwischen.",
    "largeNumberClues": "Die Kanten bearbeiten",
    "largeNumberCluesDescription": "Große Zahlenhinweise passen möglicherweise nur eingeschränkt – nutzen Sie dies zu Ihrem Vorteil.",
    "stayOrganized": "Bleiben Sie organisiert",
    "stayOrganizedDescription": "Scannen Sie das Raster häufig. Fortschritte in einem Bereich können Hinweise in anderen Bereichen offenbaren.",
    "dontGuess": "Raten Sie nicht",
    "dontGuessDescription": "Bleiben Sie der Logik treu – vermeiden Sie nach Möglichkeit Versuch und Irrtum.",
    "howToSolveNonogramDescription": "Nonogramme sind Logikrätsel, bei denen Sie Quadrate in einem Raster mithilfe von Hinweisen für jede Zeile und Spalte ausfüllen. Diese Hinweise sind Zahlen, die Ihnen sagen, wie viele ausgefüllte Blöcke sich in dieser Zeile befinden und in welcher Reihenfolge. Beispielsweise bedeutet der Hinweis „4 1“, dass es vier ausgefüllte Quadrate gefolgt von einem ausgefüllten Quadrat gibt, mit mindestens einem leeren Feld zwischen den Gruppen. Ihr Ziel ist es, mithilfe logischer Überlegungen und unter Berücksichtigung der horizontalen und vertikalen Hinweise herauszufinden, wohin diese ausgefüllten Blöcke gehören.",
    "howToSolveNonogramInstructions": "Suchen Sie zunächst nach Zeilen oder Spalten, in denen die Hinweise einen großen Teil der Linie einnehmen, da diese in der Regel zuerst am einfachsten auszufüllen sind. Nutzen Sie im Laufe der Zeit Ihr Gelerntes, um weitere Zeilen und Spalten zu aktualisieren. Definitiv leere Felder sollten mit einem roten „X“ markiert werden, um Fehler zu vermeiden und Ihre verbleibenden Optionen zu verdeutlichen. Durch das Ausfüllen bestätigter Felder und das Markieren leerer Felder arbeiten Sie sich nach und nach zu einem vollständigen und konsistenten Raster vor.",
    "darkMode": "Dunkler Modus",
    "lightMode": "Lichtmodus",
    "todaysPuzzle": "Das heutige Rätsel",
    "playNow": "jetzt spielen",
    "contactMessages": "Nachrichten",
    "dailyPuzzleArchive": "Tägliches Rätselarchiv",
    "previous": "Vorherige",
    "next": "Nächste",
    "noPuzzlesFound": "Für diesen Monat wurden keine täglichen Rätsel gefunden.",
    "nonogram": "Nonogramm",
    "sudoku": "Sudoku",
    "playSudokuDailyToday": "Spiele heute das tägliche Sudoku!",
    "playNonogramDailyToday": "Spiele heute das Nonogramm-Tagesspiel!"
  },
  "el": {
    "timeRecorded": "Ο χρόνος σας έχει καταγραφεί!",
    "dailyNonogramFor": "Ημερήσιο Νονογράφημα για",
    "privacyPolicy": "Πολιτική Απορρήτου",
    "termsOfService": "Όροι Παροχής Υπηρεσιών",
    "account": "λογαριασμός",
    "username": "Όνομα χρήστη",
    "password": "Κωδικός πρόσβασης",
    "oldPassword": "Παλιός κωδικός πρόσβασης",
    "loading": "Φόρτωση",
    "login": "Σύνδεση",
    "noAccount": "Δεν έχετε λογαριασμό;",
    "createAccount": "Εγγραφείτε εδώ",
    "required": "Απαιτείται",
    "loggedIn": "Είστε συνδεδεμένοι!",
    "logout": "Αποσυνδέση",
    "loggedOut": "Τώρα αποσυνδεθείτε",
    "returnToPuzzles": "Επιστρέψτε στο παζλ",
    "changePassword": "Άλλαξε κωδικό",
    "settings": "Ρυθμίσεις",
    "settingsUpdated": "Οι ρυθμίσεις ενημερώθηκαν",
    "register": "Κανω ΕΓΓΡΑΦΗ",
    "forgotYourPassword": "Ξεχάσατε τον κωδικό σας?",
    "resetPassword": "Επαναφορά του κωδικού πρόσβασής σας",
    "email": "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ",
    "confirmPassword": "Επιβεβαίωση Κωδικού",
    "passwordUpdated": "Ο κωδικός είναι ενημερωμένος",
    "passwordsMustMatch": "οι κωδικοί πρέπει να ταιριάζουν",
    "haveAnAccount": "Έχετε ήδη λογαριασμό?",
    "ajaxError": "Υπήρξε ένα πρόβλημα. Δοκιμάστε ξανά αργότερα",
    "language": "Γλώσσα",
    "size": "Μέγεθος",
    "save": "Αποθηκεύσετε",
    "invalidEmail": "Δώστε έγκυρο μήνυμα ηλεκτρονικού ταχυδρομείου",
    "sendingEmail": "Αποστολή μηνύματος ηλεκτρονικού ταχυδρομείου",
    "resetEmailSent": "Ελέγξτε το μήνυμα ηλεκτρονικού ταχυδρομείου για τη σύνδεση για να επαναφέρετε τον κωδικό πρόσβασής σας",
    "ad": "Διαφήμιση",
    "nonogramPuzzle": "Πλανόγραμμα Nonogram",
    "goodLuck": "Καλή τύχη!",
    "errorFound": "Βρέθηκαν σφάλματα",
    "correct": "Σωστός!!",
    "startOver": "Ξεκίνα από την αρχή",
    "showCorrect": "Εμφάνιση των σωστών σειρών/στελών",
    "checkIt": "Ελεγξέ το",
    "newNonogram": "Νέο Nonogram",
    "topTimesFor": "Κορυφαίοι χρόνοι για {size} x {size}",
    "noTimes": "Δεν υπάρχουν στιγμές για εμφάνιση",
    "user": "Χρήστης",
    "time": "χρόνος",
    "puzzle": "Παζλ",
    "nonogramSizes": "Μεγέθη Nonogram",
    "contactMe": "Επικοινώνησε μαζί μου",
    "howToSolve": "Πώς να λύσετε",
    "topTimes": "Κορυφαίοι χρόνοι",
    "languages": "Γλώσσες",
    "yourName": "Το όνομα σου",
    "yourEmail": "Η διεύθυνση του ηλεκτρονικού σου ταχυδρομείου",
    "message": "Μήνυμα",
    "sendingMessage": "Αποστολή μηνύματος",
    "sendMessage": "Να στείλετε μήνυμα",
    "sentMessage": "Το μήνυμα στάλθηκε",
    "bulgarian": "Βούλγαρος",
    "czech": "Τσέχος",
    "danish": "δανικός",
    "german": "Γερμανός",
    "greek": "Ελληνικά",
    "english": "Αγγλικά",
    "spanish": "Ισπανικά",
    "estonian": "Εσθονικά",
    "finnish": "φινλανδικός",
    "french": "γαλλική γλώσσα",
    "hebrew": "Εβραϊκά",
    "croatian": "Κροατία",
    "hungarian": "ουγγρικός",
    "italian": "ιταλικός",
    "japanese": "Ιαπωνικά",
    "korean": "κορεάτης",
    "norwegian": "Νορβηγός",
    "dutch": "Ολλανδός",
    "polish": "Στίλβωση",
    "portuguese": "Πορτογαλικά",
    "romanian": "ρουμανικός",
    "russian": "Ρωσική",
    "slovak": "Σλοβάκος",
    "slovenian": "Σλοβενικά",
    "serbian": "Σέρβος",
    "swedish": "Σουηδικά",
    "turkish": "τούρκικος",
    "vietnamese": "Βιετναμέζοι",
    "chinese": "κινέζικα",
    "howToSolveNonogram": "Πώς να λύσετε ένα μηγραμμό",
    "objective": "Σκοπός",
    "nonoObjective": "Το αντικείμενο του παιχνιδιού είναι να γεμίσει το πλέγμα με μαύρα τετράγωνα έτσι ώστε οι αριθμοί των γεμάτων διαδοχικά τετράγωνα να ταιριάζουν με τους αριθμούς στην κορυφή και στο αριστερό.",
    "controls": "Έλεγχοι",
    "nonoControlsLeft": "Αριστερό κλικ για να επισημάνετε ένα τετράγωνο ως ενεργοποιημένο (μαύρο) ή άγνωστο (λευκό).",
    "nonoControlsRight": "Κάντε δεξί κλικ για να επισημάνετε ένα τετράγωνο ως απενεργοποιημένο (κόκκινο Χ) ή άγνωστο (λευκό).",
    "nonoControlsTouch": "Αγγίξτε για κύλιση ενός τετραγώνου όπως είναι ενεργοποιημένο (μαύρο), απενεργοποιημένο (κόκκινο Χ) ή άγνωστο (λευκό).",
    "nonoControlsDrag": "Το dragging λειτουργεί και για τα τρία παραπάνω.",
    "freecell": "Freecell",
    "metaDescription": "Nonograms Online. Πάνω από 500.000 παζλ σε 29 γλώσσες.",
    "metaKeywords": "nonogram, nonograms, εικόνα, παζλ, griddlers, griddler, picross",
    "mobileApps": "Εφαρμογές για κινητά",
    "dailyArchive": "Αρχείο",
    "day": "Ημέρα",
    "fastestTime": "Ταχύτερος χρόνος",
    "name": "Ονομα",
    "created": "Δημιουργήθηκε",
    "markAsRead": "Σήμανση ως αναγνωσμένου",
    "dontMissTodaysPuzzle": "Μην χάσετε το σημερινό παζλ!",
    "playToday": "Παίξτε σήμερα",
    "dismiss": "Απολύω",
    "neverShowAgain": "Να μην εμφανιστεί ποτέ ξανά",
    "tipsAndTricks": "Συμβουλές και κόλπα για την επίλυση μη γραφημάτων",
    "startWithTheObvious": "Ξεκινήστε με το προφανές",
    "focusOnRowsOrColumns": "Εστιάστε σε γραμμές ή στήλες όπου οι ενδείξεις γεμίζουν σχεδόν ολόκληρη τη γραμμή.",
    "useBothDirections": "Χρησιμοποιήστε και τις δύο κατευθύνσεις",
    "progressInOneDirection": "Η πρόοδος προς τη μία κατεύθυνση συχνά βοηθά στην απελευθέρωση της λογικής προς την άλλη.",
    "markYourEmptySpaces": "Σημειώστε τα κενά σας",
    "useARedX": "Χρησιμοποιήστε ένα κόκκινο «Χ» σε επιβεβαιωμένα κενά τετράγωνα για να παραμείνετε οργανωμένοι.",
    "countCarefully": "Μέτρησε προσεκτικά",
    "separateNumbersMeanDifferentGroups": "Ξεχωριστοί αριθμοί σημαίνουν διαφορετικές ομάδες με τουλάχιστον ένα κενό μεταξύ τους.",
    "largeNumberClues": "Δουλέψτε τις άκρες",
    "largeNumberCluesDescription": "Οι ενδείξεις μεγάλου αριθμού μπορεί να ταιριάζουν μόνο σε περιορισμένο βαθμό—χρησιμοποιήστε το προς όφελός σας.",
    "stayOrganized": "Μείνετε οργανωμένοι",
    "stayOrganizedDescription": "Σαρώστε συχνά το πλέγμα. Η πρόοδος σε έναν τομέα μπορεί να αποκαλύψει ενδείξεις σε άλλους.",
    "dontGuess": "Μην μαντεύεις",
    "dontGuessDescription": "Να βασίζεστε στη λογική—αποφύγετε τη δοκιμή και το λάθος όταν είναι δυνατόν.",
    "howToSolveNonogramDescription": "Τα νονογράμματα είναι παζλ που βασίζονται στη λογική, όπου συμπληρώνετε τετράγωνα σε ένα πλέγμα χρησιμοποιώντας στοιχεία που παρέχονται για κάθε γραμμή και στήλη. Αυτά τα στοιχεία είναι αριθμοί που σας λένε πόσα γεμάτα μπλοκ υπάρχουν σε αυτήν τη γραμμή και με ποια σειρά. Για παράδειγμα, ένα στοιχείο \"4 1\" σημαίνει ότι υπάρχουν τέσσερα γεμάτα τετράγωνα ακολουθούμενα από ένα γεμισμένο τετράγωνο, με τουλάχιστον ένα κενό διάστημα μεταξύ των ομάδων. Ο στόχος σας είναι να καταλάβετε πού πηγαίνουν αυτά τα γεμάτα μπλοκ εφαρμόζοντας λογική συλλογιστική και λαμβάνοντας υπόψη τόσο τα οριζόντια όσο και τα κάθετα στοιχεία μαζί.",
    "howToSolveNonogramInstructions": "Για να ξεκινήσετε την επίλυση, αναζητήστε γραμμές ή στήλες όπου οι ενδείξεις καταλαμβάνουν μεγάλο μέρος της γραμμής, καθώς αυτές είναι συνήθως πιο εύκολο να συμπληρωθούν πρώτες. Καθώς σημειώνετε πρόοδο, χρησιμοποιήστε ό,τι έχετε μάθει για να ενημερώσετε άλλες γραμμές και στήλες. Τα κενά που είναι σίγουρα κενά θα πρέπει να σημειώνονται με ένα κόκκινο \"X\" για να αποφύγετε σφάλματα και να διευκρινίσετε τις υπόλοιπες επιλογές σας. Σταδιακά, συμπληρώνοντας τα επιβεβαιωμένα τετράγωνα και σημειώνοντας τα κενά, θα προχωρήσετε προς ένα ολοκληρωμένο και συνεπές πλέγμα.",
    "darkMode": "Σκοτεινή λειτουργία",
    "lightMode": "Λειτουργία φωτισμού",
    "todaysPuzzle": "Το σημερινό παζλ",
    "playNow": "Παίξε τώρα",
    "contactMessages": "Μηνύματα",
    "dailyPuzzleArchive": "Ημερήσιο Αρχείο Παζλ",
    "previous": "Προηγούμενος",
    "next": "Επόμενος",
    "noPuzzlesFound": "Δεν βρέθηκαν καθημερινά παζλ για αυτόν τον μήνα.",
    "nonogram": "Νονόγραμμα",
    "sudoku": "Σουντόκου",
    "playNonogramDailyToday": "Παίξτε το Nonogram Daily σήμερα!",
    "playSudokuDailyToday": "Παίξτε το Sudoku καθημερινά σήμερα!"
  },
  "es": {
    "timeRecorded": "¡Tu tiempo ha sido registrado!",
    "dailyNonogramFor": "Nonograma diario para",
    "privacyPolicy": "política de privacidad",
    "termsOfService": "Condiciones de servicio",
    "account": "Cuenta",
    "username": "Nombre de usuario",
    "password": "Contraseña",
    "oldPassword": "Contraseña anterior",
    "loading": "Cargando",
    "login": "Iniciar sesión",
    "noAccount": "¿No tienes una cuenta?",
    "createAccount": "Registrar aquí",
    "required": "Necesario",
    "loggedIn": "Has iniciado sesión!",
    "logout": "Cerrar sesión",
    "loggedOut": "ahora estás registrado",
    "returnToPuzzles": "Volver a los puzzles",
    "changePassword": "Cambia la contraseña",
    "settings": "Ajustes",
    "settingsUpdated": "Ajustes actualizan",
    "register": "Registro",
    "forgotYourPassword": "¿Olvidaste tu contraseña?",
    "resetPassword": "Restablecer su contraseña",
    "email": "Email",
    "confirmPassword": "Confirmar contraseña",
    "passwordUpdated": "Contraseña actualiza",
    "passwordsMustMatch": "Las contraseñas deben coincidir",
    "haveAnAccount": "¿Ya tienes una cuenta?",
    "ajaxError": "Había un problema. Inténtalo más tarde",
    "language": "Idioma",
    "size": "tamaño",
    "save": "Salvar",
    "invalidEmail": "Proporcionar un correo electrónico válido",
    "sendingEmail": "Enviando email",
    "resetEmailSent": "Revise su correo electrónico para el enlace para restablecer su contraseña.",
    "ad": "Anuncio",
    "nonogramPuzzle": "Rompecabezas Nonogram",
    "goodLuck": "¡Buena suerte!",
    "errorFound": "Errores encontrados",
    "correct": "¡¡Correcto!!",
    "startOver": "Comenzar de nuevo",
    "showCorrect": "Mostrar filas/columnas correctas",
    "checkIt": "Revisalo",
    "newNonogram": "Nuevo nonograma",
    "topTimesFor": "Los mejores tiempos para {tamaño} x {tamaño}",
    "noTimes": "No hay tiempos para mostrar",
    "user": "Usuario",
    "time": "Hora",
    "puzzle": "Rompecabezas",
    "nonogramSizes": "Tamaños Nonogram",
    "contactMe": "Contáctame",
    "howToSolve": "Cómo resolver",
    "topTimes": "Top Times",
    "languages": "Idiomas",
    "yourName": "Tu nombre",
    "yourEmail": "Tu correo electrónico",
    "message": "Mensaje",
    "sendingMessage": "Enviando mensaje",
    "sendMessage": "Enviar mensaje",
    "sentMessage": "Mensaje enviado",
    "bulgarian": "búlgaro",
    "czech": "checo",
    "danish": "danés",
    "german": "alemán",
    "greek": "griego",
    "english": "Inglés",
    "spanish": "Español",
    "estonian": "Estonio",
    "finnish": "finlandés",
    "french": "francés",
    "hebrew": "hebreo",
    "croatian": "croata",
    "hungarian": "húngaro",
    "italian": "italiano",
    "japanese": "japonés",
    "korean": "coreano",
    "norwegian": "noruego",
    "dutch": "holandés",
    "polish": "polaco",
    "portuguese": "portugués",
    "romanian": "rumano",
    "russian": "ruso",
    "slovak": "eslovaco",
    "slovenian": "esloveno",
    "serbian": "serbio",
    "swedish": "sueco",
    "turkish": "turco",
    "vietnamese": "vietnamita",
    "chinese": "chino",
    "howToSolveNonogram": "Cómo resolver un nonograma",
    "objective": "Objetivo",
    "nonoObjective": "El objetivo del juego es rellenar la cuadrícula con cuadrados negros para que los números de cuadrados secuenciales rellenos coincidan con los números en la parte superior e izquierda.",
    "controls": "Controles",
    "nonoControlsLeft": "Haga clic izquierdo para marcar un cuadrado como encendido (negro) o desconocido (blanco).",
    "nonoControlsRight": "Haga clic con el botón derecho para marcar un cuadrado como desactivado (X roja) o desconocido (blanco).",
    "nonoControlsTouch": "Toque para alternar un cuadrado como activado (negro), desactivado (X roja) o desconocido (blanco).",
    "nonoControlsDrag": "El arrastre funciona para los tres de los anteriores.",
    "freecell": "Libre de células",
    "metaDescription": "Nonogramas en línea. Más de 500,000 rompecabezas en 29 idiomas.",
    "metaKeywords": "nonograma, nonogramas, imagen, rompecabezas, griddlers, griddler, picross",
    "mobileApps": "Aplicaciones móviles",
    "dailyArchive": "Archivo",
    "day": "Día",
    "fastestTime": "Tiempo más rápido",
    "name": "Nombre",
    "created": "Creado",
    "markAsRead": "Marcar como leído",
    "dontMissTodaysPuzzle": "¡No te pierdas el rompecabezas de hoy!",
    "playToday": "Juega hoy",
    "dismiss": "Despedir",
    "neverShowAgain": "No volver a mostrar",
    "tipsAndTricks": "Consejos y trucos para resolver nonogramas",
    "startWithTheObvious": "Empecemos por lo obvio",
    "focusOnRowsOrColumns": "Concéntrese en las filas o columnas donde las pistas llenan casi toda la línea.",
    "useBothDirections": "Utilice ambas direcciones",
    "progressInOneDirection": "El progreso en una dirección a menudo ayuda a desbloquear la lógica en la otra.",
    "markYourEmptySpaces": "Marca tus espacios vacíos",
    "useARedX": "Utilice una “X” roja en los cuadrados vacíos confirmados para mantenerse organizado.",
    "countCarefully": "Cuente con cuidado",
    "separateNumbersMeanDifferentGroups": "Los números separados significan grupos diferentes con al menos un espacio entre ellos.",
    "largeNumberClues": "Trabajar los bordes",
    "largeNumberCluesDescription": "Es posible que las pistas con un gran número de pistas solo encajen de manera limitada: use esto a su favor.",
    "stayOrganized": "Mantente organizado",
    "stayOrganizedDescription": "Escanee la cuadrícula con frecuencia; el progreso en un área puede revelar pistas en otras.",
    "dontGuess": "No adivines",
    "dontGuessDescription": "Apéguese a la lógica: evite el ensayo y error cuando sea posible.",
    "howToSolveNonogramDescription": "Los nonogramas son juegos de lógica en los que se rellenan casillas de una cuadrícula usando pistas para cada fila y columna. Estas pistas son números que indican cuántos bloques llenos hay en esa línea y en qué orden. Por ejemplo, la pista \"4 1\" significa que hay cuatro casillas llenas seguidas de una, con al menos un espacio en blanco entre los grupos. El objetivo es averiguar dónde van esos bloques llenos aplicando el razonamiento lógico y considerando las pistas horizontales y verticales en conjunto.",
    "howToSolveNonogramInstructions": "Para empezar a resolver, busca filas o columnas donde las pistas ocupen gran parte de la línea, ya que suelen ser más fáciles de completar primero. A medida que avances, usa lo aprendido para actualizar otras filas y columnas. Los espacios que estén definitivamente vacíos deben marcarse con una \"X\" roja para evitar errores y aclarar las opciones restantes. Gradualmente, al completar las casillas confirmadas y marcar las vacías, irás avanzando hacia una cuadrícula completa y coherente.",
    "darkMode": "Modo oscuro",
    "lightMode": "Modo claro",
    "todaysPuzzle": "El rompecabezas de hoy",
    "playNow": "Jugar ahora",
    "contactMessages": "Mensajes",
    "dailyPuzzleArchive": "Archivo de rompecabezas diarios",
    "previous": "Anterior",
    "next": "Próximo",
    "noPuzzlesFound": "No se encontraron rompecabezas diarios para este mes.",
    "nonogram": "Nonograma",
    "sudoku": "Sudoku",
    "playSudokuDailyToday": "¡Juega hoy mismo al Sudoku diario!",
    "playNonogramDailyToday": "¡Juega hoy mismo al Nonograma Diario!"
  },
  "et": {
    "timeRecorded": "Teie aeg on registreeritud!",
    "dailyNonogramFor": "Igapäevane nonogramm",
    "privacyPolicy": "Privaatsuspoliitika",
    "termsOfService": "Teenusetingimused",
    "account": "Konto",
    "username": "Kasutajanimi",
    "password": "Parool",
    "oldPassword": "Vana parool",
    "loading": "Laadimine",
    "login": "Logi sisse",
    "noAccount": "Kas teil pole kontot?",
    "createAccount": "Registreeru siin",
    "required": "Nõutud",
    "loggedIn": "Sa oled sisse logitud!",
    "logout": "Logi välja",
    "loggedOut": "Olete nüüd välja loginud",
    "returnToPuzzles": "Tagasi mõistatuste juurde",
    "changePassword": "Muuda salasõna",
    "settings": "Seaded",
    "settingsUpdated": "Seaded uuendatud",
    "register": "Registreeri",
    "forgotYourPassword": "Unustasid salasõna?",
    "resetPassword": "Taasta oma salasõna",
    "email": "E-post",
    "confirmPassword": "Kinnita salasõna",
    "passwordUpdated": "Parool uuendatud",
    "passwordsMustMatch": "salasõnad peavad kattuma",
    "haveAnAccount": "On juba konto?",
    "ajaxError": "Probleem oli. Proovige hiljem uuesti",
    "language": "Keel",
    "size": "Suurus",
    "save": "Salvesta",
    "invalidEmail": "Esitage kehtiv e-kiri",
    "sendingEmail": "E-kirja saatmine",
    "resetEmailSent": "Kontrollige oma e-posti parooli parooli lähtestamiseks linki.",
    "ad": "Reklaam",
    "nonogramPuzzle": "Nonogramm Puzzle",
    "goodLuck": "Edu!",
    "errorFound": "Leitud vead",
    "correct": "Õige!",
    "startOver": "Alusta uuesti",
    "showCorrect": "Kuva õiged read/veerud",
    "checkIt": "Vaata seda",
    "newNonogram": "Uus Nonogram",
    "topTimesFor": "Parim aeg {size} x {size} jaoks",
    "noTimes": "Ei ole aega näidata",
    "user": "Kasutaja",
    "time": "Aeg",
    "puzzle": "Mõistatus",
    "nonogramSizes": "Nonogram Sizes",
    "contactMe": "Võta minuga ühendust",
    "howToSolve": "Kuidas lahendada",
    "topTimes": "Top Times",
    "languages": "Keeled",
    "yourName": "Sinu nimi",
    "yourEmail": "Sinu email",
    "message": "Sõnum",
    "sendingMessage": "Sõnumi saatmine",
    "sendMessage": "Saada sõnum",
    "sentMessage": "Sõnum saadetud",
    "bulgarian": "Bulgaaria keel",
    "czech": "Tšehhi keel",
    "danish": "Taani keel",
    "german": "Saksa keel",
    "greek": "Kreeka keel",
    "english": "Inglise",
    "spanish": "Hispaania keel",
    "estonian": "Eesti keel",
    "finnish": "Soome keel",
    "french": "Prantsuse keel",
    "hebrew": "Heebrea keel",
    "croatian": "Horvaatia keel",
    "hungarian": "Ungari keel",
    "italian": "Itaalia keel",
    "japanese": "Jaapani keel",
    "korean": "Korea keel",
    "norwegian": "Norra keel",
    "dutch": "Hollandi keel",
    "polish": "Poola keel",
    "portuguese": "Portugali keel",
    "romanian": "Rumeenia keel",
    "russian": "Vene keel",
    "slovak": "Slovaki keel",
    "slovenian": "Sloveeni keel",
    "serbian": "Serbia",
    "swedish": "Rootsi keel",
    "turkish": "Türgi keel",
    "vietnamese": "Vietnami keel",
    "chinese": "Hiina",
    "howToSolveNonogram": "Kuidas lahendada mittogramm",
    "objective": "Eesmärk",
    "nonoObjective": "Mängu eesmärk on täita ruudustik mustade ruutudega, nii et täidetud järjestikuste ruutude arv sobiks üleval ja vasakul olevate numbritega.",
    "controls": "Kontrollid",
    "nonoControlsLeft": "Vasak klõps tähistab ruudu nagu (must) või tundmatu (valge).",
    "nonoControlsRight": "Paremklõps ruudu tähistamiseks välja (punane X) või teadmata (valge).",
    "nonoControlsTouch": "Puudutage ruudu tsüklit nagu sisse (must), välja (punane X) või tundmatu (valge).",
    "nonoControlsDrag": "Lohistamine toimib kõigi kolme eespool.",
    "freecell": "Freecell",
    "metaDescription": "Nonogrammid veebis. Üle 500 000 mõistatuse 29 keeles.",
    "metaKeywords": "nonogramm, nonogramm, pilt, mõistatus, lehtsildurid, lehtsinder, pikross",
    "mobileApps": "Mobiilirakendused",
    "dailyArchive": "Arhiiv",
    "day": "Päev",
    "fastestTime": "Kiireim aeg",
    "name": "Nimi",
    "created": "Loodud",
    "markAsRead": "Märgi loetuks",
    "dontMissTodaysPuzzle": "Ära maga tänast mõistatust maha!",
    "playToday": "Mängi täna",
    "dismiss": "Jäta vahele",
    "neverShowAgain": "Ära kunagi enam näita",
    "tipsAndTricks": "Näpunäited ja nipid nonogrammide lahendamiseks",
    "startWithTheObvious": "Alusta ilmselgest",
    "focusOnRowsOrColumns": "Keskendu ridadele või veergudele, kus vihjed täidavad peaaegu kogu rea.",
    "useBothDirections": "Kasutage mõlemat suunda",
    "progressInOneDirection": "Ühes suunas edasiminek aitab sageli avada loogikat teises suunas.",
    "markYourEmptySpaces": "Märgi oma tühjad kohad",
    "useARedX": "Korrastatuse tagamiseks märgi kinnitatud tühjad ruudud punase „X”-iga.",
    "countCarefully": "Loenda hoolikalt",
    "separateNumbersMeanDifferentGroups": "Eraldi numbrid tähistavad erinevaid rühmi, mille vahel on vähemalt üks tühik.",
    "largeNumberClues": "Töötle servad",
    "largeNumberCluesDescription": "Suure arvu vihjed võivad sobida vaid piiratud viisil – kasuta seda enda huvides.",
    "stayOrganized": "Püsi organiseeritud",
    "stayOrganizedDescription": "Sirvi ruudustikku sageli; edusammud ühes valdkonnas võivad paljastada vihjeid teistes.",
    "dontGuess": "Ära arva ära",
    "dontGuessDescription": "Jää loogika juurde – väldi võimalusel katse-eksituse meetodit.",
    "howToSolveNonogramDescription": "Nonogrammid on loogikal põhinevad mõistatused, kus täidetakse ruudustiku ruudud, kasutades iga rea ja veeru jaoks etteantud vihjeid. Need vihjed on numbrid, mis näitavad, mitu täidetud klotsi selles reas on ja mis järjekorras. Näiteks vihje „4 1” tähendab, et on neli täidetud ruutu, millele järgneb üks täidetud ruut ja rühmade vahel on vähemalt üks tühi koht. Teie eesmärk on välja selgitada, kuhu need täidetud klotsid lähevad, rakendades loogilist arutluskäiku ja arvestades nii horisontaalseid kui ka vertikaalseid vihjeid koos.",
    "howToSolveNonogramInstructions": "Lahendamise alustamiseks otsi ridu või veerge, kus vihjed hõivavad suure osa reast, kuna neid on tavaliselt kõige lihtsam esimesena täita. Edasi liikudes kasuta õpitut teiste ridade ja veergude värskendamiseks. Kindlasti tühjad ruudud tuleks märkida punase „X”-iga, et vältida vigu ja selgitada ülejäänud valikuid. Järk-järgult, kinnitatud ruutude täitmise ja tühjade ruutude maha märkimisega, liigud sa tervikliku ja ühtlase ruudustiku poole.",
    "darkMode": "Tume režiim",
    "lightMode": "Valgusrežiim",
    "todaysPuzzle": "Tänane mõistatus",
    "playNow": "Mängi kohe",
    "contactMessages": "Sõnumid",
    "dailyPuzzleArchive": "Päevane mõistatuste arhiiv",
    "previous": "Eelmine",
    "next": "Järgmine",
    "noPuzzlesFound": "Selle kuu kohta ei leitud ühtegi päevapõhist mõistatust.",
    "nonogram": "Nonogramm",
    "playNonogramDailyToday": "Mängi Nonogrammi iga päev juba täna!",
    "playSudokuDailyToday": "Mängi Sudokut iga päev juba täna!",
    "sudoku": "Sudoku"
  },
  "fi": {
    "timeRecorded": "Aikasi on tallennettu!",
    "dailyNonogramFor": "Päivittäinen nonogrammi",
    "privacyPolicy": "Tietosuojakäytäntö",
    "termsOfService": "Palveluehdot",
    "account": "Tili",
    "username": "Käyttäjätunnus",
    "password": "Salasana",
    "oldPassword": "Vanha salasana",
    "loading": "Ladataan",
    "login": "Kirjaudu sisään",
    "noAccount": "Eikö sinulla ole tiliä?",
    "createAccount": "Rekisteröidy täällä",
    "required": "Vaaditaan",
    "loggedIn": "Olet kirjautunut sisään!",
    "logout": "Kirjautua ulos",
    "loggedOut": "Olet nyt kirjautunut ulos",
    "returnToPuzzles": "Palaa palapeleihin",
    "changePassword": "Vaihda salasana",
    "settings": "asetukset",
    "settingsUpdated": "Asetukset päivitetty",
    "register": "Rekisteröidy",
    "forgotYourPassword": "Unohditko salasanasi?",
    "resetPassword": "Nollaa salasana",
    "email": "Sähköposti",
    "confirmPassword": "Vahvista salasana",
    "passwordUpdated": "Salasana päivitetty",
    "passwordsMustMatch": "Salasanojen täytyy täsmätä",
    "haveAnAccount": "Onko sinulla jo tili?",
    "ajaxError": "Oli ongelma. Yritä myöhemmin uudelleen",
    "language": "Kieli",
    "size": "Koko",
    "save": "Tallentaa",
    "invalidEmail": "Anna kelvollinen sähköposti",
    "sendingEmail": "Sähköpostin lähettäminen",
    "resetEmailSent": "Tarkista sähköpostiosoitteesi salasanan nollaamiseksi.",
    "ad": "Mainos",
    "nonogramPuzzle": "Nonogram-palapeli",
    "goodLuck": "Onnea!",
    "errorFound": "Löytyneet virheet",
    "correct": "Oikea!!",
    "startOver": "Aloittaa alusta",
    "showCorrect": "Näytä oikeat rivit/sarakkeet",
    "checkIt": "Tarkista se",
    "newNonogram": "Uusi Nonogram",
    "topTimesFor": "Eniten kertaa {size} x {size}",
    "noTimes": "Ei aikaa näyttää",
    "user": "käyttäjä",
    "time": "Aika",
    "puzzle": "Palapeli",
    "nonogramSizes": "Nonogram-koot",
    "contactMe": "Ota yhteyttä minuun",
    "howToSolve": "Miten ratkaista",
    "topTimes": "Top Times",
    "languages": "Kieli (kielet",
    "yourName": "Sinun nimesi",
    "yourEmail": "Sähköpostisi",
    "message": "Viesti",
    "sendingMessage": "Viestin lähettäminen",
    "sendMessage": "Lähetä viesti",
    "sentMessage": "Viesti lähetetty",
    "bulgarian": "bulgarialainen",
    "czech": "czech",
    "danish": "Tanskan kieli",
    "german": "Saksan kieli",
    "greek": "kreikkalainen",
    "english": "Englanti",
    "spanish": "Espanja",
    "estonian": "Virolainen",
    "finnish": "Suomalainen",
    "french": "Ranskan kieli",
    "hebrew": "heprealainen",
    "croatian": "kroaatti",
    "hungarian": "Unkarin kieli",
    "italian": "italialainen",
    "japanese": "japanilainen",
    "korean": "Korealainen",
    "norwegian": "Norjan kieli",
    "dutch": "Hollannin kieli",
    "polish": "Kiillottaa",
    "portuguese": "Portugalin kieli",
    "romanian": "romanialainen",
    "russian": "Venäjän kieli",
    "slovak": "Slovakian",
    "slovenian": "slovenian",
    "serbian": "serbialainen",
    "swedish": "Ruotsin kieli",
    "turkish": "turkki",
    "vietnamese": "vietnam",
    "chinese": "Kiinalainen",
    "howToSolveNonogram": "Miten ratkaista Nonogram",
    "objective": "Tavoite",
    "nonoObjective": "Pelin tavoitteena on täyttää ruudukko mustilla neliöillä, jotta täytettyjen peräkkäisten neliöiden numerot vastaavat ylhäällä ja vasemmalla olevia numeroita.",
    "controls": "ohjaimet",
    "nonoControlsLeft": "Napsauta vasenta painiketta, kun haluat merkitä neliön kuten (musta) tai tuntematon (valkoinen).",
    "nonoControlsRight": "Napsauta hiiren kakkospainikkeella merkitä neliö pois päältä (punainen X) tai tuntematon (valkoinen).",
    "nonoControlsTouch": "Voit pyörittää neliötä kuten (musta), pois päältä (punainen X) tai tuntematon (valkoinen) koskettamalla.",
    "nonoControlsDrag": "Vedä kaikki edellä mainitut.",
    "freecell": "Vapaa solu",
    "metaDescription": "Ei-ohjelmat verkossa. Yli 500 000 palapeliä 29 kielellä.",
    "metaKeywords": "nonogram, nonograms, kuva, palapeli, griddlers, griddler, picross",
    "mobileApps": "Mobiilisovellukset",
    "dailyArchive": "Arkisto",
    "day": "Päivä",
    "fastestTime": "Nopein aika",
    "name": "Nimi",
    "created": "Luotu",
    "markAsRead": "Merkitse luetuksi",
    "dontMissTodaysPuzzle": "Älä missaa tämän päivän palapeliä!",
    "playToday": "Pelaa tänään",
    "dismiss": "Hylkää",
    "neverShowAgain": "Älä näytä enää koskaan",
    "tipsAndTricks": "Vinkkejä ja niksejä nonogrammien ratkaisemiseen",
    "startWithTheObvious": "Aloita itsestäänselvyydestä",
    "focusOnRowsOrColumns": "Keskity riveihin tai sarakkeisiin, joissa vihjeet täyttävät lähes koko rivin.",
    "useBothDirections": "Käytä molempia suuntia",
    "progressInOneDirection": "Edistyminen yhteen suuntaan usein auttaa avaamaan logiikkaa toiseen suuntaan.",
    "markYourEmptySpaces": "Merkitse tyhjät paikat",
    "useARedX": "Käytä punaista X-merkkiä tyhjiin ruutuihin pysyäksesi järjestyksessä.",
    "countCarefully": "Laske huolellisesti",
    "separateNumbersMeanDifferentGroups": "Erilliset numerot tarkoittavat eri ryhmiä, joiden välissä on vähintään yksi välilyönti.",
    "largeNumberClues": "Työstä reunat",
    "largeNumberCluesDescription": "Suuret lukuvihjeet saattavat sopia vain rajoitetusti – käytä tätä eduksesi.",
    "stayOrganized": "Pysy järjestyksessä",
    "stayOrganizedDescription": "Silmäile ruudukkoa usein; edistyminen yhdellä alueella voi paljastaa vihjeitä muilla.",
    "dontGuess": "Älä arvaa",
    "dontGuessDescription": "Pysy loogisessa linjassa – vältä kokeilua ja erehdystä aina kun mahdollista.",
    "howToSolveNonogramDescription": "Nonogrammit ovat logiikkapohjaisia pulmia, joissa täytetään ruudukon neliöitä käyttämällä kullekin riville ja sarakkeelle annettuja vihjeitä. Nämä vihjeet ovat numeroita, jotka kertovat, kuinka monta täytettyä palikkaa rivillä on ja missä järjestyksessä. Esimerkiksi vihje \"4 1\" tarkoittaa, että täytettyjä neliöitä on neljä ja niiden jälkeen yksi täytetty neliö, ja ryhmien välissä on vähintään yksi tyhjä kohta. Tavoitteenasi on selvittää, minne täytetyt palikat menevät, käyttämällä loogista päättelyä ja tarkastelemalla sekä vaakasuuntaisia että pystysuuntaisia vihjeitä yhdessä.",
    "howToSolveNonogramInstructions": "Aloita ratkaiseminen etsimällä rivejä tai sarakkeita, joissa vihjeet vievät suuren osan rivistä, koska ne on yleensä helpoin täyttää ensin. Käytä oppimaasi päivittääksesi muita rivejä ja sarakkeita edetessäsi. Ehdottomasti tyhjät ruudut tulisi merkitä punaisella \"X\":llä virheiden välttämiseksi ja jäljellä olevien vaihtoehtojen selventämiseksi. Vähitellen täyttämällä vahvistettuja ruutuja ja merkitsemällä tyhjiä ruutuja, pääset kohti täydellistä ja yhtenäistä ruudukkoa.",
    "darkMode": "Tumma tila",
    "lightMode": "Valotila",
    "todaysPuzzle": "Tämän päivän palapeli",
    "playNow": "Pelaa nyt",
    "contactMessages": "Viestit",
    "dailyPuzzleArchive": "Päivittäinen pulma-arkisto",
    "previous": "Edellinen",
    "next": "Seuraava",
    "noPuzzlesFound": "Tälle kuukaudelle ei löytynyt päivittäisiä pulmia.",
    "nonogram": "Nonogrammi",
    "sudoku": "Sudoku",
    "playNonogramDailyToday": "Pelaa Nonogramia päivittäin tänään!",
    "playSudokuDailyToday": "Pelaa Sudokua päivittäin tänään!"
  },
  "fr": {
    "timeRecorded": "Votre temps a été enregistré !",
    "dailyNonogramFor": "Nonogramme quotidien pour",
    "privacyPolicy": "politique de confidentialité",
    "termsOfService": "Conditions d'utilisation",
    "account": "Compte",
    "username": "Nom d'utilisateur",
    "password": "Mot de passe",
    "oldPassword": "Ancien mot de passe",
    "loading": "Chargement",
    "login": "S'identifier",
    "noAccount": "Vous n'avez pas de compte?",
    "createAccount": "Inscrivez-vous ici",
    "required": "Champs obligatoires",
    "loggedIn": "Vous êtes authentifié!",
    "logout": "Connectez - Out",
    "loggedOut": "Vous êtes maintenant déconnecté",
    "returnToPuzzles": "Retour aux puzzles",
    "changePassword": "Changer le mot de passe",
    "settings": "Réglages",
    "settingsUpdated": "Paramètres mis à jour",
    "register": "registre",
    "forgotYourPassword": "Mot de passe oublié?",
    "resetPassword": "Réinitialisez votre mot de passe",
    "email": "Email",
    "confirmPassword": "Confirmez le mot de passe",
    "passwordUpdated": "Mot de passe mis à jour",
    "passwordsMustMatch": "les mots de passe doivent correspondre",
    "haveAnAccount": "Vous avez déjà un compte?",
    "ajaxError": "Il y avait un problème. Réessayez plus tard",
    "language": "La langue",
    "size": "Taille",
    "save": "sauvegarder",
    "invalidEmail": "Fournir un email valide",
    "sendingEmail": "Envoi d'email",
    "resetEmailSent": "Vérifiez votre email pour le lien pour réinitialiser votre mot de passe.",
    "ad": "Publicité",
    "nonogramPuzzle": "Puzzle de Nonogram",
    "goodLuck": "Bonne chance!",
    "errorFound": "Erreurs trouvées",
    "correct": "Correct!!",
    "startOver": "Recommencer",
    "showCorrect": "Afficher les lignes/colonnes correctes",
    "checkIt": "Vérifie ça",
    "newNonogram": "Nouveau nonogramme",
    "topTimesFor": "Meilleurs temps pour {taille} x {taille}",
    "noTimes": "Pas de temps à montrer",
    "user": "Utilisateur",
    "time": "Temps",
    "puzzle": "Puzzle",
    "nonogramSizes": "Tailles Nonogram",
    "contactMe": "Contactez moi",
    "howToSolve": "Comment résoudre",
    "topTimes": "Meilleurs temps",
    "languages": "Les langues",
    "yourName": "votre nom",
    "yourEmail": "Votre email",
    "message": "Message",
    "sendingMessage": "Envoi du message",
    "sendMessage": "Envoyer le message",
    "sentMessage": "Message envoyé",
    "bulgarian": "bulgare",
    "czech": "tchèque",
    "danish": "danois",
    "german": "allemand",
    "greek": "grec",
    "english": "Anglais",
    "spanish": "Espanol",
    "estonian": "estonien",
    "finnish": "finlandais",
    "french": "français",
    "hebrew": "hébreu",
    "croatian": "croate",
    "hungarian": "hongrois",
    "italian": "italien",
    "japanese": "Japonais",
    "korean": "coréen",
    "norwegian": "norvégien",
    "dutch": "néerlandais",
    "polish": "polonais",
    "portuguese": "Portugais",
    "romanian": "roumain",
    "russian": "russe",
    "slovak": "slovaque",
    "slovenian": "slovène",
    "serbian": "serbe",
    "swedish": "suédois",
    "turkish": "turc",
    "vietnamese": "vietnamien",
    "chinese": "chinois",
    "howToSolveNonogram": "Comment résoudre un nonogramme",
    "objective": "Objectif",
    "nonoObjective": "Le but du jeu est de remplir la grille avec des carrés noirs afin que les nombres de carrés séquentiels remplis correspondent aux chiffres en haut et à gauche.",
    "controls": "Les contrôles",
    "nonoControlsLeft": "Clic gauche pour marquer un carré comme sur (noir) ou inconnu (blanc).",
    "nonoControlsRight": "Cliquez avec le bouton droit pour marquer un carré comme étant désactivé (X rouge) ou inconnu (blanc).",
    "nonoControlsTouch": "Touchez pour faire défiler un carré allumé (noir), désactivé (X rouge) ou inconnu (blanc).",
    "nonoControlsDrag": "Faire glisser fonctionne pour les trois éléments ci-dessus.",
    "freecell": "Cellule libre",
    "metaDescription": "Nonogrammes en ligne. Plus de 500 000 puzzles en 29 langues.",
    "metaKeywords": "nonogramme, nonogrammes, image, puzzle, plaques de cuisson, plaque de cuisson, picross",
    "mobileApps": "Application mobile",
    "dailyArchive": "Archive",
    "day": "Jour",
    "fastestTime": "Temps le plus rapide",
    "name": "Nom",
    "created": "Créé",
    "markAsRead": "Marquer comme lu",
    "dontMissTodaysPuzzle": "Ne manquez pas le puzzle d'aujourd'hui !",
    "playToday": "Jouez aujourd'hui",
    "dismiss": "Rejeter",
    "neverShowAgain": "Ne plus jamais montrer",
    "tipsAndTricks": "Conseils et astuces pour résoudre les nonogrammes",
    "startWithTheObvious": "Commençons par l'évidence",
    "focusOnRowsOrColumns": "Concentrez-vous sur les lignes ou les colonnes où les indices remplissent presque toute la ligne.",
    "useBothDirections": "Utiliser les deux sens",
    "progressInOneDirection": "Les progrès dans une direction aident souvent à débloquer la logique dans l’autre.",
    "markYourEmptySpaces": "Marquez vos espaces vides",
    "useARedX": "Utilisez un « X » rouge sur les cases vides confirmées pour rester organisé.",
    "countCarefully": "Comptez soigneusement",
    "separateNumbersMeanDifferentGroups": "Des numéros séparés signifient des groupes différents avec au moins un espace entre eux.",
    "largeNumberClues": "Travailler les bords",
    "largeNumberCluesDescription": "Un grand nombre d'indices ne peuvent s'intégrer que de manière limitée : utilisez cela à votre avantage.",
    "stayOrganized": "Restez organisé",
    "stayOrganizedDescription": "Parcourez souvent la grille ; les progrès dans un domaine peuvent révéler des indices dans d’autres.",
    "dontGuess": "Ne devinez pas",
    "dontGuessDescription": "Restez fidèle à la logique : évitez les essais et les erreurs lorsque cela est possible.",
    "howToSolveNonogramDescription": "Les nonogrammes sont des jeux de logique où vous remplissez des cases d'une grille à l'aide d'indices fournis pour chaque ligne et colonne. Ces indices sont des nombres qui indiquent le nombre de blocs remplis sur une ligne et leur ordre. Par exemple, un indice « 4 1 » signifie qu'il y a quatre cases remplies suivies d'une case remplie, avec au moins un espace vide entre les groupes. Votre objectif est de trouver où vont ces blocs remplis en appliquant un raisonnement logique et en considérant les indices horizontaux et verticaux ensemble.",
    "howToSolveNonogramInstructions": "Pour commencer à résoudre, recherchez les lignes ou les colonnes où les indices occupent une grande partie de la ligne, car ce sont généralement les plus faciles à remplir en premier. Au fur et à mesure de votre progression, utilisez ce que vous avez appris pour mettre à jour les autres lignes et colonnes. Les espaces vides doivent être marqués d'un « X » rouge afin d'éviter les erreurs et de clarifier les options restantes. Progressivement, en remplissant les cases confirmées et en cochant les cases vides, vous progresserez vers une grille complète et cohérente.",
    "darkMode": "Mode sombre",
    "lightMode": "Mode lumière",
    "todaysPuzzle": "Le puzzle d'aujourd'hui",
    "playNow": "Jouer maintenant",
    "contactMessages": "Messages",
    "dailyPuzzleArchive": "Archives des puzzles quotidiens",
    "previous": "Précédent",
    "next": "Suivant",
    "noPuzzlesFound": "Aucun puzzle quotidien trouvé pour ce mois-ci.",
    "nonogram": "Nonogramme",
    "sudoku": "Sudoku",
    "playNonogramDailyToday": "Jouez au Nonogram Daily dès aujourd'hui !",
    "playSudokuDailyToday": "Jouez au Sudoku Daily dès aujourd'hui !"
  },
  "he": {
    "timeRecorded": "הזמן שלך נרשם!",
    "dailyNonogramFor": "נונוגרם יומי עבור",
    "privacyPolicy": "מדיניות פרטיות",
    "termsOfService": "תנאי השירות",
    "account": "חשבון",
    "username": "שם משתמש",
    "password": "סיסמה",
    "oldPassword": "סיסמה ישנה",
    "loading": "טוען",
    "login": "התחברות",
    "noAccount": "אין לך חשבון?",
    "createAccount": "הירשם כאן",
    "required": "נדרש",
    "loggedIn": "אתה מחובר!",
    "logout": "להתנתק",
    "loggedOut": "אתה עכשיו מנותק",
    "returnToPuzzles": "לחזור פאזלים",
    "changePassword": "שנה סיסמא",
    "settings": "הגדרות",
    "settingsUpdated": "ההגדרות עודכנו",
    "register": "הירשם",
    "forgotYourPassword": "שכחת ססמה?",
    "resetPassword": "לאפס את הסיסמה שלך",
    "email": "דוא\"ל",
    "confirmPassword": "אשר סיסמה",
    "passwordUpdated": "הסיסמה עודכנה",
    "passwordsMustMatch": "הססמאות חייבות להיות זהות",
    "haveAnAccount": "כבר יש לך חשבון?",
    "ajaxError": "הייתה בעיה. נסה שוב מאוחר יותר",
    "language": "שפה",
    "size": "גודל",
    "save": "להציל",
    "invalidEmail": "ספק דוא\"ל חוקי",
    "sendingEmail": "שולח דוא\"ל",
    "resetEmailSent": "בדוק את הדוא\"ל שלך לקבלת הקישור לאיפוס הסיסמה.",
    "ad": "פרסומת",
    "nonogramPuzzle": "פאזל Nonogram",
    "goodLuck": "בהצלחה!",
    "errorFound": "נמצאו שגיאות",
    "correct": "נכון!!",
    "startOver": "להתחיל מחדש",
    "showCorrect": "הצג שורות/קולות נכונות",
    "checkIt": "בדוק את זה",
    "newNonogram": "חדש Nonogram",
    "topTimesFor": "הזמנים המובילים עבור {size} x {size}",
    "noTimes": "אין זמן להציג",
    "user": "משתמש",
    "time": "זמן",
    "puzzle": "פאזל",
    "nonogramSizes": "גדלי Nonogram",
    "contactMe": "צור איתי קשר",
    "howToSolve": "איך לפתור",
    "topTimes": "טיימס מובילים",
    "languages": "שפות",
    "yourName": "השם שלך",
    "yourEmail": "האימייל שלך",
    "message": "הודעה",
    "sendingMessage": "לשלוח הודעה",
    "sendMessage": "לשלוח הודעה",
    "sentMessage": "הודעה נשלחה",
    "bulgarian": "בולגרית",
    "czech": "צ'כית",
    "danish": "דנית",
    "german": "גרמנית",
    "greek": "יווני",
    "english": "אנגלית",
    "spanish": "ספרדית",
    "estonian": "אסטונית",
    "finnish": "פינית",
    "french": "צרפתית",
    "hebrew": "עברית",
    "croatian": "קרואטית",
    "hungarian": "הונגרית",
    "italian": "איטלקית",
    "japanese": "יפנית",
    "korean": "קוריאנית",
    "norwegian": "נורווגית",
    "dutch": "הולנדית",
    "polish": "פולני",
    "portuguese": "פורטוגזית",
    "romanian": "רומנית",
    "russian": "רוסית",
    "slovak": "סלובקית",
    "slovenian": "סלובנית",
    "serbian": "סרבית",
    "swedish": "שוודית",
    "turkish": "טורקי",
    "vietnamese": "ויאטנמית",
    "chinese": "סינית",
    "howToSolveNonogram": "כיצד לפתור Nonogram",
    "objective": "המטרה",
    "nonoObjective": "מטרת המשחק היא למלא את הרשת עם ריבועים שחורים, כך מספרים של ריבועים רציפים מלאים להתאים את המספרים בחלק העליון והשמאלי.",
    "controls": "פקדים",
    "nonoControlsLeft": "לחץ שמאלה כדי לסמן ריבוע על (שחור) או לא ידוע (לבן).",
    "nonoControlsRight": "לחץ לחיצה ימנית כדי לסמן ריבוע כבוי (אדום X) או לא ידוע (לבן).",
    "nonoControlsTouch": "גע כדי לסובב ריבוע כמו על (שחור), כבוי (אדום X), או לא ידוע (לבן).",
    "nonoControlsDrag": "גרירת עובד עבור כל שלושת האמור לעיל.",
    "freecell": "פרייסל",
    "metaDescription": "Nonograms מקוון. מעל 500,000 חידות ב 29 שפות.",
    "metaKeywords": "nonogram, nonograms, תמונה, פאזל, מגשנים, מגש, פיקרוס",
    "mobileApps": "אפליקציות סלולריות",
    "dailyArchive": "ארכיון",
    "day": "יְוֹם",
    "fastestTime": "הזמן המהיר ביותר",
    "name": "שֵׁם",
    "created": "נוצר",
    "markAsRead": "סמן כנקרא",
    "dontMissTodaysPuzzle": "אל תפספסו את חידת היום!",
    "playToday": "שחק היום",
    "dismiss": "לְפַטֵר",
    "neverShowAgain": "לעולם לא להראות שוב",
    "tipsAndTricks": "טיפים וטריקים לפתרון נונוגרמות",
    "startWithTheObvious": "תתחילו עם הברור מאליו",
    "focusOnRowsOrColumns": "התמקדו בשורות או בעמודות שבהן הרמזים כמעט ממלאים את כל השורה.",
    "useBothDirections": "השתמש בשני הכיוונים",
    "progressInOneDirection": "התקדמות בכיוון אחד לעיתים קרובות מסייעת לפתח היגיון בכיוון השני.",
    "markYourEmptySpaces": "סמנו את החללים הריקים שלכם",
    "useARedX": "השתמשו ב-\"X\" אדום על ריבועים ריקים שאושרו כדי להישאר מאורגנים.",
    "countCarefully": "ספרו בזהירות",
    "separateNumbersMeanDifferentGroups": "מספרים נפרדים מתייחסים לקבוצות שונות עם לפחות רווח אחד ביניהן.",
    "largeNumberClues": "עבדו את הקצוות",
    "largeNumberCluesDescription": "רמזים במספרים גדולים עשויים להתאים רק בדרכים מוגבלות - נצלו זאת לטובתכם.",
    "stayOrganized": "הישארו מאורגנים",
    "stayOrganizedDescription": "סרוק את הרשת לעתים קרובות; התקדמות בתחום אחד עשויה לחשוף רמזים בתחום אחר.",
    "dontGuess": "אל תנחש",
    "dontGuessDescription": "היצמדו להיגיון - הימנעו מניסוי וטעייה במידת האפשר.",
    "howToSolveNonogramDescription": "נונוגרמות הן פאזלים מבוססי לוגיקה שבהם ממלאים ריבועים על גבי רשת באמצעות רמזים המסופקים לכל שורה ועמודה. רמזים אלה הם מספרים המציינים כמה בלוקים מלאים יש באותה שורה ובאיזה סדר. לדוגמה, רמז של \"4 1\" פירושו שיש ארבעה ריבועים מלאים ואחריהם ריבוע אחד מלא, עם לפחות רווח ריק אחד בין הקבוצות. המטרה היא להבין לאן הולכים הבלוקים המלאים הללו על ידי יישום חשיבה לוגית והתחשבות ברמזים האופקיים והאנכיים יחד.",
    "howToSolveNonogramInstructions": "כדי להתחיל בפתרון, חפשו שורות או עמודות שבהן הרמזים תופסים חלק גדול מהשורה, מכיוון שאלו בדרך כלל הכי קל למלא ראשונים. ככל שתתקדמו, השתמשו במה שלמדתם כדי לעדכן שורות ועמודות אחרות. חללים שהם בהחלט ריקים צריכים להיות מסומנים ב-\"X\" אדום כדי לסייע במניעת שגיאות ולהבהיר את האפשרויות הנותרות. בהדרגה, על ידי מילוי משבצות מאושרות וסימון משבצות ריקות, תתקדמו לעבר טבלה שלמה ועקבית.",
    "darkMode": "מצב כהה",
    "lightMode": "מצב תאורה",
    "todaysPuzzle": "הפאזל של היום",
    "playNow": "שחק עכשיו",
    "contactMessages": "הודעות",
    "dailyPuzzleArchive": "ארכיון פאזלים יומי",
    "previous": "קוֹדֵם",
    "next": "הַבָּא",
    "noPuzzlesFound": "לא נמצאו פאזלים יומיים לחודש זה.",
    "nonogram": "נונוגרם",
    "sudoku": "סודוקו",
    "playSudokuDailyToday": "שחקו סודוקו יומי היום!",
    "playNonogramDailyToday": "שחקו ב-Nonogram Daily היום!"
  },
  "hr": {
    "timeRecorded": "Vaše vrijeme je zabilježeno!",
    "dailyNonogramFor": "Dnevni nonogram za",
    "privacyPolicy": "Pravila o privatnosti",
    "termsOfService": "Uvjeti pružanja usluge",
    "account": "Račun",
    "username": "Korisničko ime",
    "password": "Zaporka",
    "oldPassword": "Stara lozinka",
    "loading": "Učitavam",
    "login": "Prijaviti se",
    "noAccount": "Nemate račun?",
    "createAccount": "Registrirajte se ovdje",
    "required": "Potreban",
    "loggedIn": "Prijavljeni ste!",
    "logout": "Odjaviti se",
    "loggedOut": "Sada ste odjavljeni",
    "returnToPuzzles": "Vratite se zagonetkama",
    "changePassword": "Promijeni zaporku",
    "settings": "postavke",
    "settingsUpdated": "Postavke ažurirane",
    "register": "Registrirajte se",
    "forgotYourPassword": "Zaboravili ste zaporku?",
    "resetPassword": "Vraćanje izvorne lozinke",
    "email": "E-mail",
    "confirmPassword": "Potvrdi lozinku",
    "passwordUpdated": "Ažurirana zaporka",
    "passwordsMustMatch": "lozinka mora odgovarati",
    "haveAnAccount": "Već imate račun?",
    "ajaxError": "Došlo je do problema. Pokušajte ponovno kasnije",
    "language": "Jezik",
    "size": "Veličina",
    "save": "Uštedjeti",
    "invalidEmail": "Unesite valjanu e-poštu",
    "sendingEmail": "Slanje e-pošte",
    "resetEmailSent": "Provjerite vezu e-pošte za poništavanje zaporke.",
    "ad": "Oglas",
    "nonogramPuzzle": "Nonogram Puzzle",
    "goodLuck": "Sretno!",
    "errorFound": "Pronađene pogreške",
    "correct": "Ispravan !!",
    "startOver": "Početi ispočetka",
    "showCorrect": "Prikaži ispravne retke/stupce",
    "checkIt": "Provjeriti",
    "newNonogram": "Novi Nonogram",
    "topTimesFor": "Prva vremena za {size} x {size}",
    "noTimes": "Nema vremena za pokazivanje",
    "user": "Korisnik",
    "time": "Vrijeme",
    "puzzle": "Puzzle",
    "nonogramSizes": "Veličine Nonogram",
    "contactMe": "Kontaktiraj me",
    "howToSolve": "Kako riješiti problem",
    "topTimes": "Top Times",
    "languages": "Jezici",
    "yourName": "Tvoje ime",
    "yourEmail": "Tvoj email",
    "message": "Poruka",
    "sendingMessage": "Slanje poruke",
    "sendMessage": "Pošalji poruku",
    "sentMessage": "Poruka je poslana",
    "bulgarian": "bugarski",
    "czech": "češki",
    "danish": "danski",
    "german": "njemački",
    "greek": "grčki",
    "english": "Engleski",
    "spanish": "španjolski",
    "estonian": "estonski",
    "finnish": "finski",
    "french": "francuski",
    "hebrew": "hebrejski",
    "croatian": "Hrvatski",
    "hungarian": "madžarski",
    "italian": "talijanski",
    "japanese": "japanski",
    "korean": "korejski",
    "norwegian": "norveški",
    "dutch": "Nizozemac",
    "polish": "Polirati",
    "portuguese": "Portugalski",
    "romanian": "rumunski",
    "russian": "ruski",
    "slovak": "slovački",
    "slovenian": "Slovenac",
    "serbian": "srpski",
    "swedish": "švedski",
    "turkish": "turski",
    "vietnamese": "vijetnamski",
    "chinese": "kineski",
    "howToSolveNonogram": "Kako riješiti Nonogram",
    "objective": "Cilj",
    "nonoObjective": "Cilj igre je ispuniti rešetku crnim kvadratima tako da se broj ispunjenih sekvencijalnih kvadrata podudara s brojevima na vrhu i lijevo.",
    "controls": "kontrole",
    "nonoControlsLeft": "Lijevi klik označite kvadratom na (crno) ili nepoznato (bijelo).",
    "nonoControlsRight": "Desnim klikom označite kvadrat kao isključen (crveni X) ili nepoznati (bijeli).",
    "nonoControlsTouch": "Dodirnite za kruženje kvadrata kao on (crno), isključeno (crveno X) ili nepoznato (bijelo).",
    "nonoControlsDrag": "Povlačenje radi za sva tri gore navedena.",
    "freecell": "FreeCell",
    "metaDescription": "Nonogrami na mreži. Preko 500 000 zagonetki na 29 jezika.",
    "metaKeywords": "nonogram, nonograms, slika, puzzle, griddlers, griddler, picross",
    "mobileApps": "Mobilne aplikacije",
    "dailyArchive": "Arhiva",
    "day": "Dan",
    "fastestTime": "Najbrže vrijeme",
    "name": "Ime",
    "created": "Izrađeno",
    "markAsRead": "Označi kao pročitano",
    "dontMissTodaysPuzzle": "Ne propustite današnju zagonetku!",
    "playToday": "Igraj danas",
    "dismiss": "Odbaciti",
    "neverShowAgain": "Nikad više ne prikazuj",
    "tipsAndTricks": "Savjeti i trikovi za rješavanje nonograma",
    "startWithTheObvious": "Počnite s očitim",
    "focusOnRowsOrColumns": "Usredotočite se na retke ili stupce gdje tragovi gotovo ispunjavaju cijeli redak.",
    "useBothDirections": "Koristite oba smjera",
    "progressInOneDirection": "Napredak u jednom smjeru često pomaže otključati logiku u drugom.",
    "markYourEmptySpaces": "Označite svoja prazna mjesta",
    "useARedX": "Koristite crveni \"X\" na potvrđenim praznim kvadratićima kako biste ostali organizirani.",
    "countCarefully": "Pažljivo brojite",
    "separateNumbersMeanDifferentGroups": "Odvojeni brojevi označavaju različite grupe s barem jednim razmakom između njih.",
    "largeNumberClues": "Obradite rubove",
    "largeNumberCluesDescription": "Veliki broj tragova može odgovarati samo na ograničene načine - iskoristite to u svoju korist.",
    "stayOrganized": "Ostanite organizirani",
    "stayOrganizedDescription": "Često skenirajte mrežu; napredak u jednom području može otkriti tragove u drugima.",
    "dontGuess": "Ne pogađaj",
    "dontGuessDescription": "Držite se logike - izbjegavajte pokušaje i pogreške kad god je to moguće.",
    "howToSolveNonogramDescription": "Nonogrami su logičke zagonetke u kojima popunjavate kvadrate na mreži koristeći tragove za svaki redak i stupac. Ti tragovi su brojevi koji vam govore koliko se ispunjenih blokova nalazi u tom retku i kojim redoslijedom. Na primjer, trag \"4 1\" znači da postoje četiri ispunjena kvadrata iza kojih slijedi jedan ispunjeni kvadrat, s barem jednim praznim prostorom između grupa. Vaš je cilj shvatiti kamo idu ti ispunjeni blokovi primjenom logičkog razmišljanja i uzimajući u obzir i horizontalne i vertikalne tragove zajedno.",
    "howToSolveNonogramInstructions": "Za početak rješavanja, potražite retke ili stupce u kojima tragovi zauzimaju veliki dio retka, jer ih je obično najlakše prvo popuniti. Kako napredujete, koristite ono što ste naučili za ažuriranje ostalih redaka i stupaca. Prazna mjesta trebaju biti označena crvenim \"X\" kako biste izbjegli pogreške i razjasnili preostale mogućnosti. Postupno, popunjavanjem potvrđenih kvadrata i označavanjem praznih, napredovat ćete prema dovršenoj i dosljednoj mreži.",
    "darkMode": "Tamni način rada",
    "lightMode": "Svjetlosni način rada",
    "todaysPuzzle": "Današnja zagonetka",
    "playNow": "Igraj sada",
    "contactMessages": "Poruke",
    "dailyPuzzleArchive": "Dnevna arhiva zagonetki",
    "previous": "Prethodno",
    "next": "Sljedeći",
    "noPuzzlesFound": "Nisu pronađene dnevne zagonetke za ovaj mjesec.",
    "nonogram": "Nonogram",
    "sudoku": "Sudoku",
    "playNonogramDailyToday": "Igrajte Nonogram Daily već danas!",
    "playSudokuDailyToday": "Igrajte Sudoku Daily već danas!"
  },
  "hu": {
    "timeRecorded": "Az idődet rögzítettük!",
    "dailyNonogramFor": "Napi nonogram",
    "privacyPolicy": "Adatvédelmi irányelvek",
    "termsOfService": "Szolgáltatási feltételek",
    "account": "számla",
    "username": "Felhasználónév",
    "password": "Jelszó",
    "oldPassword": "Régi jelszó",
    "loading": "Betöltés",
    "login": "Belépés",
    "noAccount": "Nincs fiókod?",
    "createAccount": "Itt regisztrálj",
    "required": "Kívánt",
    "loggedIn": "Ön bejelentkezett!",
    "logout": "Kijelentkezés",
    "loggedOut": "Most kijelentkezett",
    "returnToPuzzles": "Vissza a rejtvényekhez",
    "changePassword": "Jelszó módosítása",
    "settings": "Beállítások",
    "settingsUpdated": "Beállítások frissítve",
    "register": "Regisztráció",
    "forgotYourPassword": "Elfelejtette a jelszavát?",
    "resetPassword": "Állítsd vissza a jelszavad",
    "email": "Email",
    "confirmPassword": "Jelszó megerősítése",
    "passwordUpdated": "Jelszó frissítve",
    "passwordsMustMatch": "a jelszavaknak egyezniük kell",
    "haveAnAccount": "Már van fiókja?",
    "ajaxError": "Probléma volt. Próbáld újra később",
    "language": "Nyelv",
    "size": "Méret",
    "save": "Mentés",
    "invalidEmail": "Adjon meg érvényes e-mailt",
    "sendingEmail": "E-mail küldése",
    "resetEmailSent": "Ellenőrizze e-mail címét a jelszó visszaállításához.",
    "ad": "Hirdetés",
    "nonogramPuzzle": "Nonogram Puzzle",
    "goodLuck": "Sok szerencsét!",
    "errorFound": "Hibák találtak",
    "correct": "Helyes!!",
    "startOver": "Elölről kezdeni",
    "showCorrect": "Helyes sorok/oszlopok megjelenítése",
    "checkIt": "Ellenőrizd",
    "newNonogram": "Új Nonogram",
    "topTimesFor": "Legnagyobb idők a {méret} x {méret} számára",
    "noTimes": "Nincs idő a megjelenítésre",
    "user": "használó",
    "time": "Idő",
    "puzzle": "Kirakós játék",
    "nonogramSizes": "Nemogramméretek",
    "contactMe": "Keress meg",
    "howToSolve": "Hogyan kell megoldani",
    "topTimes": "Top Times",
    "languages": "Nyelvek",
    "yourName": "A neved",
    "yourEmail": "Az email címed",
    "message": "Üzenet",
    "sendingMessage": "Üzenet küldése",
    "sendMessage": "Üzenet küldése",
    "sentMessage": "Üzenet elküldve",
    "bulgarian": "bolgár",
    "czech": "cseh",
    "danish": "dán",
    "german": "német",
    "greek": "görög",
    "english": "angol",
    "spanish": "spanyol",
    "estonian": "észt",
    "finnish": "finn",
    "french": "Francia",
    "hebrew": "héber",
    "croatian": "horvát",
    "hungarian": "Magyar",
    "italian": "olasz",
    "japanese": "japán",
    "korean": "koreai",
    "norwegian": "norvég",
    "dutch": "holland",
    "polish": "lengyel",
    "portuguese": "portugál",
    "romanian": "román",
    "russian": "orosz",
    "slovak": "szlovák",
    "slovenian": "szlovén",
    "serbian": "szerb",
    "swedish": "svéd",
    "turkish": "török",
    "vietnamese": "vietnami",
    "chinese": "kínai",
    "howToSolveNonogram": "Hogyan lehet megoldani egy nonogramot",
    "objective": "Célkitűzés",
    "nonoObjective": "A játék célja, hogy kitöltse a rácsot fekete négyzetekkel, hogy a kitöltött szekvenciális négyzetek száma megegyezzen a felső és a bal oldali számokkal.",
    "controls": "Controls",
    "nonoControlsLeft": "A bal egérgombbal jelölje ki a négyzetet (fekete) vagy ismeretlen (fehér).",
    "nonoControlsRight": "A jobb egérgombbal jelölje ki a négyzetet ki (piros X) vagy ismeretlen (fehér).",
    "nonoControlsTouch": "Érintse meg a négyzetet, mint a (fekete), a kikapcsolt (piros X) vagy az ismeretlen (fehér).",
    "nonoControlsDrag": "A húzás a fentiek mindháromára vonatkozik.",
    "freecell": "Admirális",
    "metaDescription": "Nonograms Online. Több mint 500 000 rejtvény 29 nyelven.",
    "metaKeywords": "nonogram, nonogram, kép, puzzle, griddlers, griddler, picross",
    "mobileApps": "Mobil alkalmazások",
    "dailyArchive": "Archívum",
    "day": "Nap",
    "fastestTime": "Leggyorsabb idő",
    "name": "Név",
    "created": "Létrehozva",
    "markAsRead": "Megjelölés olvasottként",
    "dontMissTodaysPuzzle": "Ne hagyd ki a mai rejtvényt!",
    "playToday": "Játssz ma",
    "dismiss": "Elvetés",
    "neverShowAgain": "Soha többé ne mutasd meg",
    "tipsAndTricks": "Tippek és trükkök a nonogramok megoldásához",
    "startWithTheObvious": "Kezdjük a nyilvánvalóval",
    "focusOnRowsOrColumns": "Koncentrálj azokra a sorokra vagy oszlopokra, ahol a nyomok majdnem az egész sort kitöltik.",
    "useBothDirections": "Mindkét irányt használja",
    "progressInOneDirection": "Az egyik irányba tett előrelépés gyakran segít feltárni a logikát a másik irányban.",
    "markYourEmptySpaces": "Jelöld meg az üres helyeket",
    "useARedX": "Jelölj piros „X”-szel az üres négyzeteket a rendszerezés érdekében.",
    "countCarefully": "Számolj gondosan",
    "separateNumbersMeanDifferentGroups": "A külön számok olyan különböző csoportokat jelentenek, amelyek között legalább egy szóköz van.",
    "largeNumberClues": "A szélek eldolgozása",
    "largeNumberCluesDescription": "A nagyszámú utalások csak korlátozott módon illeszkedhetnek – használd ki ezt az előnyödre.",
    "stayOrganized": "Maradj szervezett",
    "stayOrganizedDescription": "Gyakran pásztázza át a táblázatot; az egyik területen elért haladás nyomokat tárhat fel más területeken.",
    "dontGuess": "Ne találgass",
    "dontGuessDescription": "Ragaszkodj a logikához – kerüld a próbálkozásokat és a hibákat, amikor csak lehetséges.",
    "howToSolveNonogramDescription": "A nonogramok logikai alapú rejtvények, ahol egy rácson lévő négyzeteket kell kitöltened az egyes sorokhoz és oszlopokhoz tartozó nyomok segítségével. Ezek a nyomok számok, amelyek megmondják, hogy hány kitöltött blokk van az adott sorban és milyen sorrendben. Például a „4 1” nyom azt jelenti, hogy négy kitöltött négyzet van, majd egy kitöltött négyzet, és legalább egy üres hely van a csoportok között. A cél az, hogy logikus érvelés alkalmazásával és a vízszintes és függőleges nyomok együttes figyelembevételével kitaláld, hová kerülnek ezek a kitöltött blokkok.",
    "howToSolveNonogramInstructions": "A megoldás megkezdéséhez keress olyan sorokat vagy oszlopokat, ahol a nyomok a sor nagy részét foglalják el, mivel ezeket általában a legkönnyebb először kitölteni. Ahogy haladsz előre, használd fel a tanultakat a többi sor és oszlop frissítéséhez. Azokat a mezőket, amelyek biztosan üresek, piros „X”-szel kell jelölni, hogy elkerüljük a hibákat és tisztázzuk a fennmaradó lehetőségeket. Fokozatosan, a megerősített négyzetek kitöltésével és az üresek bejelölésével haladsz egy teljes és egységes rács felé.",
    "darkMode": "Sötét mód",
    "lightMode": "Világos mód",
    "todaysPuzzle": "Mai rejtvény",
    "playNow": "Játssz most",
    "contactMessages": "Üzenetek",
    "dailyPuzzleArchive": "Napi Rejtvény Archívum",
    "previous": "Előző",
    "next": "Következő",
    "noPuzzlesFound": "Nincsenek napi rejtvények ebben a hónapban.",
    "nonogram": "Nonogram",
    "playSudokuDailyToday": "Játssz Sudoku-t naponta még ma!",
    "playNonogramDailyToday": "Játssz a Nonogrammal naponta még ma!",
    "sudoku": "Szúdoku"
  },
  "it": {
    "timeRecorded": "Il tuo tempo è stato registrato!",
    "dailyNonogramFor": "Nonogramma giornaliero per",
    "privacyPolicy": "politica sulla riservatezza",
    "termsOfService": "Termini di servizio",
    "account": "account",
    "username": "Nome utente",
    "password": "Parola d'ordine",
    "oldPassword": "Vecchia password",
    "loading": "Caricamento in corso",
    "login": "Accesso",
    "noAccount": "Non hai un account?",
    "createAccount": "Registrati qui",
    "required": "necessario",
    "loggedIn": "Ti sei autenticato!",
    "logout": "Disconnettersi",
    "loggedOut": "Ora siete disconnessi",
    "returnToPuzzles": "Ritorna ai puzzle",
    "changePassword": "Cambia la password",
    "settings": "impostazioni",
    "settingsUpdated": "Impostazioni aggiornate",
    "register": "Registrare",
    "forgotYourPassword": "Hai dimenticato la password?",
    "resetPassword": "Reimposta la tua password",
    "email": "E-mail",
    "confirmPassword": "Conferma password",
    "passwordUpdated": "Password aggiornata",
    "passwordsMustMatch": "Le password devono essere identiche",
    "haveAnAccount": "Hai già un account?",
    "ajaxError": "C'era un problema. Riprovare più tardi",
    "language": "linguaggio",
    "size": "Taglia",
    "save": "Salvare",
    "invalidEmail": "Fornire un'e-mail valida",
    "sendingEmail": "Invio di email",
    "resetEmailSent": "Controlla la tua email per il link per reimpostare la password.",
    "ad": "Annuncio pubblicitario",
    "nonogramPuzzle": "Puzzle Nonogram",
    "goodLuck": "In bocca al lupo!",
    "errorFound": "Errori trovati",
    "correct": "Corretta!!",
    "startOver": "Ricominciare",
    "showCorrect": "Mostra righe/colonne corrette",
    "checkIt": "Controllalo",
    "newNonogram": "Nuovo nonogramma",
    "topTimesFor": "I tempi migliori per {size} x {size}",
    "noTimes": "Non c'è tempo da mostrare",
    "user": "Utente",
    "time": "Tempo",
    "puzzle": "Puzzle",
    "nonogramSizes": "Dimensioni nonogram",
    "contactMe": "Contattami",
    "howToSolve": "Come risolvere",
    "topTimes": "I tempi migliori",
    "languages": "Le lingue",
    "yourName": "Il tuo nome",
    "yourEmail": "La tua email",
    "message": "Messaggio",
    "sendingMessage": "Invio di messaggi",
    "sendMessage": "Invia messaggio",
    "sentMessage": "Messaggio inviato",
    "bulgarian": "bulgaro",
    "czech": "ceco",
    "danish": "danese",
    "german": "Tedesco",
    "greek": "greco",
    "english": "Inglese",
    "spanish": "spagnolo",
    "estonian": "estone",
    "finnish": "finlandese",
    "french": "francese",
    "hebrew": "ebraico",
    "croatian": "croato",
    "hungarian": "ungherese",
    "italian": "italiano",
    "japanese": "giapponese",
    "korean": "coreano",
    "norwegian": "norvegese",
    "dutch": "olandese",
    "polish": "polacco",
    "portuguese": "portoghese",
    "romanian": "rumeno",
    "russian": "russo",
    "slovak": "slovacco",
    "slovenian": "sloveno",
    "serbian": "serbo",
    "swedish": "svedese",
    "turkish": "Turco",
    "vietnamese": "vietnamita",
    "chinese": "Cinese",
    "howToSolveNonogram": "Come risolvere un nonogram",
    "objective": "Obbiettivo",
    "nonoObjective": "Lo scopo del gioco è riempire la griglia di quadrati neri in modo che i numeri dei quadrati sequenziali riempiti corrispondano ai numeri in alto ea sinistra.",
    "controls": "controlli",
    "nonoControlsLeft": "Fare clic con il tasto sinistro per contrassegnare un quadrato come attivo (nero) o sconosciuto (bianco).",
    "nonoControlsRight": "Fare clic con il tasto destro per marcare un quadrato come spento (rosso X) o sconosciuto (bianco).",
    "nonoControlsTouch": "Tocca per ciclare un quadrato come attivo (nero), spento (rosso X) o sconosciuto (bianco).",
    "nonoControlsDrag": "Trascinando funziona per tutti e tre dei precedenti.",
    "freecell": "Freecell",
    "metaDescription": "Nonogrammi online. Oltre 500.000 puzzle in 29 lingue.",
    "metaKeywords": "nonogramma, nonogrammi, immagine, puzzle, griddlers, griddler, picross",
    "mobileApps": "App mobili",
    "dailyArchive": "Archivio",
    "day": "Giorno",
    "fastestTime": "Tempo più veloce",
    "name": "Nome",
    "created": "Creato",
    "markAsRead": "Segna come letto",
    "dontMissTodaysPuzzle": "Non perdetevi il puzzle di oggi!",
    "playToday": "Gioca oggi",
    "dismiss": "Congedare",
    "neverShowAgain": "Non mostrare mai più",
    "tipsAndTricks": "Suggerimenti e trucchi per risolvere i nonogrammi",
    "startWithTheObvious": "Inizia con l'ovvio",
    "focusOnRowsOrColumns": "Concentratevi sulle righe o sulle colonne in cui gli indizi riempiono quasi l'intera riga.",
    "useBothDirections": "Utilizzare entrambe le direzioni",
    "progressInOneDirection": "Spesso il progresso in una direzione aiuta a sbloccare la logica nell'altra.",
    "markYourEmptySpaces": "Segna i tuoi spazi vuoti",
    "useARedX": "Per rimanere organizzati, usa una \"X\" rossa sui quadrati vuoti confermati.",
    "countCarefully": "Contare attentamente",
    "separateNumbersMeanDifferentGroups": "I numeri separati indicano gruppi diversi, separati almeno da uno spazio.",
    "largeNumberClues": "Lavorare i bordi",
    "largeNumberCluesDescription": "Un gran numero di indizi potrebbe essere sufficiente solo in un numero limitato di modi: sfrutta questa caratteristica a tuo vantaggio.",
    "stayOrganized": "Rimani organizzato",
    "stayOrganizedDescription": "Esamina spesso la griglia: i progressi in un'area potrebbero rivelare indizi in altre.",
    "dontGuess": "Non indovinare",
    "dontGuessDescription": "Attenetevi alla logica ed evitate, quando possibile, di procedere per tentativi ed errori.",
    "howToSolveNonogramDescription": "I nonogrammi sono rompicapo basati sulla logica in cui bisogna riempire i quadrati di una griglia utilizzando indizi forniti per ogni riga e colonna. Questi indizi sono numeri che indicano quanti blocchi pieni ci sono in quella riga e in quale ordine. Ad esempio, un indizio di \"4 1\" significa che ci sono quattro quadrati pieni seguiti da un quadrato pieno, con almeno uno spazio vuoto tra i gruppi. L'obiettivo è capire dove vanno quei blocchi pieni applicando il ragionamento logico e considerando sia gli indizi orizzontali che quelli verticali insieme.",
    "howToSolveNonogramInstructions": "Per iniziare a risolvere, cerca le righe o le colonne in cui gli indizi occupano gran parte della riga, poiché di solito sono più facili da riempire per prime. Man mano che fai progressi, usa ciò che hai imparato per aggiornare altre righe e colonne. Gli spazi sicuramente vuoti dovrebbero essere contrassegnati con una \"X\" rossa per evitare errori e chiarire le opzioni rimanenti. Gradualmente, riempiendo le caselle confermate e contrassegnando quelle vuote, lavorerai verso una griglia completa e coerente.",
    "darkMode": "Modalità scura",
    "lightMode": "Modalità luce",
    "todaysPuzzle": "Puzzle di oggi",
    "playNow": "Gioca ora",
    "contactMessages": "Messaggi",
    "dailyPuzzleArchive": "Archivio puzzle giornaliero",
    "previous": "Precedente",
    "next": "Prossimo",
    "noPuzzlesFound": "Nessun puzzle giornaliero trovato per questo mese.",
    "nonogram": "Nonogramma",
    "sudoku": "Sudoku",
    "playSudokuDailyToday": "Gioca oggi stesso al Sudoku Daily!",
    "playNonogramDailyToday": "Gioca oggi stesso al Nonogram Daily!"
  },
  "ja": {
    "timeRecorded": "あなたの時間が記録されました!",
    "dailyNonogramFor": "毎日のノノグラム",
    "privacyPolicy": "プライバシーポリシー",
    "termsOfService": "利用規約",
    "account": "アカウント",
    "username": "ユーザー名",
    "password": "パスワード",
    "oldPassword": "以前のパスワード",
    "loading": "読み込み中",
    "login": "ログイン",
    "noAccount": "アカウントを持っていませんか？",
    "createAccount": "ここに登録",
    "required": "必須",
    "loggedIn": "あなたはログインしています！",
    "logout": "ログアウト",
    "loggedOut": "あなたはログアウトしました",
    "returnToPuzzles": "パズルに戻る",
    "changePassword": "パスワードを変更する",
    "settings": "設定",
    "settingsUpdated": "設定が更新されました",
    "register": "登録",
    "forgotYourPassword": "パスワードをお忘れですか？",
    "resetPassword": "あなたのパスワードをリセット",
    "email": "Eメール",
    "confirmPassword": "パスワードを認証する",
    "passwordUpdated": "パスワード更新",
    "passwordsMustMatch": "パスワードが一致する必要があります",
    "haveAnAccount": "すでにアカウントをお持ちですか？",
    "ajaxError": "問題がありました。あとでもう一度試してみてください",
    "language": "言語",
    "size": "サイズ",
    "save": "保存する",
    "invalidEmail": "有効なメールアドレスを入力してください",
    "sendingEmail": "メールを送信する",
    "resetEmailSent": "あなたのパスワードをリセットするためのリンクをあなたのEメールでチェックしてください。",
    "ad": "広告",
    "nonogramPuzzle": "ノノグラムパズル",
    "goodLuck": "がんばろう！",
    "errorFound": "見つかったエラー",
    "correct": "正しい！！",
    "startOver": "やり直す",
    "showCorrect": "正しい行/列を表示",
    "checkIt": "それをチェック",
    "newNonogram": "新しいノノグラム",
    "topTimesFor": "{size} x {size}のトップタイム",
    "noTimes": "表示する時間はありません",
    "user": "ユーザー",
    "time": "時間",
    "puzzle": "パズル",
    "nonogramSizes": "ノノグラムサイズ",
    "contactMe": "私に連絡して",
    "howToSolve": "の解き方",
    "topTimes": "トップタイムズ",
    "languages": "言語",
    "yourName": "あなたの名前",
    "yourEmail": "あなたのEメール",
    "message": "メッセージ",
    "sendingMessage": "メッセージを送信する",
    "sendMessage": "メッセージを送る",
    "sentMessage": "送信メッセージ",
    "bulgarian": "ブルガリア語",
    "czech": "チェコ語",
    "danish": "デンマーク語",
    "german": "ドイツ人",
    "greek": "ギリシャ語",
    "english": "英語",
    "spanish": "スペイン語",
    "estonian": "エストニア語",
    "finnish": "フィンランド語",
    "french": "フランス語",
    "hebrew": "ヘブライ語",
    "croatian": "クロアチア語",
    "hungarian": "ハンガリー語",
    "italian": "イタリアの",
    "japanese": "日本人",
    "korean": "韓国語",
    "norwegian": "ノルウェー語",
    "dutch": "オランダの",
    "polish": "研磨",
    "portuguese": "ポルトガル語",
    "romanian": "ルーマニア語",
    "russian": "ロシア",
    "slovak": "スロバキア",
    "slovenian": "スロベニア語",
    "serbian": "セルビア語",
    "swedish": "スウェーデンの",
    "turkish": "トルコ語",
    "vietnamese": "ベトナム人",
    "chinese": "中国語",
    "howToSolveNonogram": "ノノグラムを解く方法",
    "objective": "目的",
    "nonoObjective": "ゲームの目的は、グリッドを黒い四角で塗りつぶして、塗りつぶされた連続する四角の数が上と下の数字と一致するようにすることです。",
    "controls": "コントロール",
    "nonoControlsLeft": "左クリックして、正方形にオン（黒）または不明（白）のマークを付けます。",
    "nonoControlsRight": "右クリックして、正方形をオフ（赤X）または不明（白）としてマークします。",
    "nonoControlsTouch": "タッチすると、四角形がオン（黒）、オフ（赤X）、または不明（白）に変わります。",
    "nonoControlsDrag": "ドラッグは上記の3つすべてに有効です。",
    "freecell": "フリーセル",
    "metaDescription": "ノノグラムオンライン。 29言語で500,000を超えるパズル。",
    "metaKeywords": "nonogram、nonograms、画像、パズル、griddlers、griddler、picross",
    "mobileApps": "モバイルアプリ",
    "dailyArchive": "アーカイブ",
    "day": "日",
    "fastestTime": "最速タイム",
    "name": "名前",
    "created": "作成",
    "markAsRead": "既読にする",
    "dontMissTodaysPuzzle": "今日のパズルを見逃さないでください！",
    "playToday": "今すぐプレイ",
    "dismiss": "却下する",
    "neverShowAgain": "二度と表示しない",
    "tipsAndTricks": "ノノグラムを解くためのヒントとコツ",
    "startWithTheObvious": "明白なことから始める",
    "focusOnRowsOrColumns": "手がかりがほぼ行全体を埋め尽くす行または列に注目してください。",
    "useBothDirections": "両方向を使用する",
    "progressInOneDirection": "一方の方向への進歩は、他の方向の論理を解き放つのに役立つことがよくあります。",
    "markYourEmptySpaces": "空きスペースをマークする",
    "useARedX": "整理された状態を保つために、確認済みの空のマス目に赤い「X」を付けます。",
    "countCarefully": "慎重に数える",
    "separateNumbersMeanDifferentGroups": "別々の数字は、間に少なくとも 1 つのスペースがある異なるグループを意味します。",
    "largeNumberClues": "エッジを加工する",
    "largeNumberCluesDescription": "大きな数字の手がかりは限られた方法でしか当てはまらない可能性があります。これを有利に利用してください。",
    "stayOrganized": "整理整頓",
    "stayOrganizedDescription": "グリッドを頻繁にスキャンしてください。1 つのエリアの進捗により、他のエリアの手がかりが明らかになる場合があります。",
    "dontGuess": "推測しないでください",
    "dontGuessDescription": "論理に従ってください。可能な場合は試行錯誤を避けてください。",
    "howToSolveNonogramDescription": "ノノグラムは、各行と各列に与えられたヒントを使ってグリッド上のマス目を埋めていく、論理的なパズルです。ヒントは数字で、その行にいくつのブロックが埋まっているか、またその順番は何かを示します。例えば、「4 1」というヒントは、4つのマス目が埋まった後に1つのマス目が続き、マス目とマス目の間には少なくとも1つの空白があることを意味します。論理的な推論を駆使し、縦と横の両方のヒントを考慮に入れて、これらのマス目がどこにあるかを推測することが目的です。",
    "howToSolveNonogramInstructions": "解き始めるには、ヒントが行の大部分を占めている行や列を探してください。通常、そこは最初に埋めるのが最も簡単です。進みながら、学んだことを活用して他の行や列を更新してください。明らかに空白のマスには赤い「X」印を付けると、間違いを防ぎ、残りの選択肢を明確にすることができます。確定したマスを埋め、空白のマスを消すことで、徐々に完成度の高い一貫性のあるグリッドへと近づいていきます。",
    "darkMode": "ダークモード",
    "lightMode": "ライトモード",
    "todaysPuzzle": "今日のパズル",
    "playNow": "今すぐプレイ",
    "contactMessages": "メッセージ",
    "dailyPuzzleArchive": "デイリーパズルアーカイブ",
    "previous": "前の",
    "next": "次",
    "noPuzzlesFound": "今月のデイリーパズルは見つかりませんでした。",
    "nonogram": "ノノグラム",
    "sudoku": "数独",
    "playNonogramDailyToday": "今日はノノグラム・デイリーをプレイしよう！",
    "playSudokuDailyToday": "今日は毎日数独に挑戦しよう！"
  },
  "ko": {
    "timeRecorded": "귀하의 시간이 기록되었습니다!",
    "dailyNonogramFor": "일일 노노그램",
    "privacyPolicy": "개인정보 보호정책",
    "termsOfService": "서비스 약관",
    "account": "계정",
    "username": "사용자 이름",
    "password": "암호",
    "oldPassword": "이전 비밀번호",
    "loading": "로딩",
    "login": "로그인",
    "noAccount": "계정이 없으십니까?",
    "createAccount": "여기에 등록하십시오",
    "required": "필수",
    "loggedIn": "로그인하셨습니다!",
    "logout": "로그 아웃",
    "loggedOut": "지금 로그 아웃되었습니다.",
    "returnToPuzzles": "퍼즐로 돌아 가기",
    "changePassword": "비밀번호 변경",
    "settings": "설정",
    "settingsUpdated": "설정이 업데이트되었습니다.",
    "register": "레지스터",
    "forgotYourPassword": "비밀번호를 잊어 버렸습니까?",
    "resetPassword": "비밀번호를 재설정",
    "email": "이메일",
    "confirmPassword": "비밀번호 확인",
    "passwordUpdated": "암호 업데이트 됨",
    "passwordsMustMatch": "비밀번호가 일치해야합니다",
    "haveAnAccount": "이미 계정이 있으십니까?",
    "ajaxError": "문제가 발생했습니다. 나중에 다시 시도하십시오.",
    "language": "언어",
    "size": "크기",
    "save": "구하다",
    "invalidEmail": "유효한 이메일 제공",
    "sendingEmail": "이메일 보내기",
    "resetEmailSent": "이메일 재설정 링크를 확인하십시오.",
    "ad": "광고",
    "nonogramPuzzle": "노 그램 퍼즐",
    "goodLuck": "행운을 빕니다!",
    "errorFound": "오류가 발견되었습니다.",
    "correct": "옳은!!",
    "startOver": "다시 시작하다",
    "showCorrect": "올바른 행/열 표시",
    "checkIt": "확인해 봐",
    "newNonogram": "새로운 노노 그램",
    "topTimesFor": "{size} x {size}의 톱 타임",
    "noTimes": "보여줄 시간이 없다.",
    "user": "사용자",
    "time": "시각",
    "puzzle": "퍼즐",
    "nonogramSizes": "노 그램 크기",
    "contactMe": "저에게 연락하십시오",
    "howToSolve": "해결 방법",
    "topTimes": "최고의 시간",
    "languages": "언어",
    "yourName": "당신의 이름",
    "yourEmail": "귀하의 이메일",
    "message": "메시지",
    "sendingMessage": "보내는 메시지",
    "sendMessage": "문자 보내",
    "sentMessage": "메시지 전송 됨",
    "bulgarian": "불가리아 사람",
    "czech": "체코 사람",
    "danish": "덴마크 말",
    "german": "독일 사람",
    "greek": "그리스 사람",
    "english": "영어",
    "spanish": "스페인 사람",
    "estonian": "에스토니아 사람",
    "finnish": "핀란드어",
    "french": "프랑스 국민",
    "hebrew": "헤브라이 사람",
    "croatian": "크로아티아 사람",
    "hungarian": "헝가리 인",
    "italian": "이탈리아 사람",
    "japanese": "일본어",
    "korean": "한국어",
    "norwegian": "노르웨이 인",
    "dutch": "네덜란드 사람",
    "polish": "광택",
    "portuguese": "포르투갈 인",
    "romanian": "루마니아 사람",
    "russian": "러시아인",
    "slovak": "슬로바키아 사람",
    "slovenian": "슬로베니아",
    "serbian": "세르비아 사람",
    "swedish": "스웨덴어",
    "turkish": "터키어",
    "vietnamese": "베트남 사람",
    "chinese": "중국말",
    "howToSolveNonogram": "노노 그램을 풀는 방법",
    "objective": "목표",
    "nonoObjective": "게임의 목적은 채워진 순차적 인 사각형의 수가 상단과 좌측의 숫자와 일치하도록 검정색 사각형으로 눈금을 채우는 것입니다.",
    "controls": "통제 수단",
    "nonoControlsLeft": "사각형을 (검정) 또는 알 수 없음 (흰색)으로 표시하려면 왼쪽 버튼을 클릭하십시오.",
    "nonoControlsRight": "사각형을 꺼짐 (빨간색 X) 또는 알 수 없음 (흰색)으로 표시하려면 마우스 오른쪽 버튼을 클릭하십시오.",
    "nonoControlsTouch": "터치하여 (검정), 꺼짐 (빨강 X) 또는 알 수 없음 (흰색)과 같은 사각형을 순환하십시오.",
    "nonoControlsDrag": "드래그는 위의 세 가지 모두에 적용됩니다.",
    "freecell": "프리셀",
    "metaDescription": "노노 그램 온라인. 29 개 언어로 된 500,000 개 이상의 퍼즐.",
    "metaKeywords": "nonogram, nonograms, 그림, 퍼즐, griddlers, griddler, picross",
    "mobileApps": "모바일 앱",
    "dailyArchive": "보관소",
    "day": "낮",
    "fastestTime": "가장 빠른 시간",
    "name": "이름",
    "created": "생성됨",
    "markAsRead": "읽음으로 표시",
    "dontMissTodaysPuzzle": "오늘의 퍼즐을 놓치지 마세요!",
    "playToday": "오늘 플레이하세요",
    "dismiss": "해고하다",
    "neverShowAgain": "다시는 보여주지 마",
    "tipsAndTricks": "노노그램 풀이 팁과 요령",
    "startWithTheObvious": "분명한 것부터 시작하세요",
    "focusOnRowsOrColumns": "단서가 줄 전체를 거의 채우는 행이나 열에 집중하세요.",
    "useBothDirections": "양방향을 사용하세요",
    "progressInOneDirection": "한 방향으로의 진전은 종종 다른 방향으로의 논리를 풀어내는 데 도움이 됩니다.",
    "markYourEmptySpaces": "빈 공간을 표시하세요",
    "useARedX": "정리된 내용을 확인하려면 빈 칸에 빨간색 \"X\"를 표시하세요.",
    "countCarefully": "신중하게 세어보세요",
    "separateNumbersMeanDifferentGroups": "숫자가 분리되어 있다는 것은 그 사이에 최소한 한 칸의 공백이 있는 서로 다른 그룹을 의미합니다.",
    "largeNumberClues": "가장자리 작업",
    "largeNumberCluesDescription": "숫자가 많은 단서는 제한된 방식으로만 적용될 수 있습니다. 이 점을 유리하게 활용하세요.",
    "stayOrganized": "조직적으로 생활하세요",
    "stayOrganizedDescription": "격자를 자주 살펴보세요. 한 분야의 진전은 다른 분야의 단서를 보여줄 수 있습니다.",
    "dontGuess": "추측하지 마세요",
    "dontGuessDescription": "논리에 충실하세요. 가능하면 시행착오를 피하세요.",
    "howToSolveNonogramDescription": "노노그램은 각 행과 열에 제공된 단서를 사용하여 격자의 사각형을 채우는 논리 기반 퍼즐입니다. 이 단서는 해당 줄에 채워진 블록이 몇 개, 그리고 어떤 순서로 있는지를 알려주는 숫자입니다. 예를 들어, \"4 1\"이라는 단서는 채워진 사각형 네 개 다음에 채워진 사각형 하나가 있고, 각 그룹 사이에 최소 한 칸의 빈칸이 있음을 의미합니다. 논리적 추론을 적용하고 가로 및 세로 단서를 모두 고려하여 채워진 블록이 어디에 있는지 알아내는 것이 목표입니다.",
    "howToSolveNonogramInstructions": "문제를 풀기 시작하려면 단서가 줄의 많은 부분을 차지하는 행이나 열을 찾으세요. 보통 그런 행이나 열은 먼저 채우기가 가장 쉽습니다. 문제를 풀면서 배운 내용을 활용하여 다른 행과 열을 업데이트하세요. 확실히 비어 있는 칸은 빨간색 \"X\"로 표시하여 오류를 방지하고 남은 선택지를 명확하게 하세요. 확인된 칸을 채우고 빈 칸을 표시하면서 점진적으로 완성되고 일관된 격자를 만들어 나가세요.",
    "darkMode": "다크 모드",
    "lightMode": "라이트 모드",
    "todaysPuzzle": "오늘의 퍼즐",
    "playNow": "지금 플레이하세요",
    "contactMessages": "메시지",
    "dailyPuzzleArchive": "일일 퍼즐 아카이브",
    "previous": "이전의",
    "next": "다음",
    "noPuzzlesFound": "이번 달에는 일일 퍼즐이 없습니다.",
    "nonogram": "노노그램",
    "sudoku": "스도쿠",
    "playSudokuDailyToday": "오늘 스도쿠 데일리를 플레이해 보세요!",
    "playNonogramDailyToday": "오늘 노노그램 데일리를 플레이해 보세요!"
  },
  "nb": {
    "timeRecorded": "Tiden din er registrert!",
    "dailyNonogramFor": "Daglig nonogram for",
    "privacyPolicy": "Personvernerklæring",
    "termsOfService": "Vilkår for bruk",
    "account": "Konto",
    "username": "Brukernavn",
    "password": "Passord",
    "oldPassword": "Gammelt passord",
    "loading": "Laster",
    "login": "Logg Inn",
    "noAccount": "Har du ikke en konto?",
    "createAccount": "Registrer her",
    "required": "Må",
    "loggedIn": "Du er logget inn!",
    "logout": "Logg ut",
    "loggedOut": "Du er nå logget ut",
    "returnToPuzzles": "Gå tilbake til puslespillene",
    "changePassword": "Bytt passord",
    "settings": "innstillinger",
    "settingsUpdated": "Innstillingene er oppdatert",
    "register": "Registrere",
    "forgotYourPassword": "Glemt passordet?",
    "resetPassword": "Tilbakestill passordet ditt",
    "email": "e-post",
    "confirmPassword": "Bekreft passord",
    "passwordUpdated": "Passord oppdatert",
    "passwordsMustMatch": "Passordene må være like",
    "haveAnAccount": "Har du allerede en konto?",
    "ajaxError": "Det var et problem. Prøv igjen senere",
    "language": "Språk",
    "size": "Størrelse",
    "save": "Lagre",
    "invalidEmail": "Gi en gyldig epost",
    "sendingEmail": "Sende e-post",
    "resetEmailSent": "Sjekk e-postadressen din for linken for å tilbakestille passordet ditt.",
    "ad": "Annonse",
    "nonogramPuzzle": "Nonogram Puzzle",
    "goodLuck": "Lykke til!",
    "errorFound": "Feil funnet",
    "correct": "Riktig!!",
    "startOver": "Begynne på nytt",
    "showCorrect": "Vis riktige rader/kolonner",
    "checkIt": "Sjekk det",
    "newNonogram": "Nytt Nonogram",
    "topTimesFor": "Topptider for {size} x {size}",
    "noTimes": "Ingen ganger å vise",
    "user": "Bruker",
    "time": "Tid",
    "puzzle": "Puslespill",
    "nonogramSizes": "Nonogram størrelser",
    "contactMe": "Kontakt meg",
    "howToSolve": "Hvordan løse",
    "topTimes": "Topptider",
    "languages": "språk",
    "yourName": "Navnet ditt",
    "yourEmail": "Din epost",
    "message": "Budskap",
    "sendingMessage": "Sende melding",
    "sendMessage": "Sende melding",
    "sentMessage": "Melding sendt",
    "bulgarian": "bulgarian",
    "czech": "Czech",
    "danish": "dansk",
    "german": "tysk",
    "greek": "gresk",
    "english": "Engelsk",
    "spanish": "spansk",
    "estonian": "estonian",
    "finnish": "finsk",
    "french": "fransk",
    "hebrew": "Hebrew",
    "croatian": "kroa~~POS=TRUNC",
    "hungarian": "ungarsk",
    "italian": "italiensk",
    "japanese": "japansk",
    "korean": "Korean",
    "norwegian": "norsk",
    "dutch": "nederlandsk",
    "polish": "Pusse",
    "portuguese": "portugisisk",
    "romanian": "rumensk",
    "russian": "russisk",
    "slovak": "slovak",
    "slovenian": "slovenian",
    "serbian": "serbisk",
    "swedish": "svensk",
    "turkish": "Turkish",
    "vietnamese": "Vietnamesisk",
    "chinese": "kinesisk",
    "howToSolveNonogram": "Slik løser du et nonogram",
    "objective": "Objektiv",
    "nonoObjective": "Formålet med spillet er å fylle rutenettet med svarte firkanter, slik at tallene fylte sekvensielle firkanter stemmer overens med tallene øverst og venstre.",
    "controls": "kontroller",
    "nonoControlsLeft": "Venstre klikk for å markere et firkant som på (svart) eller ukjent (hvitt).",
    "nonoControlsRight": "Høyreklikk for å markere en firkant som av (rød X) eller ukjent (hvit).",
    "nonoControlsTouch": "Berør for å sykle et firkant som på (svart), av (rødt) eller ukjent (hvit).",
    "nonoControlsDrag": "Trenger arbeid for alle tre av de ovennevnte.",
    "freecell": "Freecell",
    "metaDescription": "Nonograms online. Over 500 000 gåter på 29 språk.",
    "metaKeywords": "nonogram, nonograms, bilde, puslespill, griddlers, griddler, picross",
    "mobileApps": "Mobilapper",
    "dailyArchive": "Arkiv",
    "day": "Dag",
    "fastestTime": "Raskeste tid",
    "name": "Navn",
    "created": "Opprettet",
    "markAsRead": "Merk som lest",
    "dontMissTodaysPuzzle": "Ikke gå glipp av dagens puslespill!",
    "playToday": "Spill i dag",
    "dismiss": "Avskjedige",
    "neverShowAgain": "Vis aldri igjen",
    "tipsAndTricks": "Tips og triks for å løse nonogrammer",
    "startWithTheObvious": "Start med det åpenbare",
    "focusOnRowsOrColumns": "Fokuser på rader eller kolonner der ledetrådene nesten fyller hele linjen.",
    "useBothDirections": "Bruk begge retninger",
    "progressInOneDirection": "Fremgang i én retning bidrar ofte til å åpne for logikk i den andre.",
    "markYourEmptySpaces": "Merk dine tomme plasser",
    "useARedX": "Bruk en rød «X» på bekreftede tomme ruter for å holde orden.",
    "countCarefully": "Tell nøye",
    "separateNumbersMeanDifferentGroups": "Separate tall betyr forskjellige grupper med minst ett mellomrom mellom dem.",
    "largeNumberClues": "Arbeid kantene",
    "largeNumberCluesDescription": "Ledetråder med store tall passer kanskje bare på begrensede måter – bruk dette til din fordel.",
    "stayOrganized": "Hold deg organisert",
    "stayOrganizedDescription": "Skann rutenettet ofte; fremgang på ett område kan avsløre ledetråder på andre.",
    "dontGuess": "Ikke gjett",
    "dontGuessDescription": "Hold deg til logikken – unngå prøving og feiling når det er mulig.",
    "howToSolveNonogramDescription": "Nonogrammer er logikkbaserte oppgaver der du fyller ut ruter på et rutenett ved hjelp av ledetråder for hver rad og kolonne. Disse ledetrådene er tall som forteller deg hvor mange fylte blokker som er i den linjen og i hvilken rekkefølge. For eksempel betyr en ledetråd på «4 1» at det er fire fylte ruter etterfulgt av én fylt rute, med minst ett tomrom mellom gruppene. Målet ditt er å finne ut hvor disse fylte blokkene skal være ved å bruke logisk resonnement og vurdere både de horisontale og vertikale ledetrådene sammen.",
    "howToSolveNonogramInstructions": "For å begynne å løse, se etter rader eller kolonner der ledetrådene tar opp en stor del av linjen, da disse vanligvis er enklest å fylle ut først. Etter hvert som du gjør fremskritt, bruk det du har lært til å oppdatere andre rader og kolonner. Felt som definitivt er tomme, bør merkes med en rød «X» for å unngå feil og tydeliggjøre de gjenværende alternativene. Gradvis, ved å fylle ut bekreftede ruter og merke av tomme, vil du jobbe deg mot et komplett og konsistent rutenett.",
    "darkMode": "Mørk modus",
    "lightMode": "Lysmodus",
    "todaysPuzzle": "Dagens puslespill",
    "playNow": "Spill nå",
    "contactMessages": "Meldinger",
    "dailyPuzzleArchive": "Daglig puslespillarkiv",
    "previous": "Tidligere",
    "next": "Neste",
    "noPuzzlesFound": "Ingen daglige gåter funnet for denne måneden.",
    "nonogram": "Nonogram",
    "sudoku": "Sudoku",
    "playNonogramDailyToday": "Spill Nonogram Daily i dag!",
    "playSudokuDailyToday": "Spill Sudoku Daily i dag!"
  },
  "nl": {
    "timeRecorded": "Uw tijd is geregistreerd!",
    "dailyNonogramFor": "Dagelijkse nonogram voor",
    "privacyPolicy": "Privacybeleid",
    "termsOfService": "Servicevoorwaarden",
    "account": "Account",
    "username": "Gebruikersnaam",
    "password": "Wachtwoord",
    "oldPassword": "Oud wachtwoord",
    "loading": "Bezig met laden",
    "login": "Log in",
    "noAccount": "Heb je geen account?",
    "createAccount": "Registreer hier",
    "required": "Verplicht",
    "loggedIn": "Je bent ingelogd!",
    "logout": "Uitloggen",
    "loggedOut": "Je bent nu uitgelogd",
    "returnToPuzzles": "Keer terug naar de puzzels",
    "changePassword": "Wachtwoord wijzigen",
    "settings": "instellingen",
    "settingsUpdated": "Instellingen bijgewerkt",
    "register": "Registreren",
    "forgotYourPassword": "Uw wachtwoord vergeten?",
    "resetPassword": "Stel je wachtwoord opnieuw in",
    "email": "E-mail",
    "confirmPassword": "Bevestig wachtwoord",
    "passwordUpdated": "Wachtwoord bijgewerkt",
    "passwordsMustMatch": "wachtwoorden moeten overeenkomen",
    "haveAnAccount": "Heb je al een account?",
    "ajaxError": "Er was een probleem. Probeer het later opnieuw",
    "language": "Taal",
    "size": "Grootte",
    "save": "Opslaan",
    "invalidEmail": "Geef een geldig e-mailadres op",
    "sendingEmail": "Email verzenden",
    "resetEmailSent": "Controleer uw e-mail voor de link om uw wachtwoord opnieuw in te stellen.",
    "ad": "Advertentie",
    "nonogramPuzzle": "Nonogram puzzel",
    "goodLuck": "Succes!",
    "errorFound": "Fouten gevonden",
    "correct": "Correct!!",
    "startOver": "Begin opnieuw",
    "showCorrect": "Toon juiste rijen/kolommen",
    "checkIt": "Controleer het",
    "newNonogram": "Nieuw nonogram",
    "topTimesFor": "Toptijden voor {size} x {size}",
    "noTimes": "Geen tijd om te laten zien",
    "user": "Gebruiker",
    "time": "Tijd",
    "puzzle": "Puzzel",
    "nonogramSizes": "Nonogram Maten",
    "contactMe": "Neem contact met mij op",
    "howToSolve": "Hoe op te lossen",
    "topTimes": "Toptijden",
    "languages": "talen",
    "yourName": "Uw naam",
    "yourEmail": "Jouw email",
    "message": "Bericht",
    "sendingMessage": "Bericht versturen",
    "sendMessage": "Bericht versturen",
    "sentMessage": "Bericht verzonden",
    "bulgarian": "Bulgarian",
    "czech": "Tsjechisch",
    "danish": "Deens",
    "german": "Duitse",
    "greek": "Grieks",
    "english": "Engels",
    "spanish": "Spaans",
    "estonian": "Estlands",
    "finnish": "Fins",
    "french": "Frans",
    "hebrew": "Hebreeuws",
    "croatian": "Kroatisch",
    "hungarian": "Hongaars",
    "italian": "Italiaans",
    "japanese": "Japans",
    "korean": "Koreaans",
    "norwegian": "Noors",
    "dutch": "Nederlands",
    "polish": "Pools",
    "portuguese": "Portugees",
    "romanian": "Roemeense",
    "russian": "Russisch",
    "slovak": "Slowaaks",
    "slovenian": "Sloveens",
    "serbian": "Servisch",
    "swedish": "Zweeds",
    "turkish": "Turks",
    "vietnamese": "Vietnamees",
    "chinese": "Chinese",
    "howToSolveNonogram": "Hoe een nonogram op te lossen",
    "objective": "Doelstelling",
    "nonoObjective": "Het doel van het spel is om het raster te vullen met zwarte vierkanten zodat de aantallen gevulde sequentiële vierkanten overeenkomen met de nummers bovenaan en links.",
    "controls": "controls",
    "nonoControlsLeft": "Klik met de linkermuisknop om een vierkant te markeren als aan (zwart) of onbekend (wit).",
    "nonoControlsRight": "Klik met de rechtermuisknop om een vierkant als uit (rood X) of onbekend (wit) te markeren.",
    "nonoControlsTouch": "Raak aan om een vierkant te fietsen zoals aan (zwart), uit (rood X) of onbekend (wit).",
    "nonoControlsDrag": "Slepen werkt voor alle drie hierboven.",
    "freecell": "Freecell",
    "metaDescription": "Nonogrammen online. Meer dan 500.000 puzzels in 29 talen.",
    "metaKeywords": "nonogram, nonograms, afbeelding, puzzel, griddlers, griddler, picross",
    "mobileApps": "Mobiele apps",
    "dailyArchive": "Archief",
    "day": "Dag",
    "fastestTime": "Snelste tijd",
    "name": "Naam",
    "created": "Gemaakt",
    "markAsRead": "Markeer als gelezen",
    "dontMissTodaysPuzzle": "Mis de puzzel van vandaag niet!",
    "playToday": "Speel vandaag",
    "dismiss": "Afwijzen",
    "neverShowAgain": "Nooit meer tonen",
    "tipsAndTricks": "Tips en trucs voor het oplossen van nonogrammen",
    "startWithTheObvious": "Begin met het voor de hand liggende",
    "focusOnRowsOrColumns": "Concentreer u op de rijen of kolommen waarvan de aanwijzingen bijna de hele regel vullen.",
    "useBothDirections": "Gebruik beide richtingen",
    "progressInOneDirection": "Vooruitgang in de ene richting helpt vaak de logica in de andere richting te ontsluiten.",
    "markYourEmptySpaces": "Markeer uw lege ruimtes",
    "useARedX": "Gebruik een rode \"X\" op bevestigde lege vakjes om georganiseerd te blijven.",
    "countCarefully": "Tel zorgvuldig",
    "separateNumbersMeanDifferentGroups": "Aparte getallen betekenen verschillende groepen met minstens één spatie ertussen.",
    "largeNumberClues": "Werk de randen af",
    "largeNumberCluesDescription": "Aanwijzingen met een groot aantal getallen kunnen mogelijk maar op een beperkt aantal manieren worden gebruikt. Gebruik dit in uw voordeel.",
    "stayOrganized": "Blijf georganiseerd",
    "stayOrganizedDescription": "Bekijk het rooster regelmatig; vooruitgang op één gebied kan aanwijzingen opleveren op andere gebieden.",
    "dontGuess": "Raad niet",
    "dontGuessDescription": "Houd je aan de logica en vermijd zoveel mogelijk trial-and-error.",
    "howToSolveNonogramDescription": "Nonogrammen zijn puzzels gebaseerd op logica waarbij je vakjes op een raster invult met behulp van aanwijzingen voor elke rij en kolom. Deze aanwijzingen zijn getallen die aangeven hoeveel gevulde blokjes er in die rij staan en in welke volgorde. Een aanwijzing als \"4 1\" betekent bijvoorbeeld dat er vier gevulde vakjes zijn, gevolgd door één gevuld vakje, met minstens één lege ruimte tussen de groepjes. Je doel is om erachter te komen waar die gevulde blokjes horen door logisch te redeneren en zowel de horizontale als de verticale aanwijzingen samen te beschouwen.",
    "howToSolveNonogramInstructions": "Om te beginnen met oplossen, zoek je naar rijen of kolommen waar de aanwijzingen een groot deel van de regel in beslag nemen, omdat die meestal het makkelijkst als eerste in te vullen zijn. Naarmate je vordert, gebruik je wat je hebt geleerd om andere rijen en kolommen bij te werken. Vlakken die absoluut leeg zijn, markeer je met een rode \"X\" om fouten te voorkomen en je resterende opties te verduidelijken. Door de bevestigde vakjes in te vullen en de lege vakjes af te vinken, werk je geleidelijk toe naar een compleet en consistent raster.",
    "darkMode": "Donkere modus",
    "lightMode": "Lichtmodus",
    "todaysPuzzle": "Puzzel van vandaag",
    "playNow": "Nu spelen",
    "contactMessages": "Berichten",
    "dailyPuzzleArchive": "Dagelijks puzzelarchief",
    "previous": "Vorig",
    "next": "Volgende",
    "noPuzzlesFound": "Er zijn geen dagelijkse puzzels gevonden voor deze maand.",
    "nonogram": "Nonogram",
    "sudoku": "Sudoku",
    "playNonogramDailyToday": "Speel vandaag nog mee met Nonogram Daily!",
    "playSudokuDailyToday": "Speel vandaag nog mee met Sudoku Daily!"
  },
  "pl": {
    "timeRecorded": "Twój czas został zarejestrowany!",
    "dailyNonogramFor": "Codzienny Nonogram dla",
    "privacyPolicy": "Polityka prywatności",
    "termsOfService": "Warunki korzystania z usługi",
    "account": "Konto",
    "username": "Nazwa Użytkownika",
    "password": "Hasło",
    "oldPassword": "Stare hasło",
    "loading": "Ładowanie",
    "login": "Zaloguj Się",
    "noAccount": "Nie masz konta?",
    "createAccount": "Rejestracja tutaj",
    "required": "wymagany",
    "loggedIn": "Jesteś zalogowany!",
    "logout": "Wyloguj",
    "loggedOut": "teraz jesteś wylogowany",
    "returnToPuzzles": "Wróć do zagadek",
    "changePassword": "Zmień hasło",
    "settings": "Ustawienia",
    "settingsUpdated": "Ustawienia zaktualizowane",
    "register": "Zarejestrować",
    "forgotYourPassword": "Zapomniałeś hasła?",
    "resetPassword": "Zresetuj swoje hasło",
    "email": "E-mail",
    "confirmPassword": "Potwierdź hasło",
    "passwordUpdated": "Hasło zaktualizowane",
    "passwordsMustMatch": "Hasło musi pasować",
    "haveAnAccount": "Posiadasz już konto?",
    "ajaxError": "Był problem. Spróbuj ponownie później",
    "language": "Język",
    "size": "Rozmiar",
    "save": "Zapisać",
    "invalidEmail": "Podaj prawidłowy adres e-mail",
    "sendingEmail": "Wysyłać email",
    "resetEmailSent": "Sprawdź swój adres e-mail pod kątem linku, aby zresetować hasło.",
    "ad": "Reklama",
    "nonogramPuzzle": "Puzzle Nonogram",
    "goodLuck": "Powodzenia!",
    "errorFound": "Znalezione błędy",
    "correct": "Poprawny!!",
    "startOver": "Zacząć od nowa",
    "showCorrect": "Pokaż prawidłowe wiersze/kolumny",
    "checkIt": "Sprawdź to",
    "newNonogram": "Nowy Nonogram",
    "topTimesFor": "Najpopularniejsze czasy za {size} x {size}",
    "noTimes": "Nie ma czasu na pokazanie",
    "user": "Użytkownik",
    "time": "Czas",
    "puzzle": "Puzzle",
    "nonogramSizes": "Rozmiary Nonogram",
    "contactMe": "Skontaktuj się ze mną",
    "howToSolve": "Jak rozwiązać",
    "topTimes": "Najwyższe czasy",
    "languages": "Języki",
    "yourName": "Twoje imię",
    "yourEmail": "Twój email",
    "message": "Wiadomość",
    "sendingMessage": "Wysyłanie wiadomości",
    "sendMessage": "Wyślij wiadomość",
    "sentMessage": "Wiadomość wysłana",
    "bulgarian": "bułgarski",
    "czech": "Czech",
    "danish": "duński",
    "german": "Niemiecki",
    "greek": "grecki",
    "english": "język angielski",
    "spanish": "hiszpański",
    "estonian": "estoński",
    "finnish": "fiński",
    "french": "Francuski",
    "hebrew": "hebrajski",
    "croatian": "chorwacki",
    "hungarian": "język węgierski",
    "italian": "Włoski",
    "japanese": "język japoński",
    "korean": "koreański",
    "norwegian": "norweski",
    "dutch": "holenderski",
    "polish": "Polskie",
    "portuguese": "portugalski",
    "romanian": "rumuński",
    "russian": "Rosyjski",
    "slovak": "słowacki",
    "slovenian": "słoweński",
    "serbian": "serbski",
    "swedish": "szwedzki",
    "turkish": "turecki",
    "vietnamese": "wietnamski",
    "chinese": "chiński",
    "howToSolveNonogram": "Jak rozwiązać Nonogram",
    "objective": "Cel",
    "nonoObjective": "Celem gry jest wypełnienie siatki czarnymi kwadratami, tak aby liczby wypełnionych kolejnych pól pasowały do liczb na górze i na lewo.",
    "controls": "Sterownica",
    "nonoControlsLeft": "Kliknij lewym przyciskiem, aby zaznaczyć kwadrat jako włączony (czarny) lub nieznany (biały).",
    "nonoControlsRight": "Kliknij prawym przyciskiem, aby zaznaczyć kwadrat jako wyłączony (czerwony X) lub nieznany (biały).",
    "nonoControlsTouch": "Dotknij, aby włączyć kwadrat, tak jak on (czarny), off (czerwony X) lub nieznany (biały).",
    "nonoControlsDrag": "Przeciąganie działa dla wszystkich trzech powyższych.",
    "freecell": "Wolna komórka",
    "metaDescription": "Nonogramy online. Ponad 500 000 zagadek w 29 językach.",
    "metaKeywords": "nonogram, nonogramy, obraz, puzzle, griddlers, griddler, picross",
    "mobileApps": "Aplikacje mobilne",
    "dailyArchive": "Archiwum",
    "day": "Dzień",
    "fastestTime": "Najszybszy czas",
    "name": "Nazwa",
    "created": "Stworzony",
    "markAsRead": "Oznacz jako przeczytane",
    "dontMissTodaysPuzzle": "Nie przegap dzisiejszej łamigłówki!",
    "playToday": "Zagraj dziś",
    "dismiss": "Odrzucać",
    "neverShowAgain": "Nigdy więcej się nie pokazuj",
    "tipsAndTricks": "Porady i triki dotyczące rozwiązywania nonogramów",
    "startWithTheObvious": "Zacznij od tego, co oczywiste",
    "focusOnRowsOrColumns": "Skoncentruj się na rzędach lub kolumnach, w których wskazówki wypełniają niemal całą linię.",
    "useBothDirections": "Użyj obu kierunków",
    "progressInOneDirection": "Postęp w jednym kierunku często pomaga odkryć logikę w drugim.",
    "markYourEmptySpaces": "Oznacz puste miejsca",
    "useARedX": "Zaznacz czerwonym znakiem „X” puste pola, aby zachować porządek.",
    "countCarefully": "Licz dokładnie",
    "separateNumbersMeanDifferentGroups": "Oddzielne numery oznaczają różne grupy, pomiędzy którymi jest co najmniej jedna spacja.",
    "largeNumberClues": "Obrób krawędzie",
    "largeNumberCluesDescription": "Duża liczba wskazówek może pasować tylko do ograniczonego zakresu zastosowań — wykorzystaj to na swoją korzyść.",
    "stayOrganized": "Zachowaj porządek",
    "stayOrganizedDescription": "Często przeglądaj siatkę; postęp w jednym obszarze może ujawnić wskazówki w innych.",
    "dontGuess": "Nie zgaduj",
    "dontGuessDescription": "Trzymaj się logiki — jeśli to możliwe, unikaj metody prób i błędów.",
    "howToSolveNonogramDescription": "Nonogramy to logiczne łamigłówki, w których wypełniasz kwadraty siatki, korzystając ze wskazówek podanych dla każdego wiersza i kolumny. Te wskazówki to liczby, które wskazują, ile wypełnionych bloków znajduje się w danym wierszu i w jakiej kolejności. Na przykład wskazówka „4 1” oznacza, że są cztery wypełnione kwadraty, a następnie jeden wypełniony kwadrat, z co najmniej jedną pustą przestrzenią między grupami. Twoim celem jest ustalenie, gdzie znajdują się te wypełnione bloki, stosując logiczne rozumowanie i uwzględniając zarówno wskazówki poziome, jak i pionowe.",
    "howToSolveNonogramInstructions": "Aby rozpocząć rozwiązywanie, poszukaj wierszy lub kolumn, w których wskazówki zajmują większą część linii, ponieważ zazwyczaj najłatwiej je wypełnić w pierwszej kolejności. W miarę postępów wykorzystuj zdobytą wiedzę do aktualizacji innych wierszy i kolumn. Miejsca, które są zdecydowanie puste, należy oznaczyć czerwonym „X”, aby uniknąć błędów i wyjaśnić pozostałe opcje. Stopniowo, wypełniając potwierdzone pola i zaznaczając puste, będziesz dążyć do ukończenia i uzyskania spójnej siatki.",
    "darkMode": "Tryb ciemny",
    "lightMode": "Tryb światła",
    "todaysPuzzle": "Dzisiejsza łamigłówka",
    "playNow": "Graj teraz",
    "contactMessages": "Wiadomości",
    "dailyPuzzleArchive": "Archiwum codziennych łamigłówek",
    "previous": "Poprzedni",
    "next": "Następny",
    "noPuzzlesFound": "Nie znaleziono żadnych codziennych łamigłówek na ten miesiąc.",
    "nonogram": "Nonogram",
    "sudoku": "Sudoku",
    "playNonogramDailyToday": "Zagraj w Nonogram Daily już dziś!",
    "playSudokuDailyToday": "Zagraj w Sudoku Daily już dziś!"
  },
  "pt": {
    "timeRecorded": "Seu tempo foi registrado!",
    "dailyNonogramFor": "Nonograma diário para",
    "privacyPolicy": "política de Privacidade",
    "termsOfService": "Termos de Serviço",
    "account": "Conta",
    "username": "Nome de usuário",
    "password": "Senha",
    "oldPassword": "Senha Antiga",
    "loading": "Carregando",
    "login": "Entrar",
    "noAccount": "Não tem uma conta?",
    "createAccount": "Registre-se aqui",
    "required": "Requeridos",
    "loggedIn": "Você está logado!",
    "logout": "Sair",
    "loggedOut": "você está desconectado agora",
    "returnToPuzzles": "Volte para os quebra-cabeças",
    "changePassword": "Mudar senha",
    "settings": "Definições",
    "settingsUpdated": "Configurações atualizadas",
    "register": "registo",
    "forgotYourPassword": "Esqueceu sua senha?",
    "resetPassword": "Redefinir sua senha",
    "email": "O email",
    "confirmPassword": "Confirme a Senha",
    "passwordUpdated": "Senha atualizada",
    "passwordsMustMatch": "As senhas devem corresponder",
    "haveAnAccount": "já tem uma conta?",
    "ajaxError": "Havia um problema. Tente mais tarde",
    "language": "Língua",
    "size": "Tamanho",
    "save": "Salve ",
    "invalidEmail": "Forneça um email válido",
    "sendingEmail": "Enviando email",
    "resetEmailSent": "Verifique seu email para o link para redefinir sua senha.",
    "ad": "Propaganda",
    "nonogramPuzzle": "Quebra-cabeça Nonogram",
    "goodLuck": "Boa sorte!",
    "errorFound": "Erros encontrados",
    "correct": "Corrigir!!",
    "startOver": "Recomeçar",
    "showCorrect": "Mostrar linhas/colunas corretas",
    "checkIt": "Verifique-o",
    "newNonogram": "Novo Nonogram",
    "topTimesFor": "Principais tempos para {size} x {size}",
    "noTimes": "Não há horários para mostrar",
    "user": "Do utilizador",
    "time": "Tempo",
    "puzzle": "Enigma",
    "nonogramSizes": "Tamanhos de Nonogram",
    "contactMe": "Contate-me",
    "howToSolve": "Como resolver",
    "topTimes": "Top Times",
    "languages": "línguas",
    "yourName": "Seu nome",
    "yourEmail": "Seu email",
    "message": "mensagem",
    "sendingMessage": "Enviando mensagem",
    "sendMessage": "Enviar mensagem",
    "sentMessage": "Mensagem enviada",
    "bulgarian": "búlgaro",
    "czech": "Checo",
    "danish": "dinamarquês",
    "german": "alemão",
    "greek": "grego",
    "english": "Inglês",
    "spanish": "espanhol",
    "estonian": "estoniano",
    "finnish": "finlandês",
    "french": "francês",
    "hebrew": "hebraico",
    "croatian": "croata",
    "hungarian": "húngaro",
    "italian": "italiano",
    "japanese": "japonês",
    "korean": "coreano",
    "norwegian": "norueguês",
    "dutch": "holandês",
    "polish": "polonês",
    "portuguese": "Português",
    "romanian": "romena",
    "russian": "russo",
    "slovak": "Eslovaco",
    "slovenian": "esloveno",
    "serbian": "sérvio",
    "swedish": "sueco",
    "turkish": "turco",
    "vietnamese": "vietnamita",
    "chinese": "chinês",
    "howToSolveNonogram": "Como resolver um nonogram",
    "objective": "Objetivo",
    "nonoObjective": "O objetivo do jogo é preencher a grade com quadrados pretos para que os números de quadrados sequenciais preenchidos correspondam aos números no topo e na esquerda.",
    "controls": "Controles",
    "nonoControlsLeft": "Clique com o botão esquerdo para marcar um quadrado como on (preto) ou desconhecido (branco).",
    "nonoControlsRight": "Clique com o botão direito para marcar um quadrado como off (vermelho X) ou desconhecido (branco).",
    "nonoControlsTouch": "Toque para percorrer um quadrado como ligado (preto), desligado (X vermelho) ou desconhecido (branco).",
    "nonoControlsDrag": "Arrastar trabalha para todos os três acima.",
    "freecell": "Célula livre",
    "metaDescription": "Nonogramas Online. Mais de 500.000 quebra-cabeças em 29 idiomas.",
    "metaKeywords": "nonogram, nonograms, quadro, quebra-cabeça, griddlers, griddler, picross",
    "mobileApps": "Aplicativos móveis",
    "dailyArchive": "Arquivo",
    "day": "Dia",
    "fastestTime": "Tempo mais rápido",
    "name": "Nome",
    "created": "Criado",
    "markAsRead": "Marcar como lido",
    "dontMissTodaysPuzzle": "Não perca o quebra-cabeça de hoje!",
    "playToday": "Jogue hoje",
    "dismiss": "Liberar",
    "neverShowAgain": "Nunca mais mostrar",
    "tipsAndTricks": "Dicas e truques para resolver nonogramas",
    "startWithTheObvious": "Comece com o óbvio",
    "focusOnRowsOrColumns": "Concentre-se nas linhas ou colunas onde as pistas preenchem quase toda a linha.",
    "useBothDirections": "Use ambas as direções",
    "progressInOneDirection": "O progresso em uma direção geralmente ajuda a desbloquear a lógica na outra.",
    "markYourEmptySpaces": "Marque seus espaços vazios",
    "useARedX": "Use um “X” vermelho nos quadrados vazios confirmados para se manter organizado.",
    "countCarefully": "Conte com cuidado",
    "separateNumbersMeanDifferentGroups": "Números separados significam grupos diferentes com pelo menos um espaço entre eles.",
    "largeNumberClues": "Trabalhe as bordas",
    "largeNumberCluesDescription": "Um grande número de pistas pode se encaixar apenas em algumas situações — use isso a seu favor.",
    "stayOrganized": "Mantenha-se organizado",
    "stayOrganizedDescription": "Examine a grade com frequência; o progresso em uma área pode revelar pistas em outras.",
    "dontGuess": "Não adivinhe",
    "dontGuessDescription": "Mantenha a lógica — evite tentativa e erro sempre que possível.",
    "howToSolveNonogramDescription": "Nonogramas são quebra-cabeças lógicos nos quais você preenche quadrados em uma grade usando dicas fornecidas para cada linha e coluna. Essas dicas são números que indicam quantos blocos preenchidos existem naquela linha e em que ordem. Por exemplo, uma dica \"4 1\" significa que há quatro quadrados preenchidos seguidos por um quadrado preenchido, com pelo menos um espaço em branco entre os grupos. Seu objetivo é descobrir onde esses blocos preenchidos se encaixam aplicando o raciocínio lógico e considerando as dicas horizontais e verticais em conjunto.",
    "howToSolveNonogramInstructions": "Para começar a resolver, procure linhas ou colunas onde as pistas ocupam uma grande parte da linha, pois geralmente são mais fáceis de preencher primeiro. À medida que você avança, use o que aprendeu para atualizar outras linhas e colunas. Os espaços que estão definitivamente vazios devem ser marcados com um \"X\" vermelho para ajudar a evitar erros e esclarecer suas opções restantes. Gradualmente, preenchendo os quadrados confirmados e marcando os vazios, você chegará a uma grade completa e consistente.",
    "darkMode": "Modo escuro",
    "lightMode": "Modo claro",
    "todaysPuzzle": "Quebra-cabeça de hoje",
    "playNow": "Jogue agora",
    "contactMessages": "Mensagens",
    "dailyPuzzleArchive": "Arquivo de quebra-cabeças diários",
    "previous": "Anterior",
    "next": "Próximo",
    "noPuzzlesFound": "Nenhum quebra-cabeça diário encontrado para este mês.",
    "nonogram": "Nonograma",
    "sudoku": "Sudoku",
    "playSudokuDailyToday": "Jogue o Sudoku Diário hoje mesmo!",
    "playNonogramDailyToday": "Jogue Nonogram Daily hoje mesmo!"
  },
  "ro": {
    "timeRecorded": "Timpul tău a fost înregistrat!",
    "dailyNonogramFor": "Nonogramă zilnică pentru",
    "privacyPolicy": "Politica de confidențialitate",
    "termsOfService": "Termeni și condiții",
    "account": "Cont",
    "username": "Nume de utilizator",
    "password": "Parola",
    "oldPassword": "Parola veche",
    "loading": "se incarca",
    "login": "Logare",
    "noAccount": "Nu aveți un cont?",
    "createAccount": "Înregistrează-te aici",
    "required": "Necesar",
    "loggedIn": "Ești logat!",
    "logout": "Deconectați-vă",
    "loggedOut": "Acum ești deconectat",
    "returnToPuzzles": "Întoarceți-vă la puzzle-uri",
    "changePassword": "Schimbați parola",
    "settings": "Setări",
    "settingsUpdated": "Setările aduse la zi",
    "register": "Inregistreaza-te",
    "forgotYourPassword": "Ti-ai uitat parola?",
    "resetPassword": "Reseteaza parola",
    "email": "E-mail",
    "confirmPassword": "Confirma parola",
    "passwordUpdated": "Parolă actualizată",
    "passwordsMustMatch": "Parolele trebuie să se potrtivească",
    "haveAnAccount": "ai deja un cont?",
    "ajaxError": "A fost o problemă. Încercați mai târziu",
    "language": "Limba",
    "size": "mărimea",
    "save": "Salvați",
    "invalidEmail": "Furnizați un e-mail valid",
    "sendingEmail": "Trimiterea e-mailului",
    "resetEmailSent": "Verificați adresa de e-mail a link-ului pentru resetarea parolei.",
    "ad": "Publicitate",
    "nonogramPuzzle": "Puzzle nonogram",
    "goodLuck": "Mult noroc!",
    "errorFound": "Erori gasite",
    "correct": "Corect!!",
    "startOver": "Începeți",
    "showCorrect": "Afișați rândurile/Col. corecte",
    "checkIt": "Verifică",
    "newNonogram": "Nou nonogram",
    "topTimesFor": "Top timp pentru {size} x {size}",
    "noTimes": "Nu are timp să se arate",
    "user": "Utilizator",
    "time": "Timp",
    "puzzle": "Puzzle",
    "nonogramSizes": "Dimensiuni nonogram",
    "contactMe": "Contacteaza-ma",
    "howToSolve": "Cum să rezolve",
    "topTimes": "Timpul maxim",
    "languages": "Limbile",
    "yourName": "Numele dumneavoastră",
    "yourEmail": "Email-ul tau",
    "message": "Mesaj",
    "sendingMessage": "Trimiterea unui mesaj",
    "sendMessage": "Trimite mesaj",
    "sentMessage": "Mesaj trimis",
    "bulgarian": "bulgară",
    "czech": "ceh",
    "danish": "danez",
    "german": "limba germana",
    "greek": "greacă",
    "english": "Engleză",
    "spanish": "Spaniolă",
    "estonian": "eston",
    "finnish": "finlandeză",
    "french": "limba franceza",
    "hebrew": "ebraică",
    "croatian": "croat",
    "hungarian": "maghiar",
    "italian": "Italiană",
    "japanese": "japonez",
    "korean": "coreeană",
    "norwegian": "norvegian",
    "dutch": "olandeză",
    "polish": "polonez",
    "portuguese": "portugheză",
    "romanian": "Română",
    "russian": "Rusă",
    "slovak": "slovacă",
    "slovenian": "sloven",
    "serbian": "sârb",
    "swedish": "suedez",
    "turkish": "turc",
    "vietnamese": "Vietnameză",
    "chinese": "chinez",
    "howToSolveNonogram": "Cum de a rezolva o nonogram",
    "objective": "Obiectiv",
    "nonoObjective": "Obiectul jocului este să umple grila cu pătrate negre, astfel încât numerele de pătrate pline succesive să se potrivească cu numerele de sus și de stânga.",
    "controls": "Controale",
    "nonoControlsLeft": "Clic pe stânga pentru a marca un pătrat ca pe (negru) sau necunoscut (alb).",
    "nonoControlsRight": "Faceți clic dreapta pentru a marca un pătrat ca oprit (roșu X) sau necunoscut (alb).",
    "nonoControlsTouch": "Atingeți pentru a marca un pătrat ca pe (negru), oprit (roșu X) sau necunoscut (alb).",
    "nonoControlsDrag": "Draggingul funcționează pentru toate cele trei de mai sus.",
    "freecell": "Freecell",
    "metaDescription": "Nongrame online. Peste 500.000 de puzzle-uri în 29 de limbi.",
    "metaKeywords": "nonogramă, nonograme, imagine, puzzle, ghicitori, picătoare, picros",
    "mobileApps": "Aplicații pentru mobil",
    "dailyArchive": "Arhivă",
    "day": "Zi",
    "fastestTime": "Cel mai rapid timp",
    "name": "Nume",
    "created": "Creat",
    "markAsRead": "Marchează ca citit",
    "dontMissTodaysPuzzle": "Nu ratați puzzle-ul de azi!",
    "playToday": "Joacă astăzi",
    "dismiss": "Închide",
    "neverShowAgain": "Nu mai afișa niciodată",
    "tipsAndTricks": "Sfaturi și trucuri pentru rezolvarea nonogramelor",
    "startWithTheObvious": "Începeți cu evidentul",
    "focusOnRowsOrColumns": "Concentrează-te pe rândurile sau coloanele unde indiciile umplu aproape întreaga linie.",
    "useBothDirections": "Folosește ambele direcții",
    "progressInOneDirection": "Progresul într-o direcție ajută adesea la deblocarea logicii în cealaltă.",
    "markYourEmptySpaces": "Marchează spațiile goale",
    "useARedX": "Folosește un „X” roșu pe pătratele goale confirmate pentru a rămâne organizat.",
    "countCarefully": "Numără cu atenție",
    "separateNumbersMeanDifferentGroups": "Numerele separate înseamnă grupuri diferite cu cel puțin un spațiu între ele.",
    "largeNumberClues": "Lucrează marginile",
    "largeNumberCluesDescription": "Un număr mare de indicii s-ar putea potrivi doar în moduri limitate - folosește acest lucru în avantajul tău.",
    "stayOrganized": "Rămâi organizat/ă",
    "stayOrganizedDescription": "Scanează grila des; progresul într-o zonă poate dezvălui indicii în altele.",
    "dontGuess": "Nu ghici",
    "dontGuessDescription": "Rămâi la logică — evită încercările și erorile pe cât posibil.",
    "howToSolveNonogramDescription": "Nonogramele sunt puzzle-uri bazate pe logică în care completezi pătrate pe o grilă folosind indicii furnizate pentru fiecare rând și coloană. Aceste indicii sunt numere care îți spun câte blocuri umplute sunt pe acea linie și în ce ordine. De exemplu, un indiciu „4 1” înseamnă că există patru pătrate umplute urmate de un pătrat umplut, cu cel puțin un spațiu gol între grupuri. Obiectivul tău este să descoperi unde se duc acele blocuri umplute aplicând raționamentul logic și luând în considerare împreună indiciile orizontale și verticale.",
    "howToSolveNonogramInstructions": "Pentru a începe rezolvarea, căutați rânduri sau coloane unde indiciile ocupă o mare parte a liniei, deoarece acestea sunt de obicei cel mai ușor de completat primele. Pe măsură ce progresați, folosiți ceea ce ați învățat pentru a actualiza alte rânduri și coloane. Spațiile care sunt cu siguranță goale ar trebui marcate cu un „X” roșu pentru a evita erorile și a clarifica opțiunile rămase. Treptat, prin completarea pătratelor confirmate și marcarea celor goale, veți ajunge la o grilă completă și consistentă.",
    "darkMode": "Mod întunecat",
    "lightMode": "Mod Luminos",
    "todaysPuzzle": "Puzzle-ul de astăzi",
    "playNow": "Joacă acum",
    "contactMessages": "Mesaje",
    "dailyPuzzleArchive": "Arhiva puzzle-urilor zilnice",
    "previous": "Anterior",
    "next": "Următorul",
    "noPuzzlesFound": "Nu s-au găsit puzzle-uri zilnice pentru această lună.",
    "nonogram": "Nonogramă",
    "sudoku": "Sudoku",
    "playNonogramDailyToday": "Joacă Nonogram Daily astăzi!",
    "playSudokuDailyToday": "Joacă Sudoku zilnic astăzi!"
  },
  "ru": {
    "timeRecorded": "Ваше время зафиксировано!",
    "dailyNonogramFor": "Ежедневная нонограмма для",
    "privacyPolicy": "политика конфиденциальности",
    "termsOfService": "Условия обслуживания",
    "account": "учетная запись",
    "username": "имя пользователя",
    "password": "пароль",
    "oldPassword": "Старый пароль",
    "loading": "загрузка",
    "login": "Авторизоваться",
    "noAccount": "У вас нет аккаунта?",
    "createAccount": "Зарегистрируйтесь здесь",
    "required": "необходимые",
    "loggedIn": "Вы вошли в систему!",
    "logout": "Выйти",
    "loggedOut": "Вы вышли из системы",
    "returnToPuzzles": "Вернуться к головоломкам",
    "changePassword": "Изменить пароль",
    "settings": "настройки",
    "settingsUpdated": "Настройки обновлены",
    "register": "регистр",
    "forgotYourPassword": "Забыли свой пароль?",
    "resetPassword": "Сбросить свой пароль",
    "email": "Эл. адрес",
    "confirmPassword": "Подтвердите Пароль",
    "passwordUpdated": "Пароль обновлен",
    "passwordsMustMatch": "Пароли должны совпадать",
    "haveAnAccount": "Уже есть аккаунт?",
    "ajaxError": "Была проблема. Попробуйте позже",
    "language": "язык",
    "size": "Размер",
    "save": "Сохранить",
    "invalidEmail": "Введите действительный адрес электронной почты",
    "sendingEmail": "Отправка электронной почты",
    "resetEmailSent": "Проверьте свою электронную почту, чтобы найти ссылку для сброса пароля.",
    "ad": "Реклама",
    "nonogramPuzzle": "Nonogram Puzzle",
    "goodLuck": "Удачи!",
    "errorFound": "Ошибки найдены",
    "correct": "Правильный!!",
    "startOver": "Начать сначала",
    "showCorrect": "Показать правильные строки/столбцы",
    "checkIt": "Проверь это",
    "newNonogram": "Новая нонограмма",
    "topTimesFor": "Лучшие времена для {размер} х {размер}",
    "noTimes": "Нет раз, чтобы показать",
    "user": "пользователь",
    "time": "Время",
    "puzzle": "Головоломка",
    "nonogramSizes": "Размеры нонограммы",
    "contactMe": "Свяжитесь со мной",
    "howToSolve": "Как решить",
    "topTimes": "Лучшие времена",
    "languages": "Языки",
    "yourName": "Ваше имя",
    "yourEmail": "Ваш адрес электронной почты",
    "message": "Сообщение",
    "sendingMessage": "Отправка сообщения",
    "sendMessage": "Отправить сообщение",
    "sentMessage": "Сообщение отправлено",
    "bulgarian": "болгарский",
    "czech": "чешский язык",
    "danish": "датский",
    "german": "Немецкий",
    "greek": "греческий",
    "english": "английский",
    "spanish": "испанский",
    "estonian": "эстонский",
    "finnish": "финский",
    "french": "Французский",
    "hebrew": "иврит",
    "croatian": "хорватский",
    "hungarian": "Венгерский",
    "italian": "итальянский",
    "japanese": "японский язык",
    "korean": "корейский язык",
    "norwegian": "норвежский язык",
    "dutch": "Голландский",
    "polish": "польский",
    "portuguese": "португальский",
    "romanian": "румынский",
    "russian": "русский",
    "slovak": "словацкий",
    "slovenian": "словенский",
    "serbian": "сербский",
    "swedish": "шведский",
    "turkish": "турецкий",
    "vietnamese": "вьетнамский",
    "chinese": "китайский язык",
    "howToSolveNonogram": "Как решить нонограмму",
    "objective": "Задача",
    "nonoObjective": "Цель игры состоит в том, чтобы заполнить сетку черными квадратами так, чтобы числа заполненных последовательных квадратов совпадали с числами сверху и слева.",
    "controls": "управления",
    "nonoControlsLeft": "Щелкните левой кнопкой мыши, чтобы отметить квадрат как (черный) или неизвестный (белый).",
    "nonoControlsRight": "Щелкните правой кнопкой мыши, чтобы пометить квадрат как выключенный (красный X) или неизвестный (белый).",
    "nonoControlsTouch": "Коснитесь, чтобы включить или выключить квадрат (черный), выключенный (красный X) или неизвестный (белый).",
    "nonoControlsDrag": "Перетаскивание работает для всех трех вышеперечисленных.",
    "freecell": "Свободная ячейка",
    "metaDescription": "Нонограммы онлайн. Более 500 000 головоломок на 29 языках.",
    "metaKeywords": "nonogram, nonograms, картинка, пазл, griddlers, griddler, picross",
    "mobileApps": "Мобильные приложения",
    "dailyArchive": "Архив",
    "day": "День",
    "fastestTime": "Лучшее время",
    "name": "Имя",
    "created": "Созданный",
    "markAsRead": "Отметить как прочитанное",
    "dontMissTodaysPuzzle": "Не пропустите сегодняшнюю головоломку!",
    "playToday": "Играть сегодня",
    "dismiss": "Увольнять",
    "neverShowAgain": "Никогда больше не показывай",
    "tipsAndTricks": "Советы и рекомендации по решению кроссвордов",
    "startWithTheObvious": "Начнем с очевидного",
    "focusOnRowsOrColumns": "Сосредоточьтесь на строках или столбцах, где подсказки заполняют почти всю строку.",
    "useBothDirections": "Используйте оба направления",
    "progressInOneDirection": "Прогресс в одном направлении часто помогает раскрыть логику в другом.",
    "markYourEmptySpaces": "Отметьте пустые места",
    "useARedX": "Для порядка отмечайте красным «X» подтверждённые пустые клетки.",
    "countCarefully": "Считайте внимательно",
    "separateNumbersMeanDifferentGroups": "Отдельные номера означают разные группы, между которыми имеется хотя бы один пробел.",
    "largeNumberClues": "Обработать края",
    "largeNumberCluesDescription": "Подсказки с большим количеством символов могут подойти лишь ограниченному числу способов — используйте это в своих интересах.",
    "stayOrganized": "Будьте организованы",
    "stayOrganizedDescription": "Чаще просматривайте сетку: прогресс в одной области может открыть подсказки в других.",
    "dontGuess": "Не угадай",
    "dontGuessDescription": "Придерживайтесь логики — по возможности избегайте метода проб и ошибок.",
    "howToSolveNonogramDescription": "Нонограммы — это логические головоломки, в которых нужно заполнять клетки сетки, используя подсказки для каждой строки и столбца. Эти подсказки представляют собой числа, указывающие количество заполненных блоков в строке и их порядок. Например, подсказка «4 1» означает, что за четырьмя заполненными клетками следует одна заполненная клетка, и между группами есть как минимум одно пустое место. Ваша цель — определить, куда поместить эти заполненные блоки, применяя логическое мышление и учитывая как горизонтальные, так и вертикальные подсказки.",
    "howToSolveNonogramInstructions": "Чтобы начать решать головоломку, найдите строки или столбцы, где подсказки занимают большую часть строки, так как их обычно проще всего заполнить в первую очередь. По мере продвижения используйте полученные знания для обновления других строк и столбцов. Заполненные ячейки следует отмечать красным крестиком «X», чтобы избежать ошибок и уточнить оставшиеся варианты. Постепенно, заполняя подтверждённые клетки и отмечая пустые, вы придёте к завершённой и последовательной сетке.",
    "darkMode": "Темный режим",
    "lightMode": "Световой режим",
    "todaysPuzzle": "Головоломка дня",
    "playNow": "Играть сейчас",
    "contactMessages": "Сообщения",
    "dailyPuzzleArchive": "Архив ежедневных головоломок",
    "previous": "Предыдущий",
    "next": "Следующий",
    "noPuzzlesFound": "Ежедневных головоломок в этом месяце не найдено.",
    "nonogram": "Нонограмма",
    "sudoku": "Судоку",
    "playNonogramDailyToday": "Играйте в Nonogram Daily уже сегодня!",
    "playSudokuDailyToday": "Играйте в судоку прямо сегодня!"
  },
  "sk": {
    "timeRecorded": "Váš čas bol zaznamenaný!",
    "dailyNonogramFor": "Denný nonogram pre",
    "privacyPolicy": "Zásady ochrany osobných údajov",
    "termsOfService": "Podmienky služby",
    "account": "účet",
    "username": "užívateľské meno",
    "password": "heslo",
    "oldPassword": "Staré heslo",
    "loading": "Načítava",
    "login": "Prihlásiť sa",
    "noAccount": "Nemáte účet?",
    "createAccount": "Registrujte sa tu",
    "required": "Požadovaný",
    "loggedIn": "Ste prihlásení!",
    "logout": "Odhlásiť sa",
    "loggedOut": "Teraz ste sa odhlásili",
    "returnToPuzzles": "Vráťte sa na hádanky",
    "changePassword": "Zmeniť heslo",
    "settings": "nastavenie",
    "settingsUpdated": "Nastavenia aktualizované",
    "register": "Registrovať",
    "forgotYourPassword": "Zabudol si heslo?",
    "resetPassword": "Obnoviť heslo",
    "email": "e-mail",
    "confirmPassword": "Potvrďte heslo",
    "passwordUpdated": "Aktualizované heslo",
    "passwordsMustMatch": "heslá sa musia zhodovať",
    "haveAnAccount": "Máte už účet?",
    "ajaxError": "Bol tu problém. Skúste znova neskôr",
    "language": "Jazyk",
    "size": "veľkosť",
    "save": "Uložiť",
    "invalidEmail": "Zadajte platný e-mail",
    "sendingEmail": "Odosielanie e-mailov",
    "resetEmailSent": "Skontrolujte svoj e-mail pre odkaz na obnovenie hesla.",
    "ad": "Reklama",
    "nonogramPuzzle": "Nonogram Puzzle",
    "goodLuck": "Veľa štastia!",
    "errorFound": "Nájdené chyby",
    "correct": "Správna !!",
    "startOver": "Začať odznova",
    "showCorrect": "Zobraziť správne riadky/stĺpce",
    "checkIt": "Skontrolujte to",
    "newNonogram": "Nový nonogram",
    "topTimesFor": "Najvyššie časy pre {size} x {size}",
    "noTimes": "Žiadny čas na zobrazenie",
    "user": "užívateľ",
    "time": "čas",
    "puzzle": "skladačka",
    "nonogramSizes": "Veľkosti nonogramu",
    "contactMe": "Kontaktujte ma",
    "howToSolve": "Ako riešiť",
    "topTimes": "Najvyššie časy",
    "languages": "jazyky",
    "yourName": "Tvoje meno",
    "yourEmail": "Tvoj email",
    "message": "správa",
    "sendingMessage": "Odosielanie správy",
    "sendMessage": "Poslať správu",
    "sentMessage": "Správa poslaná",
    "bulgarian": "bulharský",
    "czech": "český",
    "danish": "dánsky",
    "german": "Nemec",
    "greek": "grécky",
    "english": "Angličtina",
    "spanish": "španielsky",
    "estonian": "estónsky",
    "finnish": "fínsky",
    "french": "francúzsky",
    "hebrew": "hebrejčina",
    "croatian": "chorvátsky",
    "hungarian": "maďarský",
    "italian": "taliansky",
    "japanese": "japonský",
    "korean": "kórejský",
    "norwegian": "nórsky",
    "dutch": "holandský",
    "polish": "poľský",
    "portuguese": "portugalský",
    "romanian": "rumunský",
    "russian": "ruský",
    "slovak": "slovenský",
    "slovenian": "slovinčina",
    "serbian": "srbský",
    "swedish": "švédsky",
    "turkish": "turecký",
    "vietnamese": "vietnamský",
    "chinese": "čínsky",
    "howToSolveNonogram": "Ako vyriešiť nonogram",
    "objective": "objektívny",
    "nonoObjective": "Cieľom hry je vyplniť mriežku čiernymi štvorcami tak, aby čísla vyplnených sekvenčných štvorcov zodpovedali číslam v hornej a ľavej.",
    "controls": "riadenie",
    "nonoControlsLeft": "Kliknutím ľavým tlačidlom označte štvorec ako zapnutú (čiernu) alebo neznámu (bielu).",
    "nonoControlsRight": "Kliknutím pravým tlačidlom označte štvorec ako vypnutý (červený X) alebo neznámy (biely).",
    "nonoControlsTouch": "Dotknite sa, ak chcete štvorcový štítok zapnúť (čierny), vypnutý (červený X) alebo neznámy (biely).",
    "nonoControlsDrag": "Dragovanie funguje pre všetky tri vyššie uvedené.",
    "freecell": "Freecell",
    "metaDescription": "Nonograms Online. Viac ako 500 000 hádaniek v 29 jazykoch.",
    "metaKeywords": "nonogram, nonograms, picture, puzzle, griddlers, griddler, picross",
    "mobileApps": "Mobilné aplikácie",
    "dailyArchive": "Archív",
    "day": "Deň",
    "fastestTime": "Najrýchlejší čas",
    "name": "Meno",
    "created": "Vytvorené",
    "markAsRead": "Označiť ako prečítané",
    "dontMissTodaysPuzzle": "Nenechajte si ujsť dnešnú hádanku!",
    "playToday": "Hrajte ešte dnes",
    "dismiss": "Zavrieť",
    "neverShowAgain": "Už nikdy nezobrazovať",
    "tipsAndTricks": "Tipy a triky na riešenie nonogramov",
    "startWithTheObvious": "Začnite s tým zrejmým",
    "focusOnRowsOrColumns": "Zamerajte sa na riadky alebo stĺpce, kde indície takmer vypĺňajú celý riadok.",
    "useBothDirections": "Použite oba smery",
    "progressInOneDirection": "Pokrok v jednom smere často pomáha odomknúť logiku v druhom.",
    "markYourEmptySpaces": "Označte si prázdne miesta",
    "useARedX": "Pre udržanie poriadku použite červené „X“ na potvrdených prázdnych políčkach.",
    "countCarefully": "Počítajte starostlivo",
    "separateNumbersMeanDifferentGroups": "Samostatné čísla znamenajú rôzne skupiny s aspoň jednou medzerou medzi nimi.",
    "largeNumberClues": "Opracujte okraje",
    "largeNumberCluesDescription": "Veľký počet indícií sa môže hodiť len obmedzene – využite to vo svoj prospech.",
    "stayOrganized": "Zostaňte organizovaní",
    "stayOrganizedDescription": "Často prehľadávajte mriežku; pokrok v jednej oblasti môže odhaliť indície v iných.",
    "dontGuess": "Nehádaj",
    "dontGuessDescription": "Držte sa logiky – ak je to možné, vyhýbajte sa metóde pokus-omyl.",
    "howToSolveNonogramDescription": "Nonogramy sú logické hádanky, v ktorých vypĺňate štvorce na mriežke pomocou indícií pre každý riadok a stĺpec. Tieto indície sú čísla, ktoré vám hovoria, koľko vyplnených štvorcov je v danom riadku a v akom poradí. Napríklad indícia „4 1“ znamená, že sú štyri vyplnené štvorce, za ktorými nasleduje jeden vyplnený štvorec, s aspoň jedným prázdnym miestom medzi skupinami. Vaším cieľom je zistiť, kam tieto vyplnené štvorce patria, a to pomocou logického uvažovania a spoločného zohľadnenia horizontálnych aj vertikálnych indícií.",
    "howToSolveNonogramInstructions": "Ak chcete začať s riešením, hľadajte riadky alebo stĺpce, kde indície zaberajú veľkú časť riadku, pretože tie sa zvyčajne najľahšie vypĺňajú ako prvé. Ako budete postupovať, využite to, čo ste sa naučili, na aktualizáciu ďalších riadkov a stĺpcov. Medzery, ktoré sú určite prázdne, by mali byť označené červeným „X“, aby ste sa vyhli chybám a objasnili si zostávajúce možnosti. Postupne, vypĺňaním potvrdených štvorcov a odznačovaním prázdnych, sa budete prepracovávať k úplnej a konzistentnej mriežke.",
    "darkMode": "Tmavý režim",
    "lightMode": "Svetelný režim",
    "todaysPuzzle": "Dnešná hádanka",
    "playNow": "Hrať teraz",
    "contactMessages": "Správy",
    "dailyPuzzleArchive": "Denný archív hádaniek",
    "previous": "Predchádzajúce",
    "next": "Ďalej",
    "noPuzzlesFound": "Pre tento mesiac sa nenašli žiadne denné hádanky.",
    "nonogram": "Nonogram",
    "sudoku": "Sudoku",
    "playSudokuDailyToday": "Zahrajte si Sudoku Daily ešte dnes!",
    "playNonogramDailyToday": "Zahrajte si Nonogram Daily ešte dnes!"
  },
  "sl": {
    "timeRecorded": "Vaš čas je bil zabeležen!",
    "dailyNonogramFor": "Dnevni nonogram za",
    "privacyPolicy": "Pravilnik o zasebnosti",
    "termsOfService": "Pogoji storitve",
    "account": "račun",
    "username": "Uporabniško ime",
    "password": "Geslo",
    "oldPassword": "Staro geslo",
    "loading": "nalaganje",
    "login": "Vpiši se",
    "noAccount": "Nimate računa?",
    "createAccount": "Registrirajte se tukaj",
    "required": "Zahtevano",
    "loggedIn": "Prijavljeni ste!",
    "logout": "Izpisati",
    "loggedOut": "Zdaj ste odjavljeni",
    "returnToPuzzles": "Vrni se na uganke",
    "changePassword": "Spremeni geslo",
    "settings": "Nastavitve",
    "settingsUpdated": "Nastavitve posodobljene",
    "register": "Register",
    "forgotYourPassword": "Ste pozabili geslo?",
    "resetPassword": "Ponastavi geslo",
    "email": "E-naslov",
    "confirmPassword": "Potrdi geslo",
    "passwordUpdated": "Geslo posodobljeno",
    "passwordsMustMatch": "Geslo se mora ujemati",
    "haveAnAccount": "Že imate račun?",
    "ajaxError": "Prišlo je do težave. Poskusi znova kasneje",
    "language": "Jezik",
    "size": "Velikost",
    "save": "Shrani",
    "invalidEmail": "Vnesite veljaven e-poštni naslov",
    "sendingEmail": "Pošiljanje e-pošte",
    "resetEmailSent": "Preverite e-pošto za povezavo za ponastavitev gesla.",
    "ad": "Oglaševanje",
    "nonogramPuzzle": "Nonogram Puzzle",
    "goodLuck": "Vso srečo!",
    "errorFound": "Najdene napake",
    "correct": "Pravilno!",
    "startOver": "Začeti znova",
    "showCorrect": "Prikaži pravilne vrstice/stolpce",
    "checkIt": "Preveri",
    "newNonogram": "Novi Nonogram",
    "topTimesFor": "Najboljši časi za {size} x {size}",
    "noTimes": "Ni časa za prikaz",
    "user": "Uporabnik",
    "time": "Čas",
    "puzzle": "Puzzle",
    "nonogramSizes": "Velikosti Nonogramov",
    "contactMe": "Kontaktiraj me",
    "howToSolve": "Kako rešiti",
    "topTimes": "Top Times",
    "languages": "Jeziki",
    "yourName": "Tvoje ime",
    "yourEmail": "Vaš e-poštni naslov",
    "message": "Sporočilo",
    "sendingMessage": "Pošiljanje sporočila",
    "sendMessage": "Pošlji sporočilo",
    "sentMessage": "Sporočilo poslano",
    "bulgarian": "Bolgarščina",
    "czech": "Češčina",
    "danish": "Danščina",
    "german": "Nemščina",
    "greek": "Grščina",
    "english": "angleščina",
    "spanish": "španski",
    "estonian": "Estonščina",
    "finnish": "Finščina",
    "french": "Francosko",
    "hebrew": "Hebrejščina",
    "croatian": "Hrvaščina",
    "hungarian": "Madžarščina",
    "italian": "Italijanščina",
    "japanese": "Japonščina",
    "korean": "Korejščina",
    "norwegian": "Norveščina",
    "dutch": "Nizozemščina",
    "polish": "Poljščina",
    "portuguese": "Portugalščina",
    "romanian": "Romunščina",
    "russian": "Ruski",
    "slovak": "Slovaščina",
    "slovenian": "Slovenščina",
    "serbian": "Srbščina",
    "swedish": "Švedščina",
    "turkish": "Turščina",
    "vietnamese": "Vietnamski",
    "chinese": "Kitajski",
    "howToSolveNonogram": "Kako rešiti Nonogram",
    "objective": "Cilj",
    "nonoObjective": "Cilj igre je zapolniti mrežo s črnimi kvadrati, tako da se število zapolnjenih zaporednih kvadratov ujema s številkami na vrhu in levo.",
    "controls": "Kontrole",
    "nonoControlsLeft": "Z levim klikom označite kvadrat kot (črno) ali neznano (belo).",
    "nonoControlsRight": "Z desnim klikom označite kvadrat kot izklopljen (rdeč X) ali neznan (bel).",
    "nonoControlsTouch": "Dotaknite se, da označite kvadrat kot (črno), izklopljeno (rdeč X) ali neznano (belo).",
    "nonoControlsDrag": "Vlečenje deluje za vse tri zgoraj.",
    "freecell": "Freecell",
    "metaDescription": "Nonogrami na spletu. Več kot 500.000 ugank v 29 jezikih.",
    "metaKeywords": "nonogram, nonogrami, slika, sestavljanka, griddlers, griddler, picross",
    "mobileApps": "Mobilne aplikacije",
    "dailyArchive": "Arhiv",
    "day": "Dan",
    "fastestTime": "Najhitrejši čas",
    "name": "Ime",
    "created": "Ustvarjeno",
    "markAsRead": "Označi kot prebrano",
    "dontMissTodaysPuzzle": "Ne zamudite današnje uganke!",
    "playToday": "Igraj še danes",
    "dismiss": "Zavrzi",
    "neverShowAgain": "Nikoli več ne pokaži",
    "tipsAndTricks": "Nasveti in triki za reševanje nonogramov",
    "startWithTheObvious": "Začnite z očitnim",
    "focusOnRowsOrColumns": "Osredotočite se na vrstice ali stolpce, kjer namigi skoraj zapolnijo celotno vrstico.",
    "useBothDirections": "Uporabite obe smeri",
    "progressInOneDirection": "Napredek v eni smeri pogosto pomaga odkleniti logiko v drugi.",
    "markYourEmptySpaces": "Označi prazna mesta",
    "useARedX": "Za organizacijo uporabite rdeč \"X\" na potrjenih praznih kvadratkih.",
    "countCarefully": "Pazljivo štejte",
    "separateNumbersMeanDifferentGroups": "Ločene številke pomenijo različne skupine z vsaj enim presledkom med njimi.",
    "largeNumberClues": "Obdelajte robove",
    "largeNumberCluesDescription": "Veliko število namigov je morda primernih le v omejenem obsegu – to izkoristite v svojo korist.",
    "stayOrganized": "Ostanite organizirani",
    "stayOrganizedDescription": "Pogosto skenirajte mrežo; napredek na enem področju lahko razkrije namige na drugih.",
    "dontGuess": "Ne ugibaj",
    "dontGuessDescription": "Držite se logike – kadar koli je mogoče, se izogibajte poskusom in napakam.",
    "howToSolveNonogramDescription": "Nonogrami so logične uganke, kjer zapolnjujete kvadratke na mreži z namigi, ki so na voljo za vsako vrstico in stolpec. Ti namigi so številke, ki vam povedo, koliko zapolnjenih kvadratkov je v tej vrstici in v kakšnem vrstnem redu. Na primer, namig »4 1« pomeni, da so štirje zapolnjeni kvadratki, ki jim sledi en zapolnjen kvadrat, z vsaj enim praznim prostorom med skupinami. Vaš cilj je ugotoviti, kam gredo ti zapolnjeni kvadratki, tako da uporabite logično sklepanje in upoštevate tako horizontalne kot vertikalne namige skupaj.",
    "howToSolveNonogramInstructions": "Za začetek reševanja poiščite vrstice ali stolpce, kjer namigi zavzemajo velik del vrstice, saj jih je običajno najlažje najprej izpolniti. Ko napredujete, uporabite naučeno znanje za posodabljanje drugih vrstic in stolpcev. Prazna mesta označite z rdečim »X«, da se izognete napakam in razjasnite preostale možnosti. Postopoma se boste z izpolnjevanjem potrjenih kvadratkov in označevanjem praznih polj prebijali do popolne in dosledne mreže.",
    "darkMode": "Temni način",
    "lightMode": "Svetlobni način",
    "todaysPuzzle": "Današnja uganka",
    "playNow": "Igraj zdaj",
    "contactMessages": "Sporočila",
    "dailyPuzzleArchive": "Dnevni arhiv ugank",
    "previous": "Prejšnji",
    "next": "Naprej",
    "noPuzzlesFound": "Za ta mesec ni bilo najdenih dnevnih ugank.",
    "nonogram": "Nonogram",
    "sudoku": "Sudoku",
    "playNonogramDailyToday": "Igrajte Nonogram Daily še danes!",
    "playSudokuDailyToday": "Igrajte Sudoku Daily še danes!"
  },
  "sr": {
    "timeRecorded": "Ваше време је забележено!",
    "dailyNonogramFor": "Дневни нонограм за",
    "privacyPolicy": "Политика приватности",
    "termsOfService": "Услови коришћења услуге",
    "account": "Рачун",
    "username": "Корисничко име",
    "password": "Пассворд",
    "oldPassword": "Стара лозинка",
    "loading": "Учитавање",
    "login": "Пријавите се",
    "noAccount": "Немате налог?",
    "createAccount": "Региструјте овде",
    "required": "Потребан",
    "loggedIn": "Пријављени сте!",
    "logout": "Одјавити се",
    "loggedOut": "Сада сте одјављени",
    "returnToPuzzles": "Вратите се на загонетке",
    "changePassword": "Промени лозинку",
    "settings": "Подешавања",
    "settingsUpdated": "Подешавања су ажурирана",
    "register": "Регистровати",
    "forgotYourPassword": "Заборавили сте лозинку?",
    "resetPassword": "Ресетујте вашу лозинку",
    "email": "Емаил",
    "confirmPassword": "Потврди лозинку",
    "passwordUpdated": "Пассворд Упдатед",
    "passwordsMustMatch": "шифре морају да се подударају",
    "haveAnAccount": "Већ имате налог?",
    "ajaxError": "Настао је проблем. Покушајте поново касније",
    "language": "Језик",
    "size": "Величина",
    "save": "сачувати",
    "invalidEmail": "Наведите важећу е-пошту",
    "sendingEmail": "Слање е-поште",
    "resetEmailSent": "Проверите своју е-пошту за везу да бисте поново поставили лозинку.",
    "ad": "Реклама",
    "nonogramPuzzle": "Нонограм Пуззле",
    "goodLuck": "Срећно!",
    "errorFound": "Пронађене грешке",
    "correct": "Цоррецт !!",
    "startOver": "Почети испочетка",
    "showCorrect": "Прикажи исправне редове/колове",
    "checkIt": "Провери",
    "newNonogram": "Нев Нонограм",
    "topTimesFor": "Топ Тимес фор {сизе} к {сизе}",
    "noTimes": "Нема времена за показивање",
    "user": "Усер",
    "time": "време",
    "puzzle": "Пуззле",
    "nonogramSizes": "Нонограм Сизес",
    "contactMe": "Контактирај ме",
    "howToSolve": "Како решити",
    "topTimes": "Топ Тимес",
    "languages": "Лангуагес",
    "yourName": "Твоје име",
    "yourEmail": "Иоур Емаил",
    "message": "Порука",
    "sendingMessage": "Сендинг Мессаге",
    "sendMessage": "Пошаљи поруку",
    "sentMessage": "Порука послата",
    "bulgarian": "Булгариан",
    "czech": "Чешки",
    "danish": "Данисх",
    "german": "Немачки",
    "greek": "Греек",
    "english": "енглески језик",
    "spanish": "Шпански",
    "estonian": "Естонски",
    "finnish": "Фински",
    "french": "Француски",
    "hebrew": "Хебрев",
    "croatian": "Цроатиан",
    "hungarian": "Хунгариан",
    "italian": "Италијан",
    "japanese": "Јапанесе",
    "korean": "корејски",
    "norwegian": "Норвегиан",
    "dutch": "Дутцх",
    "polish": "Пољски",
    "portuguese": "Португалски",
    "romanian": "Румунски",
    "russian": "Руски",
    "slovak": "Словак",
    "slovenian": "Словеначки",
    "serbian": "Српски",
    "swedish": "Шведски",
    "turkish": "Туркисх",
    "vietnamese": "Вијетнамски",
    "chinese": "Цхинесе",
    "howToSolveNonogram": "Како ријешити Нонограм",
    "objective": "објективан",
    "nonoObjective": "Циљ игре је попунити мрежу црним квадратима тако да бројеви попуњених секвенцијалних квадрата одговарају бројевима на врху и лијево.",
    "controls": "Контроле",
    "nonoControlsLeft": "Левим кликом означите квадрат као он (црно) или непознато (бело).",
    "nonoControlsRight": "Десним кликом означите квадрат као искључен (црвени Кс) или непознати (бијели).",
    "nonoControlsTouch": "Додирните за кружење квадрата на (црно), искључено (црвено Кс) или непознато (бело).",
    "nonoControlsDrag": "Повлачење ради за сва три горе наведена.",
    "freecell": "Слободна ћелија",
    "metaDescription": "Нонограмс Онлине. Преко 500 000 загонетки на 29 језика.",
    "metaKeywords": "нонограм, нонограмс, слика, слагалица, гриддлерс, гриддлер, пицросс",
    "mobileApps": "Мобилне апликације",
    "dailyArchive": "Архива",
    "day": "Дан",
    "fastestTime": "Најбрже време",
    "name": "Име",
    "created": "Креирано",
    "markAsRead": "Означи као прочитано",
    "dontMissTodaysPuzzle": "Не пропустите данашњу слагалицу!",
    "playToday": "Играј данас",
    "dismiss": "Одбаци",
    "neverShowAgain": "Никад више не приказуј",
    "tipsAndTricks": "Савети и трикови за решавање нонограма",
    "startWithTheObvious": "Почните са очигледним",
    "focusOnRowsOrColumns": "Фокусирајте се на редове или колоне где трагови скоро испуњавају цео ред.",
    "useBothDirections": "Користите оба смера",
    "progressInOneDirection": "Напредак у једном смеру често помаже у откључавању логике у другом.",
    "markYourEmptySpaces": "Означите своја празна места",
    "useARedX": "Користите црвени „X“ на потврђеним празним квадратима да бисте остали организовани.",
    "countCarefully": "Пажљиво бројте",
    "separateNumbersMeanDifferentGroups": "Одвојени бројеви означавају различите групе са најмање једним размаком између њих.",
    "largeNumberClues": "Обрадите ивице",
    "largeNumberCluesDescription": "Велики број трагова може се користити само на ограничен начин – искористите то у своју корист.",
    "stayOrganized": "Останите организовани",
    "stayOrganizedDescription": "Често скенирајте мрежу; напредак у једној области може открити трагове у другима.",
    "dontGuess": "Не погађај",
    "dontGuessDescription": "Држите се логике - избегавајте покушаје и грешке кад год је то могуће.",
    "howToSolveNonogramDescription": "Нонограми су слагалице засноване на логици где попуњавате квадрате на мрежи користећи трагове дате за сваки ред и колону. Ови трагови су бројеви који вам говоре колико попуњених блокова има у том реду и којим редоследом. На пример, траг „4 1“ значи да постоје четири попуњена квадрата праћена једним попуњеним квадратом, са најмање једним празним простором између група. Ваш циљ је да схватите где ти попуњени блокови иду применом логичког размишљања и разматрањем и хоризонталних и вертикалних трагова заједно.",
    "howToSolveNonogramInstructions": "Да бисте почели са решавањем, потражите редове или колоне где трагови заузимају велики део линије, јер је њих обично најлакше прво попунити. Како напредујете, користите оно што сте научили да бисте ажурирали остале редове и колоне. Простори који су дефинитивно празни треба да буду означени црвеним „X“ како бисте избегли грешке и разјаснили преостале опције. Постепено, попуњавањем потврђених квадрата и обележавањем празних, радићете на томе да добијете комплетну и конзистентну мрежу.",
    "darkMode": "Тамни режим",
    "lightMode": "Светли режим",
    "todaysPuzzle": "Данашња слагалица",
    "playNow": "Играј сада",
    "contactMessages": "Поруке",
    "dailyPuzzleArchive": "Дневна архива слагалица",
    "previous": "Претходно",
    "next": "Следеће",
    "noPuzzlesFound": "Није пронађена ниједна дневна загонетка за овај месец.",
    "nonogram": "Нонограм",
    "sudoku": "Судоку",
    "playSudokuDailyToday": "Играјте Судоку Даили данас!",
    "playNonogramDailyToday": "Играјте Нонограм Дејли данас!"
  },
  "sv": {
    "timeRecorded": "Din tid har registrerats!",
    "dailyNonogramFor": "Dagligt nonogram för",
    "privacyPolicy": "Integritetspolicy",
    "termsOfService": "Användarvillkor",
    "account": "konto",
    "username": "Användarnamn",
    "password": "Lösenord",
    "oldPassword": "Gammalt lösenord",
    "loading": "Läser in",
    "login": "Logga in",
    "noAccount": "Har du inget konto?",
    "createAccount": "Registrera här",
    "required": "Nödvändig",
    "loggedIn": "Du är inloggad!",
    "logout": "Logga ut",
    "loggedOut": "Du är nu utloggad",
    "returnToPuzzles": "Återgå till pusselarna",
    "changePassword": "Ändra lösenord",
    "settings": "inställningar",
    "settingsUpdated": "Inställningar uppdaterade",
    "register": "Registrera",
    "forgotYourPassword": "Glömt ditt lösenord?",
    "resetPassword": "Återställ ditt lösenord",
    "email": "E-post",
    "confirmPassword": "Bekräfta lösenord",
    "passwordUpdated": "Lösenord uppdaterat",
    "passwordsMustMatch": "Lösenorden måste matcha",
    "haveAnAccount": "Har du redan ett konto?",
    "ajaxError": "Det var ett problem. Försök igen senare",
    "language": "Språk",
    "size": "Storlek",
    "save": "Spara",
    "invalidEmail": "Ange ett giltigt e-postmeddelande",
    "sendingEmail": "Skickar e-post",
    "resetEmailSent": "Kontrollera din email för länken för att återställa ditt lösenord.",
    "ad": "Annons",
    "nonogramPuzzle": "Nonogram pussel",
    "goodLuck": "Lycka till!",
    "errorFound": "Fel hittade",
    "correct": "Korrekt!!",
    "startOver": "Börja om",
    "showCorrect": "Visa korrekta rader/kolumner",
    "checkIt": "Kolla upp det",
    "newNonogram": "Nytt nonogram",
    "topTimesFor": "Topptider för {size} x {size}",
    "noTimes": "Inga gånger att visa",
    "user": "Användare",
    "time": "Tid",
    "puzzle": "Pussel",
    "nonogramSizes": "Nonogram storlekar",
    "contactMe": "Kontakta mig",
    "howToSolve": "Hur man löser",
    "topTimes": "Top Times",
    "languages": "språk",
    "yourName": "Ditt namn",
    "yourEmail": "Din email",
    "message": "Meddelande",
    "sendingMessage": "Skickar meddelande",
    "sendMessage": "Skicka meddelande",
    "sentMessage": "Meddelande skickat",
    "bulgarian": "bulgarisk",
    "czech": "tjeck",
    "danish": "danska",
    "german": "tysk",
    "greek": "grekisk",
    "english": "engelsk",
    "spanish": "spansk",
    "estonian": "estniska",
    "finnish": "finsk",
    "french": "franska",
    "hebrew": "hebreiska",
    "croatian": "Kroatisk",
    "hungarian": "ungerska",
    "italian": "italienska",
    "japanese": "japansk",
    "korean": "korean",
    "norwegian": "norrman",
    "dutch": "holländska",
    "polish": "putsa",
    "portuguese": "portugisiska",
    "romanian": "rumänska",
    "russian": "ryska",
    "slovak": "slovakiska",
    "slovenian": "slovenska",
    "serbian": "serb",
    "swedish": "svenska",
    "turkish": "turkiska",
    "vietnamese": "vietnames",
    "chinese": "kinesisk",
    "howToSolveNonogram": "Hur man löser ett nonogram",
    "objective": "Mål",
    "nonoObjective": "Syftet med spelet är att fylla rutnätet med svarta rutor så att antalet fyllda sekventiella rutor matchar siffrorna längst upp och vänster.",
    "controls": "kontroller",
    "nonoControlsLeft": "Vänster klicka för att markera en kvadrat som på (svart) eller okänt (vit).",
    "nonoControlsRight": "Högerklicka för att markera en kvadrat som av (röd X) eller okänd (vit).",
    "nonoControlsTouch": "Tryck på för att slå en kvadrat som på (svart), av (röd X) eller okänd (vit).",
    "nonoControlsDrag": "Draverk för alla tre ovanstående.",
    "freecell": "Freecell",
    "metaDescription": "Nonograms online. Över 500 000 pussel på 29 språk.",
    "metaKeywords": "nonogram, nonograms, bild, pussel, griddlers, griddler, picross",
    "mobileApps": "Mobilappar",
    "dailyArchive": "Arkiv",
    "day": "Dag",
    "fastestTime": "Snabbaste tid",
    "name": "Namn",
    "created": "Skapad",
    "markAsRead": "Markera som läst",
    "dontMissTodaysPuzzle": "Missa inte dagens pussel!",
    "playToday": "Spela idag",
    "dismiss": "Avfärda",
    "neverShowAgain": "Visa aldrig igen",
    "tipsAndTricks": "Tips och tricks för att lösa nonogram",
    "startWithTheObvious": "Börja med det uppenbara",
    "focusOnRowsOrColumns": "Fokusera på rader eller kolumner där ledtrådarna nästan fyller hela raden.",
    "useBothDirections": "Använd båda riktningarna",
    "progressInOneDirection": "Framsteg i en riktning hjälper ofta till att öppna upp logiken i den andra.",
    "markYourEmptySpaces": "Markera dina tomma utrymmen",
    "useARedX": "Använd ett rött \"X\" på bekräftade tomma rutor för att hålla dig organiserad.",
    "countCarefully": "Räkna noggrant",
    "separateNumbersMeanDifferentGroups": "Separata siffror betyder olika grupper med minst ett mellanslag mellan dem.",
    "largeNumberClues": "Bearbeta kanterna",
    "largeNumberCluesDescription": "Ledtrådar med ett stort antal kan bara passa in på begränsade sätt – använd detta till din fördel.",
    "stayOrganized": "Håll dig organiserad",
    "stayOrganizedDescription": "Skanna rutnätet ofta; framsteg inom ett område kan avslöja ledtrådar inom andra.",
    "dontGuess": "Gissa inte",
    "dontGuessDescription": "Håll dig till logiken – undvik trial and error när det är möjligt.",
    "howToSolveNonogramDescription": "Nonogram är logikbaserade pussel där du fyller i rutor i ett rutnät med hjälp av ledtrådar som ges för varje rad och kolumn. Dessa ledtrådar är siffror som talar om hur många fyllda block som finns i den raden och i vilken ordning. Till exempel betyder en ledtråd på \"4 1\" att det finns fyra fyllda rutor följt av en fylld ruta, med minst ett tomt mellanrum mellan grupperna. Ditt mål är att lista ut var de fyllda blocken ska vara genom att tillämpa logiskt resonemang och beakta både de horisontella och vertikala ledtrådarna tillsammans.",
    "howToSolveNonogramInstructions": "För att börja lösa, leta efter rader eller kolumner där ledtrådarna tar upp en stor del av raden, eftersom de oftast är lättast att fylla i först. Allt eftersom du gör framsteg, använd det du har lärt dig för att uppdatera andra rader och kolumner. Platser som definitivt är tomma bör markeras med ett rött \"X\" för att undvika fel och förtydliga dina återstående alternativ. Gradvis, genom att fylla i bekräftade rutor och markera tomma, kommer du att arbeta dig mot ett komplett och konsekvent rutnät.",
    "darkMode": "Mörkt läge",
    "lightMode": "Ljusläge",
    "todaysPuzzle": "Dagens pussel",
    "playNow": "Spela nu",
    "contactMessages": "Meddelanden",
    "dailyPuzzleArchive": "Dagligt pusselarkiv",
    "previous": "Tidigare",
    "next": "Nästa",
    "noPuzzlesFound": "Inga dagliga pussel hittades för denna månad.",
    "nonogram": "Nonogram",
    "sudoku": "Sudoku",
    "playSudokuDailyToday": "Spela Sudoku Daily idag!",
    "playNonogramDailyToday": "Spela Nonogram Daily idag!"
  },
  "tr": {
    "timeRecorded": "Zamanınız kaydedildi!",
    "dailyNonogramFor": "Günlük Nonogram",
    "privacyPolicy": "Gizlilik Politikası",
    "termsOfService": "Hizmet Şartları",
    "account": "hesap",
    "username": "Kullanıcı adı",
    "password": "Parola",
    "oldPassword": "eski Şifre",
    "loading": "Yükleniyor",
    "login": "Oturum aç",
    "noAccount": "Hesabınız yok mu?",
    "createAccount": "Buraya kayıt ol",
    "required": "gereklidir",
    "loggedIn": "Giriş yaptınız!",
    "logout": "Çıkış Yap",
    "loggedOut": "şimdi çıkış yaptın",
    "returnToPuzzles": "Bulmacalara dön",
    "changePassword": "Şifre değiştir",
    "settings": "Ayarlar",
    "settingsUpdated": "Ayarlar güncellendi",
    "register": "Kayıt olmak",
    "forgotYourPassword": "Parolanızı mı unuttunuz?",
    "resetPassword": "Şifrenizi sıfırlayın",
    "email": "E-posta",
    "confirmPassword": "Şifreyi Onayla",
    "passwordUpdated": "Şifre güncellendi",
    "passwordsMustMatch": "Parolalar eşleşmeli",
    "haveAnAccount": "Zaten hesabınız var mı?",
    "ajaxError": "Bir problem vardı. Daha sonra tekrar deneyin",
    "language": "Dil",
    "size": "Boyut",
    "save": "Kayıt etmek",
    "invalidEmail": "Geçerli bir e-posta sağlayın",
    "sendingEmail": "E-mail göndermek",
    "resetEmailSent": "Şifrenizi sıfırlamak için bağlantı için e-postanızı kontrol edin.",
    "ad": "reklâm",
    "nonogramPuzzle": "Nonogram Yapboz",
    "goodLuck": "İyi şanslar!",
    "errorFound": "Bulunan Hatalar",
    "correct": "Doğru!!",
    "startOver": "Baştan başlamak",
    "showCorrect": "Doğru Satırları/Sütunları Göster",
    "checkIt": "Kontrol et",
    "newNonogram": "Yeni Nonogram",
    "topTimesFor": "{Size} x {size} için en iyi zamanlar",
    "noTimes": "Gösterecek zaman yok",
    "user": "kullanıcı",
    "time": "zaman",
    "puzzle": "Bulmaca",
    "nonogramSizes": "Nonogram Boyutları",
    "contactMe": "Benimle irtibata geçin",
    "howToSolve": "Nasıl çözülür",
    "topTimes": "En İyi Zamanlar",
    "languages": "duujjil",
    "yourName": "Adınız",
    "yourEmail": "E-posta adresiniz",
    "message": "Mesaj",
    "sendingMessage": "Mesaj göndermek",
    "sendMessage": "Mesaj gönder",
    "sentMessage": "Mesajı gönderildi",
    "bulgarian": "Bulgar",
    "czech": "Çek",
    "danish": "Danimarkalı",
    "german": "Almanca",
    "greek": "Yunan",
    "english": "ingilizce",
    "spanish": "İspanyol",
    "estonian": "Estonyalı",
    "finnish": "Fince",
    "french": "Fransızca",
    "hebrew": "İbranice",
    "croatian": "Hırvat",
    "hungarian": "Macarca",
    "italian": "İtalyan",
    "japanese": "Japonca",
    "korean": "Koreli",
    "norwegian": "Norveççe",
    "dutch": "Flemenkçe",
    "polish": "Polonya",
    "portuguese": "Portekizce",
    "romanian": "Romen",
    "russian": "Rusça",
    "slovak": "Slovak",
    "slovenian": "Sloven",
    "serbian": "Sırpça",
    "swedish": "İsveççe",
    "turkish": "Türk",
    "vietnamese": "Vietnam",
    "chinese": "Çince",
    "howToSolveNonogram": "Nonogram Nasıl Çözülür?",
    "objective": "Amaç",
    "nonoObjective": "Oyunun amacı, ızgarayı siyah karelerle doldurmak, böylece doldurulmuş ardışık karelerin sayıları üst ve soldaki sayılarla eşleşiyor.",
    "controls": "Kontroller",
    "nonoControlsLeft": "Bir kareyi (siyah) veya bilinmeyen (beyaz) olarak işaretlemek için sol tıklayın.",
    "nonoControlsRight": "Bir kareyi kapalı (kırmızı X) veya bilinmeyen (beyaz) olarak işaretlemek için sağ tıklayın.",
    "nonoControlsTouch": "Bir kareyi açık (siyah), kapalı (kırmızı X) veya bilinmiyor (beyaz) olarak değiştirmek için dokunun.",
    "nonoControlsDrag": "Sürüklemek yukarıdakilerin üçünde de işe yarar.",
    "freecell": "Freecell",
    "metaDescription": "Nonogramlar Çevrimiçi. 29 dilde 500.000'den fazla bulmaca.",
    "metaKeywords": "nonogram, nonogram, resim, bulmaca, griddlers, griddler, picross",
    "mobileApps": "Mobil uygulamalar",
    "dailyArchive": "Arşiv",
    "day": "Gün",
    "fastestTime": "En Hızlı Zaman",
    "name": "İsim",
    "created": "Oluşturuldu",
    "markAsRead": "Okundu olarak işaretle",
    "dontMissTodaysPuzzle": "Bugünkü bulmacayı kaçırmayın!",
    "playToday": "Bugün Oyna",
    "dismiss": "Azletmek",
    "neverShowAgain": "Bir Daha Asla Gösterme",
    "tipsAndTricks": "Nonogramları Çözmek İçin İpuçları ve Püf Noktaları",
    "startWithTheObvious": "Bariz olanla başlayın",
    "focusOnRowsOrColumns": "İpuçlarının neredeyse tüm satırı doldurduğu satırlara veya sütunlara odaklanın.",
    "useBothDirections": "Her iki yönü de kullanın",
    "progressInOneDirection": "Bir yöndeki ilerleme çoğu zaman diğer yöndeki mantığın kilidini açmaya yardımcı olur.",
    "markYourEmptySpaces": "Boş alanlarınızı işaretleyin",
    "useARedX": "Düzenli kalmak için onaylanmış boş karelerin üzerine kırmızı \"X\" işareti koyun.",
    "countCarefully": "Dikkatlice sayın",
    "separateNumbersMeanDifferentGroups": "Ayrı sayılar, aralarında en az bir boşluk bulunan farklı grupları ifade eder.",
    "largeNumberClues": "Kenarları çalışın",
    "largeNumberCluesDescription": "Çok sayıda ipucu yalnızca sınırlı şekillerde işe yarayabilir; bunu kendi avantajınıza kullanın.",
    "stayOrganized": "Düzenli kalın",
    "stayOrganizedDescription": "Tabloyu sık sık tarayın; bir alandaki ilerleme diğerlerinde de ipuçları ortaya çıkarabilir.",
    "dontGuess": "Tahmin etme",
    "dontGuessDescription": "Mantığa bağlı kalın; mümkün olduğunca deneme yanılma yönteminden kaçının.",
    "howToSolveNonogramDescription": "Nonogramlar, her satır ve sütun için verilen ipuçlarını kullanarak bir ızgaradaki kareleri doldurduğunuz mantığa dayalı bulmacalardır. Bu ipuçları, o satırda kaç dolu blok olduğunu ve hangi sırayla olduğunu gösteren sayılardır. Örneğin, \"4 1\" ipucu, dört dolu kare ve ardından bir dolu kare olduğu ve gruplar arasında en az bir boşluk bulunduğu anlamına gelir. Amacınız, mantıksal akıl yürütmeyi uygulayarak ve hem yatay hem de dikey ipuçlarını birlikte değerlendirerek bu dolu blokların nereye gittiğini bulmaktır.",
    "howToSolveNonogramInstructions": "Çözmeye başlamak için, ipuçlarının satırın büyük bir kısmını kapladığı satır veya sütunları arayın, çünkü bunlar genellikle ilk önce doldurulması en kolay olanlardır. İlerledikçe, öğrendiklerinizi kullanarak diğer satır ve sütunları güncelleyin. Kesinlikle boş olan boşluklar, hatalardan kaçınmanıza ve kalan seçeneklerinizi netleştirmenize yardımcı olmak için kırmızı bir \"X\" ile işaretlenmelidir. Onaylanmış kareleri doldurup boş olanları işaretleyerek, kademeli olarak tamamlanmış ve tutarlı bir tabloya doğru ilerleyeceksiniz.",
    "darkMode": "Karanlık Mod",
    "lightMode": "Işık Modu",
    "todaysPuzzle": "Bugünün Bulmacası",
    "playNow": "Şimdi Oyna",
    "contactMessages": "Mesajlar",
    "dailyPuzzleArchive": "Günlük Bulmaca Arşivi",
    "previous": "Öncesi",
    "next": "Sonraki",
    "noPuzzlesFound": "Bu ay için günlük bulmaca bulunamadı.",
    "nonogram": "Nonogram",
    "sudoku": "Sudoku",
    "playSudokuDailyToday": "Bugün Sudoku Daily oyununu oynayın!",
    "playNonogramDailyToday": "Nonogram Daily oyununu bugün oynayın!"
  },
  "vi": {
    "timeRecorded": "Thời gian của bạn đã được ghi lại!",
    "dailyNonogramFor": "Nonogram hàng ngày cho",
    "privacyPolicy": "Chính sách bảo mật",
    "termsOfService": "Điều khoản dịch vụ",
    "account": "Tài khoản",
    "username": "Tên đăng nhập",
    "password": "Mật khẩu",
    "oldPassword": "Mật khẩu cũ",
    "loading": "Đang tải",
    "login": "Đăng nhập",
    "noAccount": "Không có tài khoản?",
    "createAccount": "Đăng ký ở đây",
    "required": "Cần thiết",
    "loggedIn": "Bạn đã đăng nhập!",
    "logout": "Đăng xuất",
    "loggedOut": "Bạn đã đăng xuất",
    "returnToPuzzles": "Quay trở lại câu đố",
    "changePassword": "Đổi mật khẩu",
    "settings": "Cài đặt",
    "settingsUpdated": "Cài đặt đã cập nhật",
    "register": "Ghi danh",
    "forgotYourPassword": "Quên mật khẩu?",
    "resetPassword": "Đặt lại mật khẩu của bạn",
    "email": "E-mail",
    "confirmPassword": "Xác nhận mật khẩu",
    "passwordUpdated": "Mật khẩu được cập nhật",
    "passwordsMustMatch": "mật khẩu phải trùng khớp",
    "haveAnAccount": "Bạn co săn san để tạo một tai khoản?",
    "ajaxError": "Có một vấn đề. Thử lại sau",
    "language": "Ngôn ngữ",
    "size": "Kích thước",
    "save": "Tiết kiệm",
    "invalidEmail": "Cung cấp một email hợp lệ",
    "sendingEmail": "Gửi email",
    "resetEmailSent": "Kiểm tra email của bạn để biết liên kết để thiết lập lại mật khẩu của bạn.",
    "ad": "Quảng cáo",
    "nonogramPuzzle": "Câu đố Nonogram",
    "goodLuck": "Chúc may mắn!",
    "errorFound": "Lỗi tìm kiếm",
    "correct": "Chính xác!!",
    "startOver": "Bắt đầu lại",
    "showCorrect": "Hiển thị hàng/Cols chính xác",
    "checkIt": "Kiểm tra nó",
    "newNonogram": "Nonogram mới",
    "topTimesFor": "Thời gian hàng đầu cho {size} x {size}",
    "noTimes": "Không có thời gian để hiển thị",
    "user": "Người dùng",
    "time": "Thời gian",
    "puzzle": "Câu đố",
    "nonogramSizes": "Kích thước phi hình",
    "contactMe": "Liên hệ với tôi",
    "howToSolve": "Giải quyết thế nào",
    "topTimes": "Thời báo hàng đầu",
    "languages": "Ngôn ngữ",
    "yourName": "Tên của bạn",
    "yourEmail": "Email của bạn",
    "message": "Thông điệp",
    "sendingMessage": "Gửi tin nhắn",
    "sendMessage": "Gửi tin nhắn",
    "sentMessage": "Tin nhắn đã gửi",
    "bulgarian": "Tiếng Bulgaria",
    "czech": "Séc",
    "danish": "người Đan Mạch",
    "german": "tiếng Đức",
    "greek": "người Hy Lạp",
    "english": "Anh",
    "spanish": "người Tây Ban Nha",
    "estonian": "Tiếng Estonia",
    "finnish": "Phần Lan",
    "french": "người Pháp",
    "hebrew": "Tiếng Do Thái",
    "croatian": "Tiếng Croatia",
    "hungarian": "Tiếng Hungary",
    "italian": "người Ý",
    "japanese": "tiếng Nhật",
    "korean": "Hàn Quốc",
    "norwegian": "Na Uy",
    "dutch": "Hà Lan",
    "polish": "đánh bóng",
    "portuguese": "Bồ Đào Nha",
    "romanian": "Rumani",
    "russian": "Tiếng nga",
    "slovak": "Tiếng Slovak",
    "slovenian": "Tiếng Slovenia",
    "serbian": "Tiếng Serbia",
    "swedish": "Thụy Điển",
    "turkish": "Thổ Nhĩ Kỳ",
    "vietnamese": "Tiếng Việt",
    "chinese": "Trung Quốc",
    "howToSolveNonogram": "Làm thế nào để giải quyết một Nonogram",
    "objective": "Mục tiêu",
    "nonoObjective": "Mục tiêu của trò chơi là lấp đầy lưới bằng các ô vuông màu đen sao cho số lượng các ô vuông liên tiếp được điền khớp với các số ở trên cùng và bên trái.",
    "controls": "Kiểm soát",
    "nonoControlsLeft": "Nhấp chuột trái để đánh dấu hình vuông như trên (đen) hoặc không xác định (trắng).",
    "nonoControlsRight": "Nhấp chuột phải để đánh dấu một hình vuông là tắt (X màu đỏ) hoặc không xác định (màu trắng).",
    "nonoControlsTouch": "Chạm để xoay vòng một hình vuông như trên (đen), tắt (đỏ X) hoặc không xác định (trắng).",
    "nonoControlsDrag": "Kéo hoạt động cho cả ba trong số trên.",
    "freecell": "Freecell",
    "metaDescription": "Nonograms trực tuyến. Hơn 500.000 câu đố trong 29 ngôn ngữ.",
    "metaKeywords": "nonogram, nonograms, hình ảnh, câu đố, griddlers, griddler, picross",
    "mobileApps": "Ứng dụng di động",
    "dailyArchive": "Lưu trữ",
    "day": "Ngày",
    "fastestTime": "Thời gian nhanh nhất",
    "name": "Tên",
    "created": "Tạo",
    "markAsRead": "Đánh dấu là đã đọc",
    "dontMissTodaysPuzzle": "Đừng bỏ lỡ câu đố hôm nay!",
    "playToday": "Chơi ngay hôm nay",
    "dismiss": "Miễn nhiệm",
    "neverShowAgain": "Không bao giờ hiển thị lại",
    "tipsAndTricks": "Mẹo và thủ thuật để giải Nonogram",
    "startWithTheObvious": "Bắt đầu với điều hiển nhiên",
    "focusOnRowsOrColumns": "Tập trung vào các hàng hoặc cột có các gợi ý gần như lấp đầy toàn bộ dòng.",
    "useBothDirections": "Sử dụng cả hai hướng",
    "progressInOneDirection": "Tiến triển theo một hướng thường giúp mở khóa logic theo hướng khác.",
    "markYourEmptySpaces": "Đánh dấu những khoảng trống của bạn",
    "useARedX": "Sử dụng dấu “X” màu đỏ trên các ô trống đã xác nhận để sắp xếp mọi thứ ngăn nắp.",
    "countCarefully": "Đếm cẩn thận",
    "separateNumbersMeanDifferentGroups": "Các số riêng biệt có nghĩa là các nhóm khác nhau với ít nhất một khoảng cách giữa chúng.",
    "largeNumberClues": "Làm việc các cạnh",
    "largeNumberCluesDescription": "Những manh mối có số lượng lớn chỉ có thể phù hợp theo một số cách hạn chế—hãy tận dụng điều này để có lợi cho bạn.",
    "stayOrganized": "Hãy giữ mọi thứ ngăn nắp",
    "stayOrganizedDescription": "Thường xuyên quét lưới; tiến triển ở một khu vực có thể hé lộ manh mối ở những khu vực khác.",
    "dontGuess": "Đừng đoán",
    "dontGuessDescription": "Tuân thủ logic—tránh thử nghiệm và sai sót nếu có thể.",
    "howToSolveNonogramDescription": "Nonogram là trò chơi giải đố logic, trong đó bạn điền vào các ô vuông trên lưới bằng cách sử dụng gợi ý cho mỗi hàng và cột. Gợi ý này là những con số cho biết có bao nhiêu ô vuông đã được tô màu trên hàng đó và theo thứ tự nào. Ví dụ, gợi ý \"4 1\" nghĩa là có bốn ô vuông đã được tô màu, tiếp theo là một ô vuông đã được tô màu, với ít nhất một khoảng trống giữa các nhóm. Mục tiêu của bạn là tìm ra vị trí của các ô vuông đã được tô màu bằng cách áp dụng suy luận logic và xem xét cả gợi ý theo chiều ngang và chiều dọc cùng lúc.",
    "howToSolveNonogramInstructions": "Để bắt đầu giải, hãy tìm những hàng hoặc cột mà gợi ý chiếm phần lớn trên dòng, vì những hàng hoặc cột này thường dễ điền nhất trước. Khi bạn tiến bộ, hãy vận dụng những kiến thức đã học để cập nhật các hàng và cột khác. Những ô chắc chắn còn trống nên được đánh dấu \"X\" màu đỏ để tránh sai sót và làm rõ các lựa chọn còn lại. Dần dần, bằng cách điền vào các ô đã xác nhận và đánh dấu những ô trống, bạn sẽ dần dần tạo ra một lưới ô hoàn chỉnh và nhất quán.",
    "darkMode": "Chế độ tối",
    "lightMode": "Chế độ sáng",
    "todaysPuzzle": "Câu đố hôm nay",
    "playNow": "Chơi ngay",
    "contactMessages": "Tin nhắn",
    "dailyPuzzleArchive": "Kho lưu trữ câu đố hàng ngày",
    "previous": "Trước",
    "next": "Kế tiếp",
    "noPuzzlesFound": "Không tìm thấy câu đố hàng ngày nào trong tháng này.",
    "nonogram": "Nonogram",
    "sudoku": "Sudoku",
    "playSudokuDailyToday": "Hãy chơi Sudoku hàng ngày ngay hôm nay!",
    "playNonogramDailyToday": "Hãy chơi Nonogram Daily ngay hôm nay!"
  },
  "zh": {
    "timeRecorded": "您的时间已记录！",
    "dailyNonogramFor": "每日数独",
    "privacyPolicy": "隐私政策",
    "termsOfService": "服务条款",
    "account": "帐户",
    "username": "用户名",
    "password": "密码",
    "oldPassword": "旧密码",
    "loading": "载入中",
    "login": "登录",
    "noAccount": "没有账号？",
    "createAccount": "在这里注册",
    "required": "需要",
    "loggedIn": "你登录了！",
    "logout": "登出",
    "loggedOut": "您现在已退出",
    "returnToPuzzles": "回到谜题",
    "changePassword": "更改密码",
    "settings": "设置",
    "settingsUpdated": "设置更新",
    "register": "寄存器",
    "forgotYourPassword": "忘记密码了吗？",
    "resetPassword": "重置你的密码",
    "email": "电子邮件",
    "confirmPassword": "确认密码",
    "passwordUpdated": "密码已更新",
    "passwordsMustMatch": "密码必须匹配",
    "haveAnAccount": "已经有账号？",
    "ajaxError": "有一个问题。稍后再试",
    "language": "语言",
    "size": "尺寸",
    "save": "保存",
    "invalidEmail": "提供有效的电子邮件",
    "sendingEmail": "发送电子邮件",
    "resetEmailSent": "查看您的电子邮件，找到重置密码的链接。",
    "ad": "广告",
    "nonogramPuzzle": "非图形拼图",
    "goodLuck": "祝好运！",
    "errorFound": "发现错误",
    "correct": "正确！！",
    "startOver": "重来",
    "showCorrect": "显示正确的行/列",
    "checkIt": "核实",
    "newNonogram": "新的Nonogram",
    "topTimesFor": "{size} x {size}的热门时间",
    "noTimes": "没时间表现出来",
    "user": "用户",
    "time": "时间",
    "puzzle": "难题",
    "nonogramSizes": "非图形尺寸",
    "contactMe": "联络我",
    "howToSolve": "怎么解决",
    "topTimes": "热门时报",
    "languages": "语言",
    "yourName": "你的名字",
    "yourEmail": "你的邮件",
    "message": "信息",
    "sendingMessage": "发送消息",
    "sendMessage": "发信息",
    "sentMessage": "消息已发送",
    "bulgarian": "保加利亚语",
    "czech": "捷克",
    "danish": "丹麦",
    "german": "德语",
    "greek": "希腊语",
    "english": "英语",
    "spanish": "西班牙语",
    "estonian": "爱沙尼亚语",
    "finnish": "芬兰",
    "french": "法国",
    "hebrew": "希伯来语",
    "croatian": "克罗地亚",
    "hungarian": "匈牙利",
    "italian": "意大利",
    "japanese": "日本",
    "korean": "朝鲜的",
    "norwegian": "挪威",
    "dutch": "荷兰人",
    "polish": "抛光",
    "portuguese": "葡萄牙语",
    "romanian": "罗马尼亚",
    "russian": "俄语",
    "slovak": "斯洛伐克",
    "slovenian": "斯洛文尼亚",
    "serbian": "塞尔维亚",
    "swedish": "瑞典",
    "turkish": "土耳其",
    "vietnamese": "越南",
    "chinese": "中文",
    "howToSolveNonogram": "如何解决Nonogram",
    "objective": "目的",
    "nonoObjective": "游戏的目的是用黑色方块填充网格，以便填充的连续方块的数量与顶部和左侧的数字相匹配。",
    "controls": "控制",
    "nonoControlsLeft": "左键单击以将方块标记为（黑色）或未知（白色）。",
    "nonoControlsRight": "右键单击将方块标记为关闭（红色X）或未知（白色）。",
    "nonoControlsTouch": "触摸可将方块循环为（黑色），关闭（红色X）或未知（白色）。",
    "nonoControlsDrag": "拖动适用于上述所有三个。",
    "freecell": "接龙",
    "metaDescription": "Nonograms在线。 29种语言的超过500,000个谜题。",
    "metaKeywords": "非图，非图，图片，拼图，平板电脑，格斗，picross",
    "mobileApps": "移动应用程序",
    "dailyArchive": "档案",
    "day": "天",
    "fastestTime": "最快时间",
    "name": "姓名",
    "created": "创建",
    "markAsRead": "标记为已读",
    "dontMissTodaysPuzzle": "不要错过今天的谜题！",
    "playToday": "今天玩",
    "dismiss": "解雇",
    "neverShowAgain": "不再显示",
    "tipsAndTricks": "解答数图的技巧和窍门",
    "startWithTheObvious": "从显而易见的事情开始",
    "focusOnRowsOrColumns": "重点关注线索几乎填满整行的行或列。",
    "useBothDirections": "使用两个方向",
    "progressInOneDirection": "一个方向上的进步往往有助于解开另一个方向上的逻辑。",
    "markYourEmptySpaces": "标记空白处",
    "useARedX": "在已确认的空白方块上使用红色“X”以保持井然有序。",
    "countCarefully": "仔细数数",
    "separateNumbersMeanDifferentGroups": "单独的数字表示不同的组，它们之间至少有一个空格。",
    "largeNumberClues": "处理边缘",
    "largeNumberCluesDescription": "大量线索可能只适合有限的方式——利用这一点对你有利。",
    "stayOrganized": "保持井然有序",
    "stayOrganizedDescription": "经常扫描网格；一个区域的进展可能会揭示其他区域的线索。",
    "dontGuess": "不要猜测",
    "dontGuessDescription": "坚持逻辑——尽可能避免反复试验。",
    "howToSolveNonogramDescription": "数图游戏是基于逻辑的谜题，玩家需要根据每行和每列提供的线索，在网格中填充方格。这些线索是数字，告诉你该行有多少个已填充的方块以及填充顺序。例如，线索“4 1”表示有四个已填充的方块，后面跟着一个已填充的方块，且每组之间至少有一个空格。你的目标是运用逻辑推理，并结合水平和垂直线索，找出这些已填充方块的位置。",
    "howToSolveNonogramInstructions": "开始解题时，先找到线索占据大部分行或列的位置，因为这些位置通常最容易填入。随着解题进度，运用所学知识更新其他行和列。确定为空的位置应标上红色“X”，以避免错误并明确剩余选项。逐步填写已确认的方格并标记空格，你将逐步获得完整且一致的网格。",
    "darkMode": "黑暗模式",
    "lightMode": "灯光模式",
    "todaysPuzzle": "今日谜题",
    "playNow": "立即玩",
    "contactMessages": "消息",
    "dailyPuzzleArchive": "每日谜题存档",
    "previous": "以前的",
    "next": "下一个",
    "noPuzzlesFound": "未找到本月的每日谜题。",
    "nonogram": "数图",
    "sudoku": "数独",
    "playNonogramDailyToday": "今天就来玩 Nonogram Daily 吧！",
    "playSudokuDailyToday": "今天就来玩数独每日版吧！"
  }
};

export default localeData;
